import { Path, Svg, Defs, G, Rect, ClipPath, Use } from "react-native-svg";

export const GeneralIcon = ({ color }) => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M12.25 11.25C11.1289 11.25 10.5898 11.875 8.75 11.875C6.91016 11.875 6.375 11.25 5.25 11.25C2.35156 11.25 0 13.6016 0 16.5V18.125C0 19.1602 0.839844 20 1.875 20H15.625C16.6602 20 17.5 19.1602 17.5 18.125V16.5C17.5 13.6016 15.1484 11.25 12.25 11.25ZM16.25 18.125C16.25 18.4688 15.9688 18.75 15.625 18.75H1.875C1.53125 18.75 1.25 18.4688 1.25 18.125V16.5C1.25 14.293 3.04297 12.5 5.25 12.5C6.01562 12.5 6.77734 13.125 8.75 13.125C10.7188 13.125 11.4844 12.5 12.25 12.5C14.457 12.5 16.25 14.293 16.25 16.5V18.125ZM8.75 10C11.5117 10 13.75 7.76172 13.75 5C13.75 2.23828 11.5117 0 8.75 0C5.98828 0 3.75 2.23828 3.75 5C3.75 7.76172 5.98828 10 8.75 10ZM8.75 1.25C10.8164 1.25 12.5 2.93359 12.5 5C12.5 7.06641 10.8164 8.75 8.75 8.75C6.68359 8.75 5 7.06641 5 5C5 2.93359 6.68359 1.25 8.75 1.25Z"
        fill={color || "#1B4965"}
      />
    </Svg>
  );
};
export const PasswordIcon = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M8.75 16.4063C8.32031 16.4063 7.96875 16.0547 7.96875 15.625V13.125C7.96875 12.6954 8.32031 12.3438 8.75 12.3438C9.17969 12.3438 9.53125 12.6954 9.53125 13.125V15.625C9.53125 16.0547 9.17969 16.4063 8.75 16.4063ZM17.5 10.625V18.125C17.5 19.1602 16.6602 20 15.625 20H1.875C0.839844 20 0 19.1602 0 18.125V10.625C0 9.58989 0.839844 8.75004 1.875 8.75004H2.5V6.25004C2.5 2.79691 5.3125 -0.0116822 8.76953 3.65392e-05C12.2227 0.0117553 15 2.85551 15 6.30863V8.75004H15.625C16.6602 8.75004 17.5 9.58989 17.5 10.625ZM3.75 8.75004H13.75V6.25004C13.75 3.49223 11.5078 1.25004 8.75 1.25004C5.99219 1.25004 3.75 3.49223 3.75 6.25004V8.75004ZM16.25 18.125V10.625C16.25 10.2813 15.9688 10 15.625 10H1.875C1.53125 10 1.25 10.2813 1.25 10.625V18.125C1.25 18.4688 1.53125 18.75 1.875 18.75H15.625C15.9688 18.75 16.25 18.4688 16.25 18.125Z"
        fill="#1B4965"
      />
    </Svg>
  );
};

export const EmailIcon = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M18 0.59375H2C0.9 0.59375 0.00999999 1.49375 0.00999999 2.59375L0 14.5938C0 15.6938 0.9 16.5938 2 16.5938H18C19.1 16.5938 20 15.6938 20 14.5938V2.59375C20 1.49375 19.1 0.59375 18 0.59375ZM17.6 4.84375L10.53 9.26375C10.21 9.46375 9.79 9.46375 9.47 9.26375L2.4 4.84375C2.15 4.68375 2 4.41375 2 4.12375C2 3.45375 2.73 3.05375 3.3 3.40375L10 7.59375L16.7 3.40375C17.27 3.05375 18 3.45375 18 4.12375C18 4.41375 17.85 4.68375 17.6 4.84375Z"
        fill="#1B4965"
      />
    </Svg>
  );
};

export const PhoneIcon = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M16.23 12.8538L13.69 12.5638C13.08 12.4938 12.48 12.7038 12.05 13.1338L10.21 14.9738C7.38 13.5338 5.06 11.2238 3.62 8.38376L5.47 6.53376C5.9 6.10376 6.11 5.50376 6.04 4.89376L5.75 2.37376C5.63 1.36376 4.78 0.60376 3.76 0.60376H2.03C0.900003 0.60376 -0.0399975 1.54376 0.0300025 2.67376C0.560003 11.2138 7.39 18.0338 15.92 18.5638C17.05 18.6338 17.99 17.6938 17.99 16.5638V14.8338C18 13.8238 17.24 12.9738 16.23 12.8538Z"
        fill="#1B4965"
      />
    </Svg>
  );
};

export const AccountIcon = () => {
  return (
    <Svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M20.25 0.25H2.75C1.37109 0.25 0.25 1.37109 0.25 2.75V15.25C0.25 16.6289 1.37109 17.75 2.75 17.75H20.25C21.6289 17.75 22.75 16.6289 22.75 15.25V2.75C22.75 1.37109 21.6289 0.25 20.25 0.25ZM21.5 15.25C21.5 15.9375 20.9375 16.5 20.25 16.5H2.75C2.0625 16.5 1.5 15.9375 1.5 15.25V2.75C1.5 2.0625 2.0625 1.5 2.75 1.5H20.25C20.9375 1.5 21.5 2.0625 21.5 2.75V15.25ZM18.6875 10.25H14.3125C14.1406 10.25 14 10.3906 14 10.5625V11.1875C14 11.3594 14.1406 11.5 14.3125 11.5H18.6875C18.8594 11.5 19 11.3594 19 11.1875V10.5625C19 10.3906 18.8594 10.25 18.6875 10.25ZM18.6875 7.75H14.3125C14.1406 7.75 14 7.89062 14 8.0625V8.6875C14 8.85938 14.1406 9 14.3125 9H18.6875C18.8594 9 19 8.85938 19 8.6875V8.0625C19 7.89062 18.8594 7.75 18.6875 7.75ZM18.6875 5.25H14.3125C14.1406 5.25 14 5.39062 14 5.5625V6.1875C14 6.35938 14.1406 6.5 14.3125 6.5H18.6875C18.8594 6.5 19 6.35938 19 6.1875V5.5625C19 5.39062 18.8594 5.25 18.6875 5.25ZM8.375 10.25C10.1016 10.25 11.5 8.85156 11.5 7.125C11.5 5.39844 10.1016 4 8.375 4C6.64844 4 5.25 5.39844 5.25 7.125C5.25 8.85156 6.64844 10.25 8.375 10.25ZM8.375 5.25C9.41016 5.25 10.25 6.08984 10.25 7.125C10.25 8.16016 9.41016 9 8.375 9C7.33984 9 6.5 8.16016 6.5 7.125C6.5 6.08984 7.33984 5.25 8.375 5.25ZM10.2031 10.875C9.44141 10.875 9.25 11.1484 8.375 11.1484C7.5 11.1484 7.30859 10.875 6.54688 10.875C5.71875 10.875 4.91406 11.2422 4.44531 11.9453C4.16406 12.3633 4 12.8672 4 13.4102V14.3125C4 14.4844 4.14062 14.625 4.3125 14.625H4.9375C5.10938 14.625 5.25 14.4844 5.25 14.3125V13.4102C5.25 13.1367 5.33203 12.8711 5.48438 12.6445C5.70312 12.3203 6.10156 12.1289 6.55078 12.1289C7.03516 12.1289 7.36328 12.4023 8.37891 12.4023C9.39062 12.4023 9.71875 12.1289 10.207 12.1289C10.6562 12.1289 11.0547 12.3242 11.2734 12.6445C11.4258 12.8711 11.5078 13.1367 11.5078 13.4102V14.3125C11.5078 14.4844 11.6484 14.625 11.8203 14.625H12.4453C12.6172 14.625 12.7578 14.4844 12.7578 14.3125V13.4102C12.7578 12.8672 12.5937 12.3633 12.3125 11.9453C11.832 11.2422 11.0273 10.875 10.2031 10.875Z"
        fill="#1B4965"
      />
    </Svg>
  );
};

export const PaymentIcon = () => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M20.625 0.210938H1.875C0.839844 0.210938 0 1.05078 0 2.08594V15.8359C0 16.8711 0.839844 17.7109 1.875 17.7109H20.625C21.6602 17.7109 22.5 16.8711 22.5 15.8359V2.08594C22.5 1.05078 21.6602 0.210938 20.625 0.210938ZM21.25 15.8359C21.25 16.1797 20.9688 16.4609 20.625 16.4609H1.875C1.53125 16.4609 1.25 16.1797 1.25 15.8359V2.08594C1.25 1.74219 1.53125 1.46094 1.875 1.46094H20.625C20.9688 1.46094 21.25 1.74219 21.25 2.08594V15.8359ZM7.5 13.1797V13.4922C7.5 13.75 7.28906 13.9609 7.03125 13.9609H4.21875C3.96094 13.9609 3.75 13.75 3.75 13.4922V13.1797C3.75 12.9219 3.96094 12.7109 4.21875 12.7109H7.03125C7.28906 12.7109 7.5 12.9219 7.5 13.1797ZM15 13.1797V13.4922C15 13.75 14.7891 13.9609 14.5312 13.9609H9.21875C8.96094 13.9609 8.75 13.75 8.75 13.4922V13.1797C8.75 12.9219 8.96094 12.7109 9.21875 12.7109H14.5312C14.7891 12.7109 15 12.9219 15 13.1797ZM19.0625 2.71094H15.9375C15.418 2.71094 15 3.12891 15 3.64844V5.52344C15 6.04297 15.418 6.46094 15.9375 6.46094H19.0625C19.582 6.46094 20 6.04297 20 5.52344V3.64844C20 3.12891 19.582 2.71094 19.0625 2.71094ZM18.75 5.21094H16.25V3.96094H18.75V5.21094ZM10.1562 11.4609H7.96875C7.71094 11.4609 7.5 11.25 7.5 10.9922V9.42969C7.5 9.17188 7.71094 8.96094 7.96875 8.96094H10.1562C10.4141 8.96094 10.625 9.17188 10.625 9.42969V10.9922C10.625 11.25 10.4141 11.4609 10.1562 11.4609ZM11.25 10.9922V9.42969C11.25 9.17188 11.4609 8.96094 11.7188 8.96094H13.9062C14.1641 8.96094 14.375 9.17188 14.375 9.42969V10.9922C14.375 11.25 14.1641 11.4609 13.9062 11.4609H11.7188C11.4609 11.4609 11.25 11.25 11.25 10.9922ZM3.75 10.9922V9.42969C3.75 9.17188 3.96094 8.96094 4.21875 8.96094H6.40625C6.66406 8.96094 6.875 9.17188 6.875 9.42969V10.9922C6.875 11.25 6.66406 11.4609 6.40625 11.4609H4.21875C3.96094 11.4609 3.75 11.25 3.75 10.9922ZM18.75 9.42969V10.9922C18.75 11.25 18.5391 11.4609 18.2812 11.4609H15.4688C15.2109 11.4609 15 11.25 15 10.9922V9.42969C15 9.17188 15.2109 8.96094 15.4688 8.96094H18.2812C18.5391 8.96094 18.75 9.17188 18.75 9.42969Z"
        fill="#1B4965"
      />
    </Svg>
  );
};
export const GiftIcon = () => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M18.125 5.625H16.5898C16.9609 5.10156 17.1875 4.45703 17.1875 3.75C17.1875 2.02734 15.8828 0.625 14.2773 0.625C12.625 0.625 11.668 1.61719 10 4.36719C8.33203 1.61719 7.375 0.625 5.72266 0.625C4.11719 0.625 2.8125 2.02734 2.8125 3.75C2.8125 4.45703 3.03906 5.10156 3.41016 5.625H1.875C0.839844 5.625 0 6.46484 0 7.5V11.25C0 11.5938 0.28125 11.875 0.625 11.875H1.25V17.5C1.25 18.5352 2.08984 19.375 3.125 19.375H16.875C17.9102 19.375 18.75 18.5352 18.75 17.5V11.875H19.375C19.7188 11.875 20 11.5938 20 11.25V7.5C20 6.46484 19.1602 5.625 18.125 5.625ZM10.7891 5.48438C12.7227 2.23047 13.3672 1.875 14.2773 1.875C15.1914 1.875 15.9375 2.71484 15.9375 3.75C15.9375 4.78516 15.1914 5.625 14.2773 5.625H10.7031L10.7891 5.48438ZM5.72266 1.875C6.63672 1.875 7.27734 2.23047 9.21094 5.48438L9.29297 5.625H5.71875C4.80469 5.625 4.05859 4.78516 4.05859 3.75C4.0625 2.71484 4.80859 1.875 5.72266 1.875ZM7.5 18.125H3.125C2.78125 18.125 2.5 17.8438 2.5 17.5V11.875H7.5V18.125ZM7.5 10.625H1.25V7.5C1.25 7.15625 1.53125 6.875 1.875 6.875H7.5V10.625ZM11.25 18.125H8.75V6.875H11.25V18.125ZM17.5 17.5C17.5 17.8438 17.2188 18.125 16.875 18.125H12.5V11.875H17.5V17.5ZM18.75 10.625H12.5V6.875H18.125C18.4688 6.875 18.75 7.15625 18.75 7.5V10.625Z"
        fill="#1B4965"
      />
    </Svg>
  );
};
export const SettingsIcon = () => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M15.625 0.25H1.875C0.839844 0.25 0 1.08984 0 2.125V15.875C0 16.9102 0.839844 17.75 1.875 17.75H15.625C16.6602 17.75 17.5 16.9102 17.5 15.875V2.125C17.5 1.08984 16.6602 0.25 15.625 0.25ZM16.25 15.875C16.25 16.2188 15.9688 16.5 15.625 16.5H1.875C1.53125 16.5 1.25 16.2188 1.25 15.875V2.125C1.25 1.78125 1.53125 1.5 1.875 1.5H15.625C15.9688 1.5 16.25 1.78125 16.25 2.125V15.875ZM7.8125 5.25H6.25V4C6.25 3.74219 6.03906 3.53125 5.78125 3.53125H5.46875C5.21094 3.53125 5 3.74219 5 4V5.25H3.4375C2.92188 5.25 2.5 5.67188 2.5 6.1875V8.0625C2.5 8.57812 2.92188 9 3.4375 9H5V13.5312C5 13.7891 5.21094 14 5.46875 14H5.78125C6.03906 14 6.25 13.7891 6.25 13.5312V9H7.8125C8.32812 9 8.75 8.57812 8.75 8.0625V6.1875C8.75 5.67188 8.32812 5.25 7.8125 5.25ZM7.5 7.75H3.75V6.5H7.5V7.75ZM14.0625 9H12.5V4C12.5 3.74219 12.2891 3.53125 12.0312 3.53125H11.7188C11.4609 3.53125 11.25 3.74219 11.25 4V9H9.6875C9.17188 9 8.75 9.42188 8.75 9.9375V11.8125C8.75 12.3281 9.17188 12.75 9.6875 12.75H11.25V13.5312C11.25 13.7891 11.4609 14 11.7188 14H12.0312C12.2891 14 12.5 13.7891 12.5 13.5312V12.75H14.0625C14.5781 12.75 15 12.3281 15 11.8125V9.9375C15 9.42188 14.5781 9 14.0625 9ZM13.75 11.5H10V10.25H13.75V11.5Z"
        fill="#1B4965"
      />
    </Svg>
  );
};
export const HelpIcon = ({ color }) => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M10 1.5625C14.6336 1.5625 18.4375 5.31543 18.4375 10C18.4375 14.6598 14.6637 18.4375 10 18.4375C5.34203 18.4375 1.5625 14.6655 1.5625 10C1.5625 5.34363 5.33602 1.5625 10 1.5625ZM10 0.3125C4.65012 0.3125 0.3125 4.65168 0.3125 10C0.3125 15.3514 4.65012 19.6875 10 19.6875C15.3499 19.6875 19.6875 15.3514 19.6875 10C19.6875 4.65168 15.3499 0.3125 10 0.3125ZM8.59375 13.75H9.0625V9.0625H8.59375C8.33488 9.0625 8.125 8.85262 8.125 8.59375V8.28125C8.125 8.02238 8.33488 7.8125 8.59375 7.8125H10.4688C10.7276 7.8125 10.9375 8.02238 10.9375 8.28125V13.75H11.4062C11.6651 13.75 11.875 13.9599 11.875 14.2188V14.5312C11.875 14.7901 11.6651 15 11.4062 15H8.59375C8.33488 15 8.125 14.7901 8.125 14.5312V14.2188C8.125 13.9599 8.33488 13.75 8.59375 13.75ZM10 4.375C9.30965 4.375 8.75 4.93465 8.75 5.625C8.75 6.31535 9.30965 6.875 10 6.875C10.6904 6.875 11.25 6.31535 11.25 5.625C11.25 4.93465 10.6904 4.375 10 4.375Z"
        fill={color || "#1B4965"}
      />
    </Svg>
  );
};

export const FlexHelpIcon = ({ color }) => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M10 1.5625C14.6336 1.5625 18.4375 5.31543 18.4375 10C18.4375 14.6598 14.6637 18.4375 10 18.4375C5.34203 18.4375 1.5625 14.6655 1.5625 10C1.5625 5.34363 5.33602 1.5625 10 1.5625ZM10 0.3125C4.65012 0.3125 0.3125 4.65168 0.3125 10C0.3125 15.3514 4.65012 19.6875 10 19.6875C15.3499 19.6875 19.6875 15.3514 19.6875 10C19.6875 4.65168 15.3499 0.3125 10 0.3125ZM8.59375 13.75H9.0625V9.0625H8.59375C8.33488 9.0625 8.125 8.85262 8.125 8.59375V8.28125C8.125 8.02238 8.33488 7.8125 8.59375 7.8125H10.4688C10.7276 7.8125 10.9375 8.02238 10.9375 8.28125V13.75H11.4062C11.6651 13.75 11.875 13.9599 11.875 14.2188V14.5312C11.875 14.7901 11.6651 15 11.4062 15H8.59375C8.33488 15 8.125 14.7901 8.125 14.5312V14.2188C8.125 13.9599 8.33488 13.75 8.59375 13.75ZM10 4.375C9.30965 4.375 8.75 4.93465 8.75 5.625C8.75 6.31535 9.30965 6.875 10 6.875C10.6904 6.875 11.25 6.31535 11.25 5.625C11.25 4.93465 10.6904 4.375 10 4.375Z"
        fill={color || "#9dc554"}
      />
    </Svg>
  );
};
export const MentionsIcon = () => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M14.4492 3.82422L11.1719 0.546875C10.8203 0.195313 10.3438 -0.00390625 9.84766 -0.00390625H1.875C0.839844 9.31323e-10 0 0.839844 0 1.875V18.125C0 19.1602 0.839844 20 1.875 20H13.125C14.1602 20 15 19.1602 15 18.125V5.15234C15 4.65625 14.8008 4.17578 14.4492 3.82422ZM13.5664 4.71094C13.6484 4.79297 13.7031 4.89063 13.7305 5H10V1.26953C10.1094 1.29688 10.207 1.35156 10.2891 1.43359L13.5664 4.71094ZM13.125 18.75H1.875C1.53125 18.75 1.25 18.4688 1.25 18.125V1.875C1.25 1.53125 1.53125 1.25 1.875 1.25H8.75V5.3125C8.75 5.83203 9.16797 6.25 9.6875 6.25H13.75V18.125C13.75 18.4688 13.4688 18.75 13.125 18.75ZM11.25 9.21875V9.53125C11.25 9.78906 11.0391 10 10.7812 10H4.21875C3.96094 10 3.75 9.78906 3.75 9.53125V9.21875C3.75 8.96094 3.96094 8.75 4.21875 8.75H10.7812C11.0391 8.75 11.25 8.96094 11.25 9.21875ZM11.25 11.7188V12.0313C11.25 12.2891 11.0391 12.5 10.7812 12.5H4.21875C3.96094 12.5 3.75 12.2891 3.75 12.0313V11.7188C3.75 11.4609 3.96094 11.25 4.21875 11.25H10.7812C11.0391 11.25 11.25 11.4609 11.25 11.7188ZM11.25 14.2188V14.5313C11.25 14.7891 11.0391 15 10.7812 15H4.21875C3.96094 15 3.75 14.7891 3.75 14.5313V14.2188C3.75 13.9609 3.96094 13.75 4.21875 13.75H10.7812C11.0391 13.75 11.25 13.9609 11.25 14.2188Z"
        fill="#1B4965"
      />
    </Svg>
  );
};
export const ContactIcon = () => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M13.75 9.6875V9.0625C13.75 8.88984 13.6102 8.75 13.4375 8.75H6.5625C6.38984 8.75 6.25 8.88984 6.25 9.0625V9.6875C6.25 9.86016 6.38984 10 6.5625 10H13.4375C13.6102 10 13.75 9.86016 13.75 9.6875ZM6.5625 7.5H13.4375C13.6102 7.5 13.75 7.36016 13.75 7.1875V6.5625C13.75 6.38984 13.6102 6.25 13.4375 6.25H6.5625C6.38984 6.25 6.25 6.38984 6.25 6.5625V7.1875C6.25 7.36016 6.38984 7.5 6.5625 7.5ZM19.3199 6.42656C19.2426 6.36289 18.4531 5.72695 17.5 4.96055V3.75C17.5 3.05977 16.9402 2.5 16.25 2.5H14.4348C14.2734 2.3707 14.1336 2.25938 14.0363 2.18203C13.173 1.4918 11.6969 0 10 0C8.31211 0 6.85 1.47344 5.96328 2.18203C5.86445 2.26055 5.725 2.37227 5.56484 2.5H3.75C3.05977 2.5 2.5 3.05977 2.5 3.75V4.96016C1.54219 5.73008 0.751953 6.3668 0.684375 6.42227C0.47045 6.59812 0.298132 6.81917 0.179801 7.06954C0.0614709 7.31991 6.65091e-05 7.59339 0 7.87031L0 18.125C0 19.1605 0.839453 20 1.875 20H18.125C19.1605 20 20 19.1605 20 18.125V7.87148C20 7.3125 19.7508 6.78242 19.3199 6.42656ZM10 1.25C10.8504 1.25 11.7438 1.90313 12.4664 2.5H7.53516C8.25898 1.90352 9.15312 1.25 10 1.25ZM3.75 3.75H16.25V10.5215C14.9871 11.5371 13.6992 12.5699 12.8676 13.2301C12.2094 13.7547 10.907 15.0145 10 15C9.09336 15.0148 7.79063 13.7547 7.13242 13.2297C6.30078 12.5695 5.01367 11.5371 3.75 10.5211V3.75ZM1.25 7.87031C1.25 7.68281 1.3332 7.50664 1.47812 7.3875C1.52656 7.34766 1.93203 7.02109 2.5 6.56406V9.51523C2.04961 9.15273 1.6207 8.80703 1.25 8.5082V7.87031ZM18.75 18.125C18.75 18.4695 18.4695 18.75 18.125 18.75H1.875C1.53047 18.75 1.25 18.4695 1.25 18.125V10.1137C2.91992 11.459 5.1293 13.2355 6.35469 14.2082C7.15508 14.8473 8.57109 16.2602 10 16.2496C11.4238 16.2598 12.823 14.8645 13.6449 14.2082C14.8719 13.2344 17.0797 11.4586 18.75 10.1133V18.125ZM18.75 8.5082C18.3742 8.81094 17.9582 9.14648 17.5 9.51562V6.56484C18.0641 7.01875 18.4688 7.34492 18.5234 7.38984C18.6676 7.50898 18.75 7.68437 18.75 7.87148V8.5082Z"
        fill="#1B4965"
      />
    </Svg>
  );
};
export const LogoutIcon = ({ color }) => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M1.875 0.5H7.03125C7.28906 0.5 7.5 0.710938 7.5 0.96875V1.28125C7.5 1.53906 7.28906 1.75 7.03125 1.75H1.875C1.53125 1.75 1.25 2.03125 1.25 2.375V13.625C1.25 13.9688 1.53125 14.25 1.875 14.25H7.03125C7.28906 14.25 7.5 14.4609 7.5 14.7188V15.0312C7.5 15.2891 7.28906 15.5 7.03125 15.5H1.875C0.839844 15.5 0 14.6602 0 13.625V2.375C0 1.33984 0.839844 0.5 1.875 0.5ZM12.7734 1.26172L12.4961 1.53906C12.3125 1.72266 12.3125 2.01953 12.4961 2.20312L17.6523 7.33594H6.71875C6.46094 7.33594 6.25 7.54688 6.25 7.80469V8.19531C6.25 8.45312 6.46094 8.66406 6.71875 8.66406H17.6523L12.5 13.7969C12.3164 13.9805 12.3164 14.2773 12.5 14.4609L12.7773 14.7383C12.9609 14.9219 13.2578 14.9219 13.4414 14.7383L19.8672 8.33203C20.0508 8.14844 20.0508 7.85156 19.8672 7.66797L13.4375 1.26172C13.2539 1.07812 12.957 1.07812 12.7734 1.26172Z"
        fill={color || "#1B4965"}
      />
    </Svg>
  );
};
export const ScoreIcon = () => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <Path
        d="M20.6289 6.69874L14.9219 5.86671L12.3711 0.694832C11.9141 -0.227044 10.5899 -0.238763 10.1289 0.694832L7.57815 5.86671L1.87111 6.69874C0.847675 6.84718 0.437518 8.1089 1.17971 8.83156L5.30862 12.855L4.33205 18.5386C4.15627 19.5659 5.2383 20.3355 6.14455 19.855L11.25 17.1714L16.3555 19.855C17.2617 20.3316 18.3438 19.5659 18.168 18.5386L17.1914 12.855L21.3203 8.83156C22.0625 8.1089 21.6524 6.84718 20.6289 6.69874ZM15.8516 12.4175L16.9375 18.7456L11.25 15.7613L5.56643 18.7495L6.65237 12.4214L2.0508 7.93312L8.40627 7.01124L11.25 1.24952L14.0938 7.01124L20.4493 7.93312L15.8516 12.4175Z"
        fill="#1B4965"
      />
    </Svg>
  );
};

export const ScoreCup = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 214 213"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <G>
        <Path
          d="M210.854 90.9762C205.051 52.9754 181.271 6.28815 134.288 1.40242C134.288 1.40242 98.6161 -2.94005 63.4518 3.64165C42.5818 7.54818 24.2817 19.1766 12.6998 35.89C1.11794 52.6034 -2.74759 72.9829 1.94642 92.4126C4.99521 105.032 7.0554 118.092 6.48986 131.06C5.77742 147.414 4.43334 164.608 11.6569 179.859C22.2406 202.203 48.0624 208.784 70.5938 210.882C78.8933 211.655 87.2303 211.967 95.5409 212.625C111.483 213.886 129.361 211.845 144.727 207.691C223.034 186.524 216.654 128.983 210.854 90.9762Z"
          fill="white"
        />
        <Path
          d="M96.4295 171.519L108.041 182.018C108.041 182.018 115.607 178.032 116.561 171.252C118.503 157.418 130.472 160.086 135.653 160.452C143.465 161.005 150.591 158.082 145.887 149.752C141.184 141.422 157.368 137.098 169.856 139.81C182.077 142.466 193.843 122.254 167.92 114.077C152.439 109.194 143.666 122.367 137.655 127.965C131.644 133.563 122.163 125.907 118.558 136.119C115.474 144.845 116.319 154.001 108.559 154.899C100.798 155.798 95.9873 160.327 96.4295 171.519Z"
          fill="#9dc554"
        />
        <Path
          d="M96.4295 171.519L108.041 182.018C108.041 182.018 115.607 178.032 116.561 171.252C118.503 157.418 130.472 160.086 135.653 160.452C143.465 161.005 149.662 158.196 146.871 150.215C143.713 141.184 157.368 137.098 169.856 139.81C182.077 142.466 193.843 122.254 167.92 114.077C152.439 109.194 143.666 122.367 137.655 127.965C131.644 133.563 122.163 125.907 118.558 136.119C115.474 144.845 116.319 154.001 108.559 154.899C100.798 155.798 95.9873 160.327 96.4295 171.519Z"
          fill="#9dc554"
        />
        <Path
          d="M100.481 177.142L100.763 177.316C100.87 177.142 111.698 159.737 127.63 145.723C142.307 132.812 164.447 120.22 186.565 133.554L186.735 133.271C176.89 127.335 166.222 125.955 155.028 129.167C146.086 131.734 136.793 137.222 127.407 145.479C111.44 159.526 100.589 176.968 100.481 177.142Z"
          fill="#9dc554"
        />
        <Path
          d="M150.408 130.712L150.679 130.902C156.984 121.887 170.457 113.163 170.593 113.077L170.414 112.799C170.28 112.884 156.751 121.644 150.408 130.712Z"
          fill="#9dc554"
        />
        <Path
          d="M157.925 128.775C170.822 131.09 176.303 140.53 176.357 140.625L176.644 140.463C176.59 140.366 171.038 130.793 157.984 128.45L157.925 128.775Z"
          fill="#9dc554"
        />
        <Path
          d="M117.713 155.453C130.894 146.363 149.174 157.737 149.342 157.862L149.556 157.611C149.402 157.472 130.823 146.009 117.526 155.18L117.713 155.453Z"
          fill="#9dc554"
        />
        <Path
          d="M122.061 150.483L122.346 150.649C127.506 141.828 124.068 129.438 124.035 129.313L123.718 129.405C123.75 129.527 127.149 141.783 122.061 150.483Z"
          fill="#9dc554"
        />
        <Path
          d="M102.526 174.615C106.943 170.431 116.583 172.673 116.68 172.696L116.754 172.374C116.352 172.278 106.844 170.068 102.296 174.375L102.526 174.615Z"
          fill="#9dc554"
        />
        <Path
          d="M105.035 170.459L105.314 170.636C107.891 166.573 106.113 157.845 105.529 154.978C105.447 154.572 105.376 154.223 105.375 154.157H105.045C105.045 154.248 105.091 154.481 105.206 155.046C105.784 157.879 107.541 166.508 105.035 170.459Z"
          fill="#9dc554"
        />
        <Path
          d="M129.061 178.884L118.169 188.735C118.169 188.735 111.071 184.996 110.179 178.636C108.357 165.66 97.1302 168.162 92.2709 168.505C84.9423 169.024 78.2587 166.282 82.6706 158.469C87.0826 150.656 71.9018 146.599 60.1877 149.144C48.7241 151.634 37.6872 132.677 62.0033 125.005C76.5253 120.425 84.755 132.781 90.3928 138.032C96.0307 143.283 104.924 136.1 108.309 145.678C111.2 153.862 110.41 162.451 117.689 163.294C124.967 164.137 129.476 168.387 129.061 178.884Z"
          fill="#9dc554"
        />
        <Path
          d="M129.061 178.884L118.169 188.735C118.169 188.735 111.071 184.996 110.179 178.636C108.357 165.66 97.1302 168.162 92.2709 168.505C84.9423 169.024 79.129 166.39 81.7481 158.903C84.7117 150.433 71.9018 146.599 60.1877 149.144C48.7241 151.634 37.6872 132.677 62.0033 125.005C76.5253 120.425 84.755 132.781 90.3928 138.032C96.0307 143.283 104.924 136.1 108.309 145.678C111.2 153.862 110.41 162.451 117.689 163.294C124.967 164.137 129.476 168.387 129.061 178.884Z"
          fill="#9dc554"
        />
        <Path
          d="M125.256 184.158L124.993 184.321C124.892 184.158 114.735 167.832 99.7909 154.686C86.0233 142.575 65.2561 130.764 44.508 143.271L44.3486 143.006C53.5846 137.438 63.5918 136.143 74.0947 139.157C82.4824 141.564 91.1998 146.712 100.004 154.457C114.981 167.634 125.159 183.994 125.256 184.158Z"
          fill="#9dc554"
        />
        <Path
          d="M78.4273 140.606L78.1732 140.784C72.2585 132.33 59.6205 124.145 59.4941 124.064L59.6609 123.803C59.7887 123.884 72.4781 132.1 78.4273 140.606Z"
          fill="#9dc554"
        />
        <Path
          d="M71.3764 138.789C59.2797 140.961 54.1376 149.817 54.0869 149.905L53.8174 149.752C53.8688 149.661 59.0762 140.682 71.3213 138.484L71.3764 138.789Z"
          fill="#9dc554"
        />
        <Path
          d="M109.098 163.813C96.7348 155.285 79.5887 165.956 79.43 166.074L79.2295 165.838C79.3764 165.708 96.8009 154.958 109.274 163.559L109.098 163.813Z"
          fill="#9dc554"
        />
        <Path
          d="M105.018 159.151L104.75 159.308C99.9102 151.032 103.134 139.411 103.168 139.295L103.462 139.38C103.433 139.496 100.245 150.991 105.018 159.151Z"
          fill="#9dc554"
        />
        <Path
          d="M123.341 181.787C119.199 177.863 110.156 179.966 110.065 179.988L109.991 179.686C110.369 179.595 119.287 177.522 123.552 181.562L123.341 181.787Z"
          fill="#9dc554"
        />
        <Path
          d="M120.988 177.889L120.726 178.055C118.31 174.244 119.977 166.057 120.524 163.367C120.602 162.987 120.671 162.659 120.671 162.598H120.981C120.981 162.684 120.938 162.902 120.834 163.431C120.287 166.089 118.638 174.183 120.988 177.889Z"
          fill="#9dc554"
        />
        <Path
          d="M102.285 178.203C101.075 183.275 104.212 187.245 106.932 189.764C107.418 189.643 107.728 189.697 108.244 189.685C112.899 189.566 114.86 188.522 119.431 187.681C120.414 187.499 123.14 186.088 124.217 185.441L126.205 184.201C126.205 184.201 127.541 172.263 120.878 170.759C114.216 169.254 114.048 157.755 113.209 151.675C112.695 147.941 111.263 146.399 110.854 145.059C106.52 130.858 109.825 125.539 105.583 121.788C100.899 117.647 95.5282 122.944 90.1945 118.708C84.1718 113.926 86.976 103.96 80.2659 100.709C79.1157 100.151 77.9156 99.6103 76.2153 99.5324C72.0119 99.3324 69.3774 102.395 65.7946 99.8419C58.5968 94.7113 48.7835 94.7128 44.7807 102.903C40.8292 110.99 50.4611 122.616 69.3597 129.119C82.2724 135.278 83.0451 137.91 83.6547 144.644C84.0815 149.361 82.1175 162.435 89.7912 165.497C97.465 168.56 103.669 172.399 102.285 178.203Z"
          fill="#FD7064"
        />
        <Path
          d="M117.125 188.448L117.445 188.326C116.784 186.552 116.1 184.771 115.404 183.033C110.243 170.173 103.977 158.306 96.7793 147.761C90.6832 138.826 83.8291 130.713 76.4161 123.648C70.4536 117.967 64.0975 112.929 57.5233 108.675C52.902 105.684 48.2212 103.108 43.6109 101.02C42.8081 100.652 41.9628 100.327 41.1446 100.01C40.0553 99.5871 38.9287 99.1496 37.8938 98.624L37.7212 98.91C38.7708 99.443 39.9048 99.8833 41.0013 100.307C41.8151 100.623 42.6568 100.95 43.4515 101.31C48.0471 103.392 52.714 105.96 57.322 108.942C63.8801 113.186 70.2215 118.212 76.1693 123.88C83.5676 130.93 90.4055 139.024 96.4928 147.945C103.678 158.471 109.934 170.32 115.087 183.158C115.782 184.898 116.468 186.676 117.125 188.448Z"
          fill="#FBF6F3"
        />
        <Path
          d="M84.7926 132.854L85.0629 132.646C76.3065 122.115 76.5871 98.466 76.5907 98.2285L76.2522 98.2417C76.2485 98.4807 75.9664 122.24 84.7926 132.854Z"
          fill="#FBF6F3"
        />
        <Path
          d="M106.444 164.504L106.737 164.326C101.709 156.46 82.9331 154.181 82.7443 154.16L82.6841 154.479C82.8692 154.501 101.493 156.76 106.444 164.504Z"
          fill="#FBF6F3"
        />
        <Path
          d="M108.878 169.224L109.196 169.096C106.955 163.436 107.152 154.405 109.753 143.661C109.884 143.121 109.884 143.121 109.863 143.064L109.543 143.189L109.702 143.127H109.534C109.53 143.164 109.481 143.367 109.423 143.604C106.806 154.411 106.613 163.508 108.878 169.224Z"
          fill="#FBF6F3"
        />
        <Path
          d="M115.876 185.23L116.147 185.023C111.863 179.825 101.268 180.043 101.164 180.046L101.153 180.367C101.257 180.364 111.689 180.15 115.876 185.23Z"
          fill="#FBF6F3"
        />
        <Path
          d="M117.632 188.346C117.717 182.87 119.462 177.149 122.963 170.855L122.666 170.718C119.14 177.06 117.377 182.83 117.293 188.361L117.632 188.346Z"
          fill="#FBF6F3"
        />
        <Path
          d="M61.1472 111.514L61.4058 111.294C56.1778 105.717 52.1177 98.6288 50.7831 96.297C50.46 95.7331 50.3424 95.5354 50.2932 95.4736L50.0259 95.6854C50.0655 95.7331 50.2462 96.0529 50.4842 96.4631C51.8224 98.8016 55.8958 105.912 61.1472 111.514Z"
          fill="#FBF6F3"
        />
        <Path
          d="M71.1317 119.308L71.3139 119.028C64.924 115.493 50.1155 119.433 49.4883 119.602L49.5617 119.912C49.716 119.868 64.8615 115.839 71.1317 119.308Z"
          fill="#FBF6F3"
        />
        <Path
          d="M127.694 173.312C126.742 173.174 122.737 181.659 120.075 175.307C119.414 173.72 118.717 168.258 111.659 167.882L107.546 167.661C106.42 164.558 105.93 161.424 110.116 160.317C116.609 158.597 116.804 147.805 115.037 143.955C112.854 139.189 108.008 127.997 117.997 125.188C126.314 122.85 132.213 122.957 132.833 112.845C133.454 102.733 139.312 96.5249 149.011 97.2976C159.22 98.1128 167.634 85.4037 175.983 89.8543C190.53 97.6093 177.248 119.68 159.501 125.825C141.754 131.971 151.901 138.196 152.35 146.489C152.348 147.623 152.211 148.754 151.944 149.856C149.84 158.467 140.797 159.798 134.224 166.765C125.257 176.265 129.296 173.543 127.694 173.312Z"
          fill="#94CDDB"
        />
        <Path
          d="M120.106 167.094L119.635 166.994C126.828 134.453 150.73 105.62 182.013 91.749L182.223 92.1622C151.072 105.973 127.27 134.688 120.106 167.094Z"
          fill="#FBF6F3"
        />
        <Path
          d="M125.64 149.694L125.158 149.684C125.252 136.58 113.469 126.114 113.35 126.013L113.674 125.68C113.799 125.783 125.736 136.383 125.64 149.694Z"
          fill="#FBF6F3"
        />
        <Path
          d="M121.603 161.144L121.18 160.919C127.931 149.367 153.455 148.252 153.712 148.241L153.739 148.697C153.485 148.707 128.225 149.812 121.603 161.144Z"
          fill="#FBF6F3"
        />
        <Path
          d="M142.963 121.669L142.523 121.478C147.025 111.902 140.462 96.8835 140.393 96.7328L140.833 96.5615C140.906 96.7108 147.549 111.916 142.963 121.669Z"
          fill="#FBF6F3"
        />
        <Path
          d="M158.449 106.604L158.2 106.21C169.057 100.151 185.78 103.978 185.948 104.017L185.839 104.458C185.673 104.421 169.138 100.639 158.449 106.604Z"
          fill="#FBF6F3"
        />
        <Path
          d="M161.534 108.718C162.055 108.312 162.46 107.775 162.709 107.162C163.02 106.363 162.801 106.006 163.191 105.506C163.686 104.872 164.699 104.6 165.395 104.909C165.574 104.975 165.727 105.096 165.832 105.255C166.141 105.777 165.455 106.681 164.908 107.162C164.497 107.525 164.326 107.498 163.89 107.806C163.454 108.114 162.928 108.625 162.494 109.576L161.534 108.718Z"
          fill="#FBF6F3"
        />
        <Path
          d="M184.435 104.34C183.796 104.17 183.214 103.835 182.745 103.368C182.147 102.753 182.21 102.339 181.656 102.032C180.953 101.641 179.915 101.786 179.396 102.342C179.257 102.472 179.163 102.644 179.128 102.831C179.047 103.432 180.031 103.997 180.722 104.228C181.243 104.401 181.389 104.31 181.91 104.423C182.42 104.534 183.116 104.802 183.884 105.509L184.435 104.34Z"
          fill="#FBF6F3"
        />
        <Path
          d="M182.247 105.083C181.943 106.533 183.508 107.822 184.637 109.088C186.903 111.627 189.274 116.159 188.403 120.047C187.927 122.172 186.403 124.469 184.251 125.561C181.934 126.733 180.547 125.667 178.137 127.058C177.959 127.161 174.911 128.969 174.823 131.41C174.713 134.42 179.136 137.623 182.922 137.869C189.845 138.316 198.188 129.101 197.799 119.956C197.376 110.001 186.689 102.099 183.614 103.438C183.133 103.646 182.418 104.268 182.247 105.083Z"
          fill="#FD7064"
        />
        <Path
          d="M179.164 208.168L178.917 210.69L180.09 210.478L180.879 208.107L179.164 208.168Z"
          fill="#FBF6F3"
        />
        <Path
          d="M186.316 161.564C186.217 165.411 185.768 169.24 184.975 173.005C184.264 176.372 183.849 176.953 183.628 179.281C183.144 184.346 184.775 185.07 185.074 190.795C185.406 197.117 183.726 202.141 183.066 204.058C182.599 205.412 182.053 206.738 181.43 208.027C180.851 208.532 179.965 208.338 179.032 208.149C178.688 202.415 178.259 197.019 177.916 191.285L174.588 165.408L186.316 161.564Z"
          fill="#FBF6F3"
        />
        <Path
          d="M179.032 208.147C178.688 202.413 178.259 197.017 177.916 191.284L174.588 165.407L186.316 161.564C186.308 161.859 186.293 162.147 186.282 162.439C180.797 167.206 179.724 170.982 179.777 173.558C179.842 176.683 181.549 178.232 181.216 182.761C180.977 186 180.004 186.571 180.004 189.493C180.004 193.257 181.62 195.374 182.405 197.548C183.165 199.65 183.434 202.627 181.965 206.861C181.772 207.303 181.589 207.69 181.427 208.026C180.851 208.531 179.965 208.337 179.032 208.147Z"
          fill="#FBF6F3"
        />
        <Path
          d="M179.607 211.551C180.163 210.862 180.673 210.912 180.766 210.448C180.84 210.081 180.606 209.64 180.265 209.475C179.785 209.246 179.219 209.632 179.09 209.719C178.22 210.312 178.479 211.203 177.657 211.61C177.491 211.692 177.228 211.781 176.954 212.051C176.838 212.165 176.549 212.447 176.623 212.635C176.707 212.856 177.231 212.835 177.729 212.816C178.327 212.795 178.626 212.785 178.909 212.596C179.301 212.336 179.176 212.083 179.607 211.551Z"
          fill="#FD7064"
        />
        <Path
          d="M178.425 189.973L180.62 190.833L181.26 189.825L179.544 188.671L178.425 189.973Z"
          fill="#FBF6F3"
        />
        <Path
          d="M181.776 191.366C181.647 190.491 182.03 190.15 181.75 189.764C181.53 189.461 181.046 189.332 180.695 189.47C180.202 189.667 180.1 190.346 180.078 190.5C179.923 191.541 180.753 191.955 180.494 192.837C180.442 193.014 180.328 193.267 180.339 193.651C180.343 193.814 180.355 194.216 180.543 194.291C180.764 194.377 181.102 193.979 181.425 193.6C181.814 193.146 182.012 192.919 182.065 192.584C182.145 192.122 181.876 192.043 181.776 191.366Z"
          fill="#FD7064"
        />
        <Path
          d="M168.929 157.584C164.84 165.929 163.452 172.887 162.927 177.433C162.589 180.354 162.621 182.161 163.462 183.975C166.474 190.474 176.976 190.903 178.575 190.949L180.151 187.721C179.184 185.927 177.497 183.435 174.609 181.619C172.388 180.223 171.519 180.52 170.965 179.581C168.74 175.812 180.751 167.648 178.957 162.213C178.336 160.328 175.947 158.421 168.929 157.584Z"
          fill="#FBF6F3"
        />
        <Path
          d="M177.789 127.586C173.371 128.345 170.008 129.136 168.506 131.452C166.919 133.899 169.441 135.74 170.127 141.107C171.177 149.325 166.455 152.395 167.814 160.669C168.016 161.886 168.325 163.084 168.738 164.247C169.378 166.048 170.608 167.578 172.229 168.589C173.617 169.466 175.101 170.184 176.65 170.728C181.13 172.297 183.34 171.385 189.367 171.73C199.227 172.293 200.703 175.155 205.159 173.395C209.661 171.617 212.919 166.811 211.964 164.757C211.392 163.527 209.588 164.294 207.001 162.784C203.668 160.839 204.227 158.182 201.522 155.904C197.637 152.631 193.899 155.936 190.579 153.09C187.217 150.211 186.816 143.21 188.245 139.042C189.178 136.322 189.196 133.359 189.888 130.566C189.973 130.229 189.959 129.874 189.847 129.544C189.296 127.939 186.361 127.633 184.142 127.418C180.751 127.095 178.153 127.523 177.789 127.586Z"
          fill="#FD7064"
        />
        <Path
          d="M204.637 170.279C203.272 169.369 204.011 166.788 201.989 165.418C200.113 164.146 198.65 165.809 195.884 164.961C192.338 163.873 192.523 160.454 189.124 159.363C186.679 158.579 185.942 160.14 182.416 160.208C178.891 160.276 174.283 158.821 171.361 155.088C170.251 153.658 169.462 152.006 169.049 150.243C168.107 153.286 167.086 156.228 167.814 160.669C168.072 162.225 168.503 163.748 169.1 165.208C169.558 166.334 170.333 167.302 171.33 167.996C172.97 169.144 174.759 170.063 176.647 170.729C181.127 172.297 183.337 171.385 189.364 171.73C199.224 172.294 200.7 175.155 205.156 173.396C208.033 172.259 210.395 169.887 211.482 167.786C207.584 170.623 205.628 170.94 204.637 170.279Z"
          fill="#FD7064"
        />
        <Path
          d="M175.613 120.294C175.613 120.294 174.409 122.557 174.333 124.145C174.257 125.733 176.047 125.615 176.047 125.615L175.98 126.617C175.952 127.035 175.803 127.437 175.552 127.773C175.301 128.109 174.958 128.364 174.564 128.509L173.857 128.769C173.857 128.769 178.469 129.757 180.987 127.977L180.262 127.903C179.763 127.855 179.297 127.635 178.942 127.281C178.587 126.928 178.365 126.462 178.314 125.963L178.271 125.535C178.271 125.535 179.071 120.589 175.613 120.294Z"
          fill="#FBF6F3"
        />
        <Path
          d="M163.758 109.174C164.449 110.484 163.3 112.155 162.563 113.684C161.086 116.75 160.054 121.76 161.963 125.258C163.006 127.169 165.104 128.956 167.472 129.408C170.021 129.894 171.062 128.487 173.761 129.159C173.961 129.208 177.388 130.106 178.146 132.427C179.08 135.294 175.712 139.59 172.141 140.871C165.609 143.214 155.05 136.658 152.904 127.76C150.568 118.074 158.663 107.528 161.988 107.967C162.513 108.036 163.368 108.438 163.758 109.174Z"
          fill="#FD7064"
        />
        <Path
          d="M176.333 122.544C176.571 122.524 176.769 122.221 176.932 122.312C177.095 122.402 177.084 122.847 176.932 123.156C176.836 123.349 176.686 123.511 176.5 123.62C176.755 123.968 176.931 124.367 177.014 124.79C177.23 125.937 176.62 126.86 176.367 127.4C175.225 129.834 177.002 133.682 178.952 135.626C180.537 137.205 181.276 136.57 182.223 137.86C184.064 140.371 181.522 143.131 182.475 146.51C183.923 151.65 192.03 153.178 192.366 153.237C192.499 153.261 192.586 153.275 192.725 153.297C196.362 153.876 201.874 154.752 205.756 151.764C208.661 149.529 209.993 145.638 209.772 142.212C209.715 141.311 209.442 137.888 206.657 135.096C206.216 134.655 203.596 132.035 200.059 132.002C198.184 131.985 197.807 132.646 196.374 132.238C194.412 131.679 193.203 129.893 192.454 128.783C191.075 126.746 191.635 126.311 190.643 125.309C188.699 123.346 186.418 124.887 184.342 123.156C182.296 121.448 183.53 119.131 181.551 117.653C179.513 116.129 175.614 116.661 174.783 118.476C174.078 120.039 175.602 122.604 176.333 122.544Z"
          fill="#1B4965"
        />
        <Path
          d="M181.544 102.761C181.544 102.761 180.723 102.982 180.296 102.357C179.869 101.733 179.697 102.794 180.261 103.177C180.604 103.409 180.984 103.581 181.384 103.687L181.544 102.761Z"
          fill="#FBF6F3"
        />
        <Path
          d="M144.187 174.9C143.878 174.516 135.172 174.694 124.051 175.085C119.791 174.725 115.057 174.6 110.064 174.767C104.322 174.958 98.9 175.512 94.1157 176.328C83.5731 176.81 75.5585 177.21 75.5585 177.21C75.5585 177.21 74.3525 185.314 76.0477 186.793H76.0557C79.1993 190.889 93.3261 193.535 110.152 192.899C128.672 192.2 143.603 187.779 144.214 182.938H144.246C144.246 182.938 145.054 175.977 144.187 174.9Z"
          fill="#FFCE63"
        />
        <Path
          d="M144.561 175.802C144.597 180.765 129.332 185.342 110.307 186.029C91.1046 186.722 75.3958 183.194 75.3833 178.146C75.3708 173.098 91.0393 168.516 110.218 167.911C129.223 167.308 144.525 170.842 144.561 175.802Z"
          fill="#FFCE63"
        />
        <Path
          d="M138.618 168.105C138.357 167.774 131.011 167.91 121.636 168.225C117.718 167.89 113.784 167.789 109.854 167.922C105.021 168.076 100.46 168.54 96.4368 169.232C87.5769 169.625 80.8454 169.953 80.8454 169.953C80.8454 169.953 79.8355 176.909 81.2597 178.182L81.2663 178.185C83.9104 181.71 95.7765 184.019 109.931 183.517C125.529 182.963 138.123 179.196 138.64 175.03H138.665C138.665 175.03 139.35 169.034 138.618 168.105Z"
          fill="#FFCE63"
        />
        <Path
          d="M139.108 168.877C139.137 173.15 126.222 177.056 110.148 177.604C93.9486 178.155 80.712 175.09 80.6958 170.755C80.6797 166.421 93.8855 162.513 110.069 162.023C126.13 161.537 139.078 164.606 139.108 168.877Z"
          fill="#FFCE63"
        />
        <Path
          d="M127.059 166.588C127.069 168.24 119.567 169.823 110.272 170.117C107.38 170.21 104.657 170.167 102.274 170.016C96.9457 169.68 93.3189 168.798 93.313 167.649C93.313 167.247 93.7581 166.967 94.5667 166.591C100.775 161.838 100.456 136.87 100.456 136.87L119.863 136.401C119.863 136.401 119.761 163.314 126.714 166.035C126.714 166.035 126.684 165.986 126.64 166.003C126.914 166.208 127.058 166.366 127.059 166.588Z"
          fill="#FFCE63"
        />
        <Path
          d="M102.273 170.018C96.9457 169.683 93.3189 168.801 93.313 167.652C93.313 167.25 93.7581 166.97 94.5667 166.594C100.775 161.841 100.456 136.872 100.456 136.872L104.525 136.774C107.256 137.042 109.945 138.161 110.384 139.862C110.386 139.863 112.1 168.419 102.273 170.018Z"
          fill="#FFCE63"
        />
        <Path
          d="M137.142 111.542L139.532 111.499C144.474 111.404 149.268 109.788 153.26 106.87C157.253 103.953 160.251 99.8751 161.846 95.192L173.902 59.6319C174.611 57.5456 174.274 55.3254 172.977 53.5207C171.718 51.7688 169.691 50.7742 167.413 50.7823C167.36 50.7823 167.307 50.7867 167.254 50.7889L139.065 51.982C138.524 52.0046 137.992 52.134 137.501 52.3627C137.01 52.5914 136.569 52.915 136.203 53.3148C135.837 53.7146 135.554 54.1828 135.369 54.6925C135.185 55.2022 135.103 55.7433 135.128 56.2849C135.153 56.8265 135.284 57.3578 135.515 57.8483C135.745 58.3388 136.071 58.7789 136.472 59.1433C136.873 59.5077 137.342 59.7892 137.852 59.9717C138.362 60.1542 138.903 60.2341 139.444 60.2068L165.482 59.0533L154.063 92.6051C151.923 98.8817 146.066 103.158 139.477 103.265L137.088 103.304C134.791 103.34 132.939 105.2 132.953 107.494C132.968 109.788 134.844 111.584 137.142 111.542Z"
          fill="#FFCE63"
        />
        <Path
          d="M153.471 41.0605C153.471 41.0605 153.471 42.0749 153.427 43.8805C153.427 44.0973 153.418 44.3304 153.412 44.5715C153.025 59.1059 150.009 115.043 126.616 133.664C124.923 135.015 123.384 136.171 121.475 137.099C118.385 138.601 114.676 139.525 111.541 139.721V139.737C110.757 139.751 111.032 139.747 110.888 139.746C110.744 139.746 110.497 139.761 110.235 139.771V139.754C71.5779 139.561 66.3874 62.4743 65.7264 44.7744C65.6669 43.1762 65.5244 42.0602 65.5148 41.5251C65.5153 41.3961 65.4934 41.268 65.4502 41.1465L109.298 41.0186H110.547L153.471 41.0605Z"
          fill="#FFCE63"
        />
        <Path
          d="M121.474 137.099C118.384 138.601 114.675 139.52 111.54 139.72V139.736C110.757 139.75 111.031 139.746 110.887 139.745C110.743 139.744 110.496 139.76 110.234 139.77V139.753C71.5771 139.56 66.3865 62.4733 65.7255 44.7734C65.4317 44.6999 65.0307 44.6263 64.7604 44.5528C64.6275 44.5153 64.4174 44.4742 64.2595 44.4286C64.0495 42.2908 63.9106 41.0947 63.9106 41.0947L65.4097 41.5285L78.4304 45.2505C78.4304 45.2505 78.4539 45.7923 78.5163 46.7854C79.1502 57.1178 83.5401 116.482 97.7353 121.379C110.939 125.925 109.51 137.21 121.474 137.099Z"
          fill="#FFCE63"
        />
        <Path
          d="M78.164 107.263L75.7035 107.304C68.8832 107.419 62.743 103.216 60.4449 96.8651L48.094 62.6422L72.4931 63.4134C72.4931 63.4134 78.9087 60.5383 73.0154 55.0556L46.1337 54.1484C46.0772 54.1484 46.0214 54.1484 45.9655 54.1484C43.5455 54.158 41.3979 55.207 40.0736 57.0272C38.7075 58.9048 38.3704 61.2175 39.1475 63.3649L52.2945 99.7542C55.8199 109.49 65.252 115.877 75.7241 115.679L78.186 115.633C80.5496 115.588 82.4577 113.697 82.4504 111.375C82.443 109.052 80.5275 107.223 78.164 107.263Z"
          fill="#FFCE63"
        />
        <Path
          d="M153.427 43.8872C153.427 44.1041 153.419 44.3334 153.412 44.5753C153.026 59.109 150.009 115.044 126.616 133.665C147.442 114.803 146.907 42.2412 146.907 42.2412L153.427 43.8872Z"
          fill="#E09B22"
        />
        <Path
          d="M160.63 38.2736C160.665 42.4896 155.886 43.8665 154.08 44.3892C153.86 44.4509 153.64 44.5127 153.412 44.5752C150.935 45.2309 147.618 45.8161 143.518 46.3175C134.557 47.4202 122.619 48.0487 109.862 48.0818C98.323 48.1127 87.3228 47.6547 78.5114 46.7806C77.5267 46.6826 76.5685 46.5789 75.6367 46.4696C71.4678 45.9859 68.0569 45.4162 65.4855 44.7729C65.1917 44.6994 64.9104 44.6259 64.6402 44.5524C64.5072 44.5149 64.3566 44.4737 64.1995 44.4274C62.0695 43.8121 57.7273 42.3227 57.7222 38.3066C57.7163 33.9906 62.7342 32.5902 64.6189 32.0661C67.2681 31.3309 70.9603 30.6811 75.5963 30.1385C84.8073 29.0608 96.9532 28.4874 109.768 28.5146C122.508 28.5411 134.44 29.1564 143.406 30.2517C147.887 30.7994 151.445 31.4463 153.988 32.1734C155.795 32.6872 160.594 34.0642 160.63 38.2736Z"
          fill="#FFCE63"
        />
        <Path
          d="M156.517 36.2322C156.534 38.1891 135.759 39.7888 109.823 39.8057C83.5572 39.8233 62.0152 38.2141 62.0093 36.2124C62.0034 34.2106 83.5293 32.6102 109.785 32.6411C135.711 32.669 156.501 34.276 156.517 36.2322Z"
          fill="url(#paint0_linear_101_6256)"
        />
        <Path
          d="M156.517 36.2322C156.534 38.1891 135.759 39.7888 109.823 39.8057C83.5572 39.8233 62.0152 38.2141 62.0093 36.2124C62.0034 34.2106 83.5293 32.6102 109.785 32.6411C135.711 32.669 156.501 34.276 156.517 36.2322Z"
          fill="#FFCE63"
        />
        <Path
          d="M57.3181 115.661L56.046 115.124C56.046 115.124 54.5902 113.466 54.2722 114.22C53.9542 114.974 53.1837 116.967 54.3721 116.934C55.5605 116.901 56.7496 116.346 57.0838 116.599L57.3181 115.661Z"
          fill="#FBF6F3"
        />
        <Path
          d="M36.4077 95.6258L37.8671 94.3357C38.0066 94.2123 38.1169 94.0595 38.1902 93.8883C38.2635 93.717 38.2979 93.5316 38.2909 93.3455C38.2703 92.7956 38.3019 91.9914 38.6111 91.5687C39.1091 90.8887 40.9783 91.4422 41.0628 91.5687C41.43 92.1215 41.5615 93.0757 40.4539 93.4285C39.3463 93.7814 39.0584 94.3666 39.0584 94.3666L37.3052 96.8447L36.4077 95.6258Z"
          fill="#FBF6F3"
        />
        <Path
          d="M43.5101 210.167C43.3683 209.74 41.8942 209.543 41.278 210.23C40.9717 210.571 40.8153 211.196 41.0577 211.435C41.1451 211.522 40.8689 211.735 41.1568 211.698C42.1102 211.574 43.6518 210.592 43.5101 210.167Z"
          fill="#94CDDB"
        />
        <Path
          d="M42.05 210.537H40.5649C41.1246 209.628 40.634 207.058 40.634 207.058L42.2315 207.184C42.2315 207.184 42.158 207.919 42.003 209.011C41.9509 209.384 41.9847 209.952 42.05 210.537Z"
          fill="#FBF6F3"
        />
        <Path
          d="M45.8986 154.322C46.9414 157.772 47.7116 161.3 48.2019 164.871C50.0057 178.006 46.1718 178.425 46.8872 192.979C47.1163 197.625 42.8659 208.338 42.4914 208.575C42.2962 208.595 42.0999 208.603 41.9038 208.598C41.3961 208.58 40.8929 208.496 40.4069 208.348C39.7341 208.232 37.3067 201.652 37.8693 197.74C38.5472 193.026 37.7143 189.753 37.9215 186.056C38.4158 177.205 37.9516 167.856 37.3339 167.824C36.9439 167.802 36.2983 171.5 35.6196 175.382C34.8433 179.839 34.7162 181.877 33.0659 183.824C31.9509 185.137 30.6179 185.845 29.691 186.234C18.4403 190.938 20.0062 190.974 17.5531 193.003C17.1462 193.339 16.0452 194.286 15.2711 193.942C14.7518 193.712 14.599 193 14.5366 192.679C14.0225 190.125 15.6031 184.799 19.7778 182.802C21.2739 182.086 21.6874 182.464 23.1358 181.572C24.9294 180.464 26.211 178.655 26.7619 176.977C27.7321 174.025 26.2088 172.182 25.373 168.262C25.2122 167.51 25.4545 160.789 26.1809 156.353C27.124 150.548 45.8986 154.322 45.8986 154.322Z"
          fill="#1B4965"
        />
        <Path
          d="M42.1534 210.34C42.1534 210.34 40.3437 210.184 40.2027 210.56C40.0617 210.937 40.047 211.888 41.1575 211.7C42.268 211.513 42.2937 210.62 42.1534 210.34Z"
          fill="#94CDDB"
        />
        <Path
          d="M56.9671 115.369C56.8099 115.866 56.653 116.362 56.4963 116.858C57.6318 117.728 60.7562 120.327 60.3824 123.115C59.8411 127.144 52.3384 128.971 47.5864 128.961C46.2834 128.961 37.8238 128.941 33.8518 122.866C30.3608 117.529 32.5231 110.865 34.3064 105.37C35.3994 102.012 36.968 98.828 38.9644 95.9159L36.6024 93.9082C33.7475 95.6395 28.4189 99.4534 24.9779 106.302C21.8057 112.616 21.6235 118.751 21.6573 121.078C21.6992 123.966 22.1267 124.759 22.1979 128.936C22.264 132.791 21.9526 135.191 21.4781 139.676C19.8101 155.432 20.2185 158.254 21.4399 161.059C22.4682 163.422 23.3562 165.458 25.5126 166.681C29.8254 169.128 33.4361 165.045 42.8358 165.799C46.105 166.061 47.264 166.681 48.6058 165.741C49.3954 165.187 50.8467 163.673 50.3752 153.853C49.972 145.463 48.7527 143.235 50.5015 140.826C52.0344 138.714 53.6105 139.547 58.3354 137.159C61.4253 135.596 68.1039 132.22 68.6966 126.662C69.1255 122.637 66.1502 119.466 65.664 118.948C62.2516 115.313 57.7001 115.351 56.9671 115.369Z"
          fill="#94CDDB"
        />
        <Path
          d="M39.5265 122.695C39.5904 121.492 38.8001 120.568 38.6275 120.369C37.9026 119.538 37.7461 119.438 37.4612 119.329L37.0748 119.195L37.0308 119.189C36.795 119.161 36.0466 119.305 35.9034 119.371C35.4458 119.581 35.3723 121.658 36.1399 124.398C36.1435 124.509 36.1487 124.619 36.1538 124.731C36.1619 124.895 36.167 125.025 36.1707 125.129C36.1747 125.243 36.1536 125.356 36.109 125.46C36.0643 125.565 35.9971 125.658 35.9122 125.734C35.8273 125.809 35.7268 125.865 35.6179 125.897C35.509 125.93 35.3943 125.937 35.282 125.92C32.8267 125.546 33.166 126.141 33.2497 126.327C33.4458 126.773 35.719 128.028 38.4564 128.703C41.8533 129.495 43.9899 129.4 43.702 128.881C43.5933 128.686 41.9084 127.806 39.9158 127.146C39.6944 127.075 39.493 126.952 39.3279 126.788C39.1628 126.623 39.0386 126.423 38.9654 126.202C38.7678 125.594 38.3866 124.75 38.2963 124.495C38.4681 124.352 39.4795 123.582 39.5265 122.695Z"
          fill="#FBF6F3"
        />
        <Path
          d="M37.8951 118.183C38.0846 119.043 37.8856 120.051 37.713 120.245C37.6127 120.368 37.5333 120.506 37.4779 120.655C37.4642 120.691 37.4553 120.729 37.4515 120.767C37.3847 121.351 38.388 121.796 38.2763 122.075C38.1948 122.278 37.558 122.174 37.5227 122.341C37.4875 122.509 38.0413 122.686 38.0053 122.873C37.9781 123.015 37.652 122.965 37.5081 123.204C37.4346 123.324 37.4816 123.396 37.4493 123.719C37.4337 123.889 37.4027 124.058 37.3568 124.223C37.1731 124.794 36.374 125.167 36.1669 125.002C36.1096 124.955 36.1375 124.9 36.0494 124.721C35.9822 124.597 35.8984 124.482 35.8004 124.381C35.5617 124.131 35.0961 124.018 34.6047 123.808C33.694 123.419 33.373 122.985 33.2724 122.837C33.2364 122.784 33.2129 122.743 33.1953 122.714C32.8501 122.126 32.6407 121.197 32.7964 120.561C33.0586 119.496 34.2353 119.709 34.9022 118.562C35.6719 117.239 34.7318 115.877 35.2459 115.588C35.8122 115.271 37.544 116.594 37.8951 118.183Z"
          fill="#1B4965"
        />
        <Path
          d="M37.9224 121.942C37.647 121.7 37.3385 122.055 37.42 122.429C37.5016 122.803 37.9518 123.112 38.2867 122.959C38.6217 122.806 38.2956 122.268 37.9224 121.942Z"
          fill="#FBF6F3"
        />
        <Path
          d="M15.6738 193.552L14.7315 194.304L14.0962 193.614L14.9621 192.773C15.0446 192.692 15.1537 192.645 15.2686 192.64C15.3835 192.635 15.4963 192.672 15.5857 192.745L15.6775 192.818C15.7321 192.863 15.7761 192.919 15.8062 192.982C15.8363 193.046 15.8517 193.116 15.8514 193.186C15.851 193.256 15.8349 193.326 15.8042 193.389C15.7734 193.452 15.7289 193.508 15.6738 193.552Z"
          fill="#FBF6F3"
        />
        <Path
          d="M13.911 194.879C13.8883 194.182 13.5438 193.973 13.7076 193.636C13.7825 193.501 13.8972 193.393 14.0359 193.326C14.1746 193.259 14.3306 193.237 14.4824 193.262C14.8915 193.345 15.0649 193.856 15.1038 193.971C15.3689 194.755 14.7843 195.192 15.1082 195.837C15.2234 196.023 15.3029 196.23 15.3425 196.445C15.3616 196.572 15.4086 196.886 15.2742 196.969C15.1178 197.066 14.7983 196.805 14.4942 196.558C14.127 196.264 13.9463 196.117 13.8559 195.862C13.7333 195.513 13.9309 195.415 13.911 194.879Z"
          fill="#94CDDB"
        />
        <Path
          d="M33.3853 157.051C37.1194 155.377 41.2273 159.299 42.4663 157.978C43.875 156.478 38.2064 151.794 38.7594 145.366C39.0848 141.616 41.5468 137.072 45.2456 135.72C49.1015 134.312 52.1261 137.165 55.2527 134.979C56.9288 133.807 56.3052 132.815 58.2178 130.898C61.4921 127.617 65.0065 128.831 66.9279 126.634C67.6183 125.844 68.1449 124.563 67.9503 122.356C68.4916 123.579 68.8662 125.053 68.695 126.665C68.1023 132.223 61.4238 135.599 58.3338 137.161C53.609 139.55 52.0328 138.717 50.5 140.829C48.7512 143.238 49.9704 145.465 50.3736 153.856C50.8452 163.676 49.3939 165.19 48.6043 165.744C47.2624 166.684 46.1071 166.063 42.8343 165.802C33.433 165.05 29.8239 169.132 25.511 166.684C24.8032 166.282 24.1753 165.753 23.6587 165.124C26.0634 165.105 27.5749 164.42 28.5672 163.543C30.8624 161.516 30.5466 158.325 33.3853 157.051Z"
          fill="#94CDDB"
        />
        <Path
          d="M117.077 45.1168L120.083 47.2413C120.083 47.2413 120.157 40.6361 127.508 38.5917C134.859 36.5473 139.888 33.8133 138.591 28.1027L130.903 25.2725C130.903 25.2725 129.648 32.8003 124.48 34.1228C115.774 36.351 117.077 45.1168 117.077 45.1168Z"
          fill="#FD7064"
        />
        <Path
          d="M128.03 50.1859C127.852 46.8543 128.155 42.6875 130.785 40.868C133.362 39.0868 136.22 40.9166 140.384 40.0087C143.108 39.4147 146.714 37.5768 150.35 31.9824C152.437 36.1948 154.523 40.4069 156.609 44.6187C150.169 49.3677 146.015 49.6037 143.32 48.7355C140.106 47.7063 138.506 44.9547 135.883 45.406C133.446 45.8251 131.879 48.7039 130.919 51.1688L128.03 50.1859Z"
          fill="#94CDDB"
        />
        <Path
          d="M144.858 32.0591C144.025 30.2212 143.28 27.7953 144.365 26.1934C145.428 24.6202 147.445 25.0223 149.594 23.5932C151.001 22.6581 152.633 20.8269 153.455 16.8682L159.766 22.6221C157.175 26.7205 154.882 27.7681 153.17 27.8739C151.13 27.9996 149.622 26.8006 148.24 27.6335C146.957 28.4069 146.706 30.3763 146.705 31.9789L144.858 32.0591Z"
          fill="#A0C460"
        />
        <Path
          d="M157.159 38.6674C155.617 36.5716 158.14 31.5689 161.185 28.5012C166.8 22.8458 172.509 25.4585 177.638 20.5742C179.051 19.2274 180.583 17.1558 181.56 13.8241C182.079 12.0517 184.365 11.5695 185.573 12.9662L193.238 21.8291C191.859 30.3273 188.925 33.2678 186.469 34.3705C181.159 36.7458 175.925 31.4748 168.429 33.6553C164.355 34.8396 161.575 37.6537 159.893 39.7812C158.903 39.7297 157.766 39.4915 157.159 38.6674Z"
          fill="#FD7064"
        />
        <Path
          d="M142.357 18.0898C143.98 16.9511 146.6 16.6982 147.352 17.8355C148.035 18.8691 147.002 20.7951 145.892 21.8221C144.21 23.3777 141.248 23.8915 140.402 22.7712C139.611 21.7265 140.675 19.2712 142.357 18.0898Z"
          fill="#94CDDB"
        />
        <Path
          d="M176.756 40.3412C178.545 41.1925 180.056 43.3502 179.438 44.5646C178.876 45.6673 176.693 45.7195 175.251 45.2578C173.071 44.5602 171.164 42.2342 171.721 40.9455C172.241 39.7421 174.9 39.4591 176.756 40.3412Z"
          fill="#94CDDB"
        />
        <Path
          d="M106.763 44.689C106.749 42.3115 108.232 39.5305 109.803 39.543C111.231 39.5526 112.379 41.8675 112.623 43.6598C112.99 46.3747 111.533 49.671 109.915 49.7666C108.405 49.8556 106.777 47.1554 106.763 44.689Z"
          fill="#E09B22"
        />
        <Path
          d="M119.324 25.4551C120.945 24.3163 123.566 24.0634 124.318 25.2007C125.001 26.2343 123.969 28.1604 122.858 29.1881C121.177 30.7429 118.215 31.2568 117.368 30.1372C116.577 29.0918 117.642 26.6364 119.324 25.4551Z"
          fill="#A0C460"
        />
      </G>
    </Svg>
  );
};

export const ScoreFestival = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 618 184"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
    >
      <G>
        <Path
          d="M112.916 175.358C113.197 176.201 113.757 176.924 114.504 177.406C114.955 176.602 115.65 175.963 116.489 175.58C116.257 174.778 115.862 174.032 115.33 173.389C114.663 174.198 113.843 174.867 112.916 175.358Z"
          fill="#A0C460"
        />
        <Path
          d="M304.957 36.6511C305.097 36.9061 305.29 37.1285 305.523 37.3037C305.755 37.4788 306.022 37.6028 306.306 37.6674C306.966 36.9533 307.706 36.3191 308.513 35.7778C308.247 35.6008 308.029 35.3608 307.878 35.0791C306.987 35.7441 306.003 36.2739 304.957 36.6511Z"
          fill="#A0C460"
        />
        <Path
          d="M180.211 99.5823C181.823 102.245 184.251 104.316 187.134 105.489C189.157 104.636 191.299 104.1 193.486 103.901C191.898 102.488 191.644 101.011 192.152 97.9785C188.627 99.2171 185.086 99.3918 180.211 99.5823Z"
          fill="#FD7064"
        />
        <Path
          d="M159.521 136.786C158.785 137.113 157.954 137.158 157.187 136.913C157.413 138.15 157.842 139.341 158.457 140.438C159.197 140.297 159.897 139.993 160.505 139.549C159.978 138.712 159.642 137.768 159.521 136.786Z"
          fill="#FBF6F3"
        />
        <Path
          d="M398.833 32.6357C398.008 33.0313 397.112 33.258 396.197 33.3027C396.197 33.7863 396.359 34.256 396.658 34.6365C397.593 34.6142 398.52 34.4481 399.405 34.1442C398.865 33.5885 398.674 33.2233 398.833 32.6357Z"
          fill="#FFCE63"
        />
        <Path
          d="M446.232 174.467C446.668 175.227 447.336 175.828 448.137 176.182C448.719 175.963 449.328 175.824 449.948 175.769C449.487 175.356 449.44 174.943 449.614 174.086C448.516 174.4 447.373 174.529 446.232 174.467Z"
          fill="#A0C460"
        />
        <Path
          d="M130.954 139.644C130.959 140.615 131.282 141.558 131.875 142.328C132.64 141.628 133.608 141.189 134.638 141.073C134.67 140.157 134.513 139.243 134.178 138.39C133.191 139.006 132.098 139.431 130.954 139.644Z"
          fill="#FFCE63"
        />
        <Path
          d="M391.306 7.13339C391.426 6.69325 391.381 6.22465 391.179 5.81543C389.816 6.25343 388.386 6.44696 386.956 6.38707C387.09 6.79441 387.09 7.23418 386.956 7.64152C388.425 7.78147 389.908 7.60829 391.306 7.13339Z"
          fill="#FBF6F3"
        />
        <Path
          d="M85.7148 159.84C85.7223 160.453 85.8905 161.052 86.2026 161.579C86.5148 162.106 86.9599 162.541 87.4933 162.841C88.6498 162.596 89.6933 161.977 90.4627 161.079C89.952 159.675 89.8529 158.155 90.1768 156.696C88.9151 158.033 87.3978 159.102 85.7148 159.84Z"
          fill="#FD7064"
        />
        <Path
          d="M43.2544 32.2385C47.0331 32.625 50.5374 34.3885 53.0994 37.1928C55.2748 30.2537 56.6404 23.0605 56.2752 19.7259C52.8765 18.5989 49.2733 18.225 45.7156 18.6302C46.2238 22.4094 45.2075 26.0934 43.2544 32.2385Z"
          fill="#94CDDB"
        />
        <Path
          d="M346.02 70.6643C345.112 69.6881 343.964 68.9673 342.691 68.5744C341.417 68.1815 340.063 68.1301 338.763 68.4254C337.249 70.5056 336.472 73.0313 336.556 75.6027C339.509 77.1906 341.034 78.9691 343.304 82.3672C343.416 78.3236 344.339 74.3438 346.02 70.6643Z"
          fill="#FD7064"
        />
        <Path
          d="M507.192 126.322C510.018 124.48 511.098 121.781 511.733 117.176C505.638 115.848 499.932 113.131 495.06 109.236C494.425 112.571 492.932 114.603 489.217 118.049C494.574 122.017 500.694 124.834 507.192 126.322Z"
          fill="#FBF6F3"
        />
        <Path
          d="M570.184 53.3738C570.073 50.8014 568.818 49.1976 566.659 46.6729C561.307 51.5795 554.162 55.184 545.508 58.598C547.043 60.554 547.871 62.9715 547.858 65.4577C556.08 63.0763 563.694 58.9552 570.184 53.3738Z"
          fill="#94CDDB"
        />
        <Path
          d="M543.824 71.9845C544.172 72.4633 544.431 73.0014 544.586 73.5724C544.907 73.5208 545.2 73.3578 545.412 73.1119C545.277 72.5 545.052 71.9114 544.745 71.3652C544.444 71.8098 544.221 72.0163 543.824 71.9845Z"
          fill="#94CDDB"
        />
        <Path
          d="M560.195 40.5908C560.22 42.198 559.813 43.7823 559.017 45.1787C558.221 46.5751 557.065 47.7325 555.67 48.5303C559.687 50.674 562.831 51.1345 568.595 51.6109C571.184 49.6577 571.771 47.9269 572.041 44.243C567.055 43.7984 563.546 43.1315 560.195 40.5908Z"
          fill="#94CDDB"
        />
        <Path
          d="M218.003 113.523C218.022 113.892 218.137 114.249 218.338 114.558C218.539 114.868 218.817 115.119 219.146 115.286C219.833 115.114 220.442 114.717 220.877 114.159C220.553 113.314 220.475 112.394 220.655 111.507C219.916 112.352 219.014 113.038 218.003 113.523Z"
          fill="#FD7064"
        />
        <Path
          d="M55.958 120.796C59.8483 118.986 61.6903 116.684 62.7542 112.11C59.9913 108.538 57.4983 106.346 54.1637 105.394C50.575 108.569 47.288 109.713 41.4604 111.046C47.5104 113.921 51.1466 115.874 55.958 120.796Z"
          fill="#FFCE63"
        />
        <Path
          d="M259.368 90.3551C259.67 90.9744 260.146 91.2284 260.956 91.6095C261.927 89.6711 263.246 87.9272 264.846 86.4647C264.263 86.1652 263.802 85.6709 263.544 85.0674C261.793 86.5133 260.369 88.3159 259.368 90.3551Z"
          fill="#FFCE63"
        />
        <Path
          d="M234.898 178.295C233.518 178.974 232.401 180.091 231.722 181.471C233.243 182.018 234.55 183.036 235.454 184.377C236.773 183.746 237.95 182.855 238.915 181.757C237.367 180.871 236.003 179.695 234.898 178.295Z"
          fill="#FD7064"
        />
        <Path
          d="M419.809 44.085C419.595 43.8126 419.457 43.4882 419.41 43.145C419.362 42.8017 419.407 42.4521 419.539 42.1318C418.586 42.314 417.689 42.7164 416.919 43.3069C416.822 43.6005 416.806 43.915 416.873 44.2169C416.94 44.5188 417.088 44.7969 417.3 45.0218C418.026 44.4696 418.899 44.1437 419.809 44.085Z"
          fill="#FD7064"
        />
        <Path
          d="M535.314 -26.3382C532.963 -27.799 530.788 -27.6402 527.231 -27.275C528.343 -19.5578 527.231 -11.0467 524.992 -1.29695C527.625 -1.47353 530.241 -0.763592 532.424 0.719683C535.309 -7.98958 536.294 -17.216 535.314 -26.3382Z"
          fill="#A0C460"
        />
        <Path
          d="M167.572 29.4914C168.359 29.47 169.131 29.265 169.826 28.8929C170.521 28.5208 171.119 27.9917 171.573 27.3477C169.727 25.3012 168.379 22.8557 167.635 20.2021C166.412 21.2401 164.857 21.8037 163.252 21.79C164.142 24.6291 165.613 27.2518 167.572 29.4914Z"
          fill="#FBF6F3"
        />
        <Path
          d="M493.663 62.3936C493.396 62.6742 493.209 63.0204 493.12 63.3969C493.03 63.7734 493.042 64.1669 493.155 64.5372C493.785 64.9309 494.526 65.1093 495.266 65.0454C495.666 64.193 496.299 63.4717 497.093 62.9652C495.922 63.0123 494.755 62.8177 493.663 62.3936Z"
          fill="#FBF6F3"
        />
        <Path
          d="M85.6829 98.8987C85.8258 99.6133 85.6829 100.36 84.7778 101.852C85.5105 102.144 86.3172 102.194 87.0803 101.995C87.5822 101.014 87.828 99.9212 87.7948 98.8193C87.1179 99.0729 86.377 99.1008 85.6829 98.8987Z"
          fill="#FBF6F3"
        />
        <Path
          d="M396.737 21.139C398.167 24.61 400.708 27.5085 403.962 29.3802C405.599 25.801 408.351 22.8484 411.806 20.9643C410.552 17.6334 408.634 14.5919 406.169 12.0244C403.645 15.6447 400.442 18.7402 396.737 21.139Z"
          fill="#FFCE63"
        />
        <Path
          d="M242.806 18.0596C240.28 20.6475 238.679 23.9963 238.249 27.587C242.063 27.668 245.749 28.9766 248.761 31.3185C251.251 28.9385 253.229 26.0746 254.573 22.9027C250.376 22.0585 246.381 20.4142 242.806 18.0596Z"
          fill="#FD7064"
        />
        <Path
          d="M289.173 91.5459C289.557 92.5049 290.243 93.3129 291.126 93.8484C291.838 93.6761 292.57 93.6066 293.301 93.6419C292.841 93.102 292.857 92.5939 293.19 91.6253C291.856 91.8185 290.499 91.7917 289.173 91.5459Z"
          fill="#A0C460"
        />
        <Path
          d="M513.972 24.4582C514.579 24.5017 515.146 24.7741 515.56 25.2204C515.871 24.3328 516.027 23.3981 516.02 22.4575C515.507 22.2975 514.966 22.2488 514.432 22.3146C514.447 23.0552 514.29 23.7892 513.972 24.4582Z"
          fill="#94CDDB"
        />
        <Path
          d="M438.737 6.80027C439.019 6.85678 439.28 6.9885 439.492 7.18143C439.705 7.37436 439.861 7.62128 439.944 7.89592C440.446 7.26875 440.799 6.53575 440.976 5.75225C440.875 5.5192 440.714 5.31636 440.511 5.16335C440.308 5.01035 440.069 4.91237 439.817 4.87891C439.655 5.61207 439.279 6.28073 438.737 6.80027Z"
          fill="#FBF6F3"
        />
        <Path
          d="M163.824 180.69C165.109 178.627 166.787 176.836 168.762 175.418C168.064 174.337 167.033 173.513 165.825 173.068C163.767 174.495 161.936 176.224 160.394 178.197C162.379 178.61 163.332 179.166 163.824 180.69Z"
          fill="#FD7064"
        />
        <Path
          d="M339.477 0.973633C338.737 1.62479 337.819 2.03956 336.841 2.16456C336.914 2.33532 336.951 2.51893 336.951 2.70445C336.951 2.88996 336.914 3.07357 336.841 3.24433C337.938 3.17423 338.994 2.80036 339.89 2.16456C339.86 1.73802 339.718 1.32703 339.477 0.973633Z"
          fill="#FD7064"
        />
        <Path
          d="M179.1 154.379C178.285 153.787 177.599 153.036 177.083 152.172C176.614 152.427 176.24 152.829 176.019 153.315C176.533 154.208 177.181 155.017 177.94 155.713C178.179 154.824 178.433 154.458 179.1 154.379Z"
          fill="#FD7064"
        />
        <Path
          d="M298.891 144.851C294.953 143.406 293.015 142.437 290.681 139.754C290.385 140.296 289.979 140.771 289.49 141.148C289.001 141.525 288.439 141.797 287.839 141.945C290.049 144.859 293.03 147.098 296.445 148.408C297.558 147.457 298.401 146.23 298.891 144.851Z"
          fill="#94CDDB"
        />
        <Path
          d="M400.024 51.1654C400.389 48.4977 401.85 45.9571 406.995 41.8603C404.787 39.8842 402.005 38.6657 399.055 38.3828C395.977 41.2651 393.691 44.8904 392.418 48.9106C395.13 48.8242 397.797 49.615 400.024 51.1654Z"
          fill="#94CDDB"
        />
        <Path
          d="M74.6313 66.3783C75.5188 67.1052 76.2529 68.0012 76.7909 69.0142C77.3414 68.7635 77.7896 68.3321 78.0612 67.7916C77.545 66.7426 76.8641 65.783 76.0446 64.9492C75.6952 65.8384 75.3777 66.2513 74.6313 66.3783Z"
          fill="#FFCE63"
        />
        <Path
          d="M540.569 114.904C541.089 115.464 541.479 116.13 541.713 116.857C542.718 115.727 543.872 114.739 545.142 113.92C545.11 113.164 544.792 112.449 544.253 111.919C542.906 112.758 541.669 113.76 540.569 114.904Z"
          fill="#FBF6F3"
        />
        <Path
          d="M259.273 146.44C258.621 146.463 257.978 146.286 257.431 145.932C257.32 146.249 257.209 146.424 257.018 146.503C257.6 146.938 258.294 147.197 259.019 147.25C259.169 147.005 259.257 146.727 259.273 146.44Z"
          fill="#FD7064"
        />
        <Path
          d="M209.905 73.5701C210.528 73.3357 211.203 73.2724 211.859 73.3869C212.516 73.5014 213.129 73.7894 213.636 74.2211C213.855 72.3781 213.648 70.5097 213.033 68.7587C212.552 68.415 211.989 68.2045 211.401 68.1487C210.812 68.093 210.219 68.1938 209.683 68.4412C210.265 70.0907 210.342 71.8764 209.905 73.5701Z"
          fill="#FD7064"
        />
        <Path
          d="M612.454 28.1729C612.239 28.442 612.088 28.7558 612.011 29.091C611.935 29.4263 611.934 29.7745 612.009 30.1101C613.098 30.4668 614.138 30.9575 615.105 31.571C615.166 31.2003 615.319 30.8508 615.55 30.5547C614.406 29.9174 613.363 29.1148 612.454 28.1729Z"
          fill="#FD7064"
        />
        <Path
          d="M381.303 85.529C381.733 86.2541 382.353 86.8472 383.097 87.2439C383.549 86.9958 383.907 86.605 384.113 86.1324C383.381 85.7753 382.768 85.2124 382.351 84.5127C382.27 84.7536 382.133 84.9716 381.95 85.1484C381.768 85.3252 381.546 85.4557 381.303 85.529Z"
          fill="#A0C460"
        />
        <Path
          d="M543.602 18.7584C544.873 15.4555 547.509 12.6767 555.289 9.02452C553.063 5.8319 549.875 3.43402 546.191 2.18066C540.776 5.7058 537.838 8.23057 534.551 13.5659C538.299 14.2963 540.252 15.6619 543.602 18.7584Z"
          fill="#FBF6F3"
        />
        <Path
          d="M344.924 53.1044C344.924 52.6915 344.67 52.4534 344.305 52.0723C343.377 52.9521 342.302 53.6616 341.129 54.1683C341.381 54.4622 341.532 54.8299 341.558 55.2163C342.816 54.7568 343.963 54.0372 344.924 53.1044Z"
          fill="#FBF6F3"
        />
        <Path
          d="M197.837 8.29196C199.093 8.26843 200.322 7.91592 201.4 7.26955C202.479 6.62317 203.369 5.70552 203.982 4.60803C203.475 2.23099 202.19 0.0908853 200.33 -1.47363C197.408 -0.362102 195.153 -0.457376 191.326 -0.997262C194.106 1.6236 196.322 4.7846 197.837 8.29196Z"
          fill="#A0C460"
        />
        <Path
          d="M179.465 168.085C179.235 171.087 179.993 174.081 181.624 176.612C183.694 177.051 185.685 177.801 187.531 178.835C187.039 176.818 187.706 175.548 189.786 173.452C186.079 172.229 182.594 170.417 179.465 168.085Z"
          fill="#FFCE63"
        />
        <Path
          d="M377.889 91.1801C379.089 90.4995 380.04 89.4537 380.604 88.1949C380.235 87.2889 380.015 86.3289 379.953 85.3525C379.302 86.0512 378.635 86.1147 377.301 85.8448C377.781 87.5804 377.98 89.3817 377.889 91.1801Z"
          fill="#FD7064"
        />
        <Path
          d="M235.724 152.933C236.014 153.066 236.263 153.275 236.444 153.538C236.626 153.8 236.734 154.107 236.756 154.426C237.429 153.874 237.971 153.18 238.344 152.393C238.303 152.114 238.189 151.851 238.014 151.63C237.838 151.41 237.606 151.24 237.343 151.139C236.991 151.882 236.427 152.506 235.724 152.933Z"
          fill="#A0C460"
        />
        <Path
          d="M270.277 160.73C269.854 159.563 269.069 158.562 268.038 157.872C267.182 158.055 266.304 158.103 265.434 158.015C265.958 158.698 265.91 159.301 265.434 160.444C267.053 160.269 268.69 160.365 270.277 160.73Z"
          fill="#A0C460"
        />
        <Path
          d="M157.059 160.526C157.808 163.328 157.497 166.308 156.186 168.895C161.728 168.561 167.301 167.593 169.509 166.386C169.392 163.661 168.682 160.995 167.428 158.573C164.808 159.986 161.966 160.256 157.059 160.526Z"
          fill="#A0C460"
        />
        <Path
          d="M246.744 122.368C249.697 124.988 253.095 127.56 257.7 127.989C260.114 126.197 262.793 124.794 265.64 123.829C263.051 122.463 262.321 120.573 262.051 116.413C257.795 119.24 253.111 120.589 246.744 122.368Z"
          fill="#FFCE63"
        />
        <Path
          d="M433.164 1.24223C433.291 1.88172 433.291 2.53997 433.164 3.17947C433.488 3.28725 433.839 3.28725 434.164 3.17947C434.312 2.52357 434.36 1.84902 434.307 1.17871C433.783 1.38514 433.497 1.44865 433.164 1.24223Z"
          fill="#FBF6F3"
        />
        <Path
          d="M461.572 87.5767C461.199 88.5589 461.199 89.6433 461.572 90.6255C464.766 89.8801 468.069 89.7187 471.321 90.1491C471.122 89.1823 471.251 88.1767 471.686 87.2909C468.332 86.6738 464.886 86.7712 461.572 87.5767Z"
          fill="#A0C460"
        />
        <Path
          d="M100.212 136.357C101.001 136.692 101.714 137.184 102.308 137.802C102.78 136.182 103.469 134.633 104.357 133.197C103.958 132.454 103.295 131.887 102.499 131.609C101.549 133.094 100.781 134.688 100.212 136.357Z"
          fill="#FBF6F3"
        />
        <Path
          d="M434.164 85.2254C434.748 85.656 435.194 86.246 435.45 86.9245C435.554 86.8357 435.676 86.77 435.808 86.7317C435.939 86.6933 436.077 86.6833 436.212 86.7022C435.988 85.9273 435.554 85.2295 434.958 84.6855C434.654 84.799 434.381 84.9842 434.164 85.2254Z"
          fill="#FFCE63"
        />
        <Path
          d="M105.675 76.5727C109.168 74.8419 113.376 74.556 122.411 77.3825C123.005 73.1326 122.208 68.8047 120.141 65.0445C113.122 63.8695 108.851 63.7266 102.213 65.6003C104.706 69.0301 105.262 71.5867 105.675 76.5727Z"
          fill="#FBF6F3"
        />
        <Path
          d="M281.392 151.934C281.503 152.537 281.392 153.173 280.534 154.379C281.142 154.65 281.82 154.722 282.471 154.586C282.926 153.764 283.166 152.841 283.17 151.902C282.596 152.105 281.972 152.116 281.392 151.934Z"
          fill="#94CDDB"
        />
        <Path
          d="M555.702 44.354C556.478 40.6004 558.054 37.0583 560.323 33.9691C551.066 32.7147 544.936 31.3967 538.362 28.6973C535.379 31.0578 533.404 34.4632 532.836 38.2247C537.537 40.3683 545.905 42.6867 555.702 44.354Z"
          fill="#FBF6F3"
        />
        <Path
          d="M321.502 138.31C318.64 137.716 315.935 136.526 313.563 134.816C313.029 140.593 311.715 146.272 309.657 151.696C311.475 153.955 314.077 155.446 316.945 155.872C319.165 150.222 320.695 144.326 321.502 138.31Z"
          fill="#FD7064"
        />
        <Path
          d="M545.746 93.1341C546.172 92.5947 546.411 91.9316 546.428 91.2445C545.714 91.2978 545.001 91.1197 544.396 90.7363C543.972 91.2277 543.653 91.8005 543.459 92.4195C544.262 92.4981 545.041 92.7414 545.746 93.1341Z"
          fill="#A0C460"
        />
        <Path
          d="M406.582 155.381C411.568 153.921 414.22 153.476 418.539 154.46C418.433 153.699 418.488 152.924 418.702 152.185C418.915 151.446 419.282 150.761 419.777 150.173C415.204 148.792 411.838 148.95 406.407 150.03C405.986 151.798 406.046 153.645 406.582 155.381Z"
          fill="#FBF6F3"
        />
        <Path
          d="M288.665 0.528359C288.724 0.0118487 288.661 -0.511291 288.482 -0.999289C288.303 -1.48729 288.012 -1.92663 287.633 -2.28223C286.124 -1.25107 284.394 -0.587607 282.583 -0.344987C283.175 0.548209 283.423 1.62571 283.282 2.6879C285.205 2.34356 287.037 1.60858 288.665 0.528359Z"
          fill="#FBF6F3"
        />
        <Path
          d="M574.36 42.276C575.738 42.5072 577.029 43.1055 578.097 44.008C579.164 44.9106 579.968 46.0839 580.426 47.4049C582.903 44.3085 583.792 41.7043 585.189 36.8453C583.935 34.3206 582.553 33.4949 579.441 32.7168C578.203 36.8771 577.075 39.7671 574.36 42.276Z"
          fill="#94CDDB"
        />
        <Path
          d="M261.337 34.3822C262.986 33.9381 264.545 33.2071 265.941 32.2226C265.337 31.3631 264.508 30.6872 263.544 30.2695C262.791 31.0246 261.807 31.5055 260.749 31.6351C261.045 32.0206 261.251 32.4672 261.353 32.9424C261.454 33.4176 261.449 33.9094 261.337 34.3822Z"
          fill="#A0C460"
        />
        <Path
          d="M343.146 39.1616C343.915 40.8407 345.223 42.2152 346.861 43.0678C347.604 41.2656 348.914 39.7547 350.593 38.7646C349.913 37.1564 348.914 35.7031 347.655 34.4932C346.471 36.3287 344.939 37.9146 343.146 39.1616Z"
          fill="#A0C460"
        />
        <Path
          d="M207.682 21.5993C208.061 21.6195 208.439 21.5408 208.778 21.371C209.118 21.2012 209.408 20.9461 209.619 20.6306C209.525 19.9017 209.19 19.2252 208.666 18.7093C207.766 18.9351 206.821 18.9077 205.935 18.6299C206.712 19.4916 207.306 20.5017 207.682 21.5993Z"
          fill="#94CDDB"
        />
        <Path
          d="M480.404 41.6379C480.029 40.9137 479.812 40.118 479.768 39.3037C478.425 40.195 476.966 40.9001 475.433 41.3997C475.259 42.1858 475.389 43.0088 475.799 43.7022C477.41 43.1995 478.956 42.5065 480.404 41.6379Z"
          fill="#A0C460"
        />
        <Path
          d="M578.473 126.148C578.057 126.863 577.885 127.693 577.98 128.514C578.44 128.874 578.842 129.303 579.171 129.785C579.298 129.213 579.616 128.975 580.378 128.721C579.61 127.97 578.967 127.102 578.473 126.148Z"
          fill="#FD7064"
        />
        <Path
          d="M315.659 4.95898C315.676 5.66816 315.921 6.35299 316.358 6.9121C316.861 6.97516 317.353 7.1088 317.819 7.30908C317.644 6.84859 317.819 6.53101 318.232 5.97524C317.324 5.77984 316.455 5.4365 315.659 4.95898Z"
          fill="#A0C460"
        />
        <Path
          d="M378.476 187.155C378.23 185.881 378.23 184.571 378.476 183.296C377.814 183.113 377.109 183.158 376.475 183.423C376.172 184.723 376.065 186.062 376.158 187.393C377.158 186.853 377.73 186.726 378.476 187.155Z"
          fill="#FFCE63"
        />
        <Path
          d="M216.431 150.38C216.971 150.653 217.592 150.721 218.178 150.57C217.98 148.686 218.125 146.781 218.606 144.949C218.046 144.99 217.488 144.844 217.019 144.536C216.409 146.42 216.208 148.412 216.431 150.38Z"
          fill="#94CDDB"
        />
        <Path
          d="M239.709 69.6332C240.266 70.1942 240.991 70.5568 241.774 70.6653C241.807 69.8432 242.102 69.0532 242.615 68.4105C242.125 67.8359 241.519 67.3706 240.837 67.0449C240.645 67.9767 240.261 68.8582 239.709 69.6332Z"
          fill="#A0C460"
        />
        <Path
          d="M305.703 168.672C305.885 168.484 306.019 168.254 306.091 168.001C306.163 167.749 306.171 167.483 306.116 167.227C305.201 167.195 304.305 166.956 303.495 166.528C303.478 167.063 303.263 167.572 302.892 167.957C303.771 168.382 304.727 168.625 305.703 168.672Z"
          fill="#FD7064"
        />
        <Path
          d="M293.81 111.063C295.234 111.35 296.54 112.058 297.557 113.096C297.675 112.85 297.841 112.631 298.046 112.451C298.251 112.271 298.489 112.134 298.748 112.048C297.685 110.847 296.311 109.962 294.778 109.491C294.327 109.924 293.994 110.465 293.81 111.063Z"
          fill="#A0C460"
        />
        <Path
          d="M576.487 73.3959C577.434 73.3141 578.388 73.4387 579.282 73.7611C578.93 71.9146 578.834 70.0285 578.996 68.1558C578.227 67.6101 577.279 67.3774 576.345 67.5048C576.155 69.4671 576.203 71.4451 576.487 73.3959Z"
          fill="#A0C460"
        />
        <Path
          d="M499.109 88.3239C499.532 87.8515 500.045 87.4682 500.618 87.1965C500.486 86.8847 500.258 86.6232 499.967 86.4502C499.39 86.7279 498.855 87.0861 498.379 87.5141C498.839 87.6888 499.046 87.9111 499.109 88.3239Z"
          fill="#FD7064"
        />
        <Path
          d="M386.289 105.458C387.817 105.354 389.304 104.914 390.643 104.171C391.982 103.427 393.141 102.397 394.038 101.155C392 96.4858 390.519 91.5933 389.623 86.5781C388.243 87.5027 386.644 88.0501 384.987 88.166C386.288 93.8318 386.727 99.6615 386.289 105.458Z"
          fill="#A0C460"
        />
        <Path
          d="M464.032 66.4248C461.615 67.3288 459.562 69.0027 458.189 71.1885C460.629 72.3961 462.616 74.3555 463.858 76.7779C466.206 76.0009 468.369 74.7467 470.209 73.094C467.736 71.2941 465.638 69.0287 464.032 66.4248Z"
          fill="#A0C460"
        />
        <Path
          d="M338.096 162.05C338.072 163.233 337.608 164.366 336.794 165.226C338.575 165.722 340.428 165.91 342.272 165.781C342.514 164.704 342.514 163.587 342.272 162.51C340.863 162.661 339.438 162.503 338.096 162.05Z"
          fill="#FBF6F3"
        />
        <Path
          d="M290.602 58.8672C290.602 60.7409 289.76 62.5829 286.568 65.8063C288.242 66.99 290.252 67.6025 292.301 67.553C294.183 65.3311 295.462 62.6628 296.016 59.804C294.158 60.0942 292.255 59.765 290.602 58.8672Z"
          fill="#FFCE63"
        />
        <Path
          d="M60.1972 149.251C60.086 147.25 59.0857 146.075 57.3866 144.074C53.2898 147.933 47.7798 150.807 41.0947 153.602C42.2891 155.09 42.954 156.934 42.9843 158.842C49.3352 156.897 55.2017 153.628 60.1972 149.251Z"
          fill="#FBF6F3"
        />
        <Path
          d="M301.622 62.0583C303.924 58.2791 306.1 53.9442 305.687 48.8311C303.233 46.5212 301.154 43.8425 299.526 40.8916C298.525 44.0674 296.588 45.2107 292.031 46.3222C295.969 50.4508 298.398 55.3733 301.622 62.0583Z"
          fill="#FBF6F3"
        />
        <Path
          d="M171.16 76.5737C171.221 76.888 171.349 77.1856 171.535 77.4459C171.722 77.7063 171.962 77.9233 172.24 78.0822C173.16 77.5406 174.141 77.1089 175.162 76.796C174.934 76.5344 174.78 76.2163 174.717 75.875C173.572 76.2808 172.374 76.5163 171.16 76.5737Z"
          fill="#94CDDB"
        />
        <Path
          d="M456.061 103.899C453.975 105.767 451.374 106.962 448.598 107.329C448.843 107.798 448.989 108.311 449.028 108.839C449.066 109.366 448.995 109.895 448.82 110.394C451.934 110.16 454.921 109.06 457.443 107.218C457.275 106.012 456.799 104.869 456.061 103.899Z"
          fill="#FBF6F3"
        />
        <Path
          d="M201.076 97.2149C200.034 96.7066 199.101 96 198.329 95.1348C197.844 95.5437 197.509 96.1023 197.376 96.7227C198.136 97.6328 199.036 98.4155 200.044 99.041C200.171 97.9295 200.377 97.4531 201.076 97.2149Z"
          fill="#FD7064"
        />
        <Path
          d="M566.659 3.84647C568.397 4.14266 570.182 3.97572 571.835 3.36245C573.488 2.74918 574.951 1.71122 576.075 0.353082C575.662 -3.7437 574.805 -6.63368 572.693 -8.98378C568.358 -8.23746 565.277 -8.98378 560.164 -10.7305C563.293 -6.3612 565.503 -1.40203 566.659 3.84647Z"
          fill="#FD7064"
        />
        <Path
          d="M458.983 64.6944C458.318 64.2351 457.746 63.653 457.3 62.9795C456.929 63.196 456.644 63.532 456.49 63.9322C456.917 64.6318 457.453 65.2589 458.078 65.7901C458.284 65.139 458.475 64.8373 458.983 64.6944Z"
          fill="#FBF6F3"
        />
        <Path
          d="M278.55 73.5563C280.383 71.6916 281.569 69.2867 281.932 66.6966C280.799 65.2263 279.894 63.5936 279.248 61.8535C278.438 63.4414 277.279 63.9495 274.691 64.156C276.479 67.059 277.783 70.234 278.55 73.5563Z"
          fill="#FBF6F3"
        />
        <Path
          d="M438.88 15.5195C436.736 17.6791 433.687 18.9494 426.272 19.1399C426.909 22.427 428.578 25.4252 431.036 27.6987C435.803 27.2244 440.365 25.5229 444.279 22.7604C441.516 20.8708 440.452 19.1241 438.88 15.5195Z"
          fill="#A0C460"
        />
        <Path
          d="M309.005 124.099C312.277 125.592 315.357 125.052 319.851 123.003C317.601 116.738 316.824 110.039 317.58 103.424C314.198 104.742 311.514 104.536 306.29 103.139C305.753 110.238 306.677 117.371 309.005 124.099Z"
          fill="#FFCE63"
        />
        <Path
          d="M435.863 23.8711C436.719 24.5725 437.719 25.0781 438.791 25.3524C439.864 25.6267 440.983 25.6631 442.071 25.459C443.321 21.988 444.979 18.6779 447.01 15.5981C445.842 15.3775 444.749 14.8639 443.834 14.1055C441.69 17.7475 439.002 21.0407 435.863 23.8711Z"
          fill="#94CDDB"
        />
        <Path
          d="M312.769 68.0127C313.093 72.0614 314.714 75.8979 317.39 78.9533C320.259 79.1168 323.086 79.7165 325.774 80.7318C324.694 78.1276 325.329 76.2857 327.711 73.0463C322.884 72.5382 318.581 70.6327 312.769 68.0127Z"
          fill="#FBF6F3"
        />
        <Path
          d="M517.656 13.8673C519.244 9.48466 518.926 6.29298 516.243 1.94213C511.368 1.30697 507.763 1.5134 504.46 3.33948C504.143 8.59544 502.444 11.9618 498.998 17.44C505.858 15.0423 510.161 13.772 517.656 13.8673Z"
          fill="#FBF6F3"
        />
        <Path
          d="M530.867 30.6657C530.16 30.4057 529.383 30.4057 528.676 30.6657C529.17 32.979 529.235 35.3634 528.866 37.7001C529.571 37.5702 530.298 37.6821 530.931 38.0177C531.431 35.5903 531.41 33.0841 530.867 30.6657Z"
          fill="#A0C460"
        />
        <Path
          d="M189.389 56.6282C188.244 55.8519 186.881 55.4624 185.498 55.5167C184.847 56.2482 184.086 56.8749 183.244 57.3746C184.165 57.6445 184.514 58.2003 184.832 59.5182C186.182 58.3113 187.721 57.3349 189.389 56.6282Z"
          fill="#A0C460"
        />
        <Path
          d="M272.341 71.3164C271.689 71.8473 271.231 72.5786 271.039 73.3966C271.349 73.8865 271.579 74.4224 271.721 74.9845C272.039 74.4922 272.436 74.3811 273.309 74.3969C272.817 73.4311 272.49 72.39 272.341 71.3164Z"
          fill="#FD7064"
        />
        <Path
          d="M133.828 54.6926C134.035 59.5833 134.701 63.4736 136.909 66.9035C139.521 67.0967 142.121 66.3907 144.277 64.9028C142.127 61.2641 141.105 57.07 141.339 52.8506C138.56 54.7719 136.655 55.4865 133.828 54.6926Z"
          fill="#94CDDB"
        />
        <Path
          d="M579.251 26.2357C579.918 26.1087 580.267 25.7276 580.839 25.0766C579.26 23.6729 577.957 21.9874 576.996 20.1064C576.577 20.561 576.018 20.8627 575.408 20.9639C576.298 22.9757 577.608 24.7733 579.251 26.2357Z"
          fill="#FFCE63"
        />
        <Path
          d="M302.209 -1.60059C301.417 -0.474166 300.831 0.783902 300.479 2.1151C301.295 2.3364 302.155 2.3364 302.972 2.1151C303.042 1.25064 303.4 0.434651 303.988 -0.203233C303.606 -0.289581 303.249 -0.459775 302.941 -0.701468C302.633 -0.943161 302.383 -1.25029 302.209 -1.60059Z"
          fill="#FD7064"
        />
        <Path
          d="M74.1865 111.03C74.3216 111.263 74.5049 111.464 74.7239 111.62C74.943 111.776 75.1929 111.884 75.4568 111.935C76.0579 111.257 76.7345 110.65 77.4735 110.125C77.2219 109.975 77.0139 109.761 76.8701 109.506C76.0597 110.15 75.1544 110.664 74.1865 111.03Z"
          fill="#FD7064"
        />
        <Path
          d="M147.611 8.29465C147.872 8.39034 148.152 8.42296 148.428 8.38984C148.704 8.35672 148.968 8.25881 149.199 8.1041C148.842 7.17971 148.706 6.18457 148.802 5.19824C148.259 5.3988 147.662 5.3988 147.119 5.19824C147.072 6.25301 147.24 7.30627 147.611 8.29465Z"
          fill="#A0C460"
        />
        <Path
          d="M465.319 3.41797C463.356 5.43653 461.978 7.95018 461.333 10.6906C462.504 11.9685 464.08 12.8041 465.795 13.0565C466.396 10.3408 467.782 7.86162 469.781 5.92685C468.886 5.91768 468.008 5.68297 467.228 5.24442C466.448 4.80588 465.791 4.17768 465.319 3.41797Z"
          fill="#94CDDB"
        />
        <Path
          d="M241.028 81.8916C241.009 82.5953 240.777 83.2766 240.361 83.8447C240.694 83.9876 240.885 84.1305 240.964 84.337C241.467 83.7356 241.787 83.0026 241.885 82.2251C241.639 82.0317 241.34 81.9157 241.028 81.8916Z"
          fill="#FFCE63"
        />
        <Path
          d="M117.854 20.6932C117.454 20.512 117.017 20.4277 116.578 20.447C116.14 20.4664 115.712 20.5887 115.329 20.8043C115.76 22.2842 115.847 23.843 115.583 25.3616C116.453 25.1147 117.383 25.188 118.203 25.568C118.419 23.9362 118.3 22.2776 117.854 20.6932Z"
          fill="#FBF6F3"
        />
        <Path
          d="M363.852 126.925C364.815 127.14 365.665 127.706 366.233 128.513C366.913 127.126 367.353 125.633 367.535 124.099C366.691 123.721 365.777 123.527 364.852 123.527C364.773 124.72 364.431 125.88 363.852 126.925Z"
          fill="#FFCE63"
        />
        <Path
          d="M144.642 161.287C143.891 161.86 143.032 162.276 142.117 162.51C142.226 163.001 142.488 163.445 142.864 163.78C143.803 163.551 144.702 163.181 145.531 162.684C144.88 162.319 144.61 161.906 144.642 161.287Z"
          fill="#94CDDB"
        />
        <Path
          d="M383.939 32.6826C382.374 33.7247 380.559 34.3275 378.682 34.4281C376.805 34.5286 374.935 34.1232 373.268 33.2543C373.697 38.5578 375.221 41.9401 378.381 47.9265C381.954 49.2444 384.066 48.7839 387.813 46.672C385.082 41.5272 383.526 37.6369 383.939 32.6826Z"
          fill="#94CDDB"
        />
        <Path
          d="M140.005 64.1084C140.051 65.1452 139.87 66.1795 139.475 67.1393C139.08 68.0991 138.481 68.9613 137.719 69.6661C142.681 72.2737 147.999 74.1408 153.502 75.2078C155.081 73.2593 156.092 70.9132 156.424 68.4275C149.819 68.4275 145.754 66.9507 140.005 64.1084Z"
          fill="#94CDDB"
        />
        <Path
          d="M27.4707 96.0565C27.5819 96.4376 27.82 96.6123 28.2329 96.8981C28.9452 95.9084 29.8333 95.058 30.8529 94.3892C30.5605 94.1694 30.3529 93.8552 30.2654 93.5C29.1619 94.1428 28.209 95.0145 27.4707 96.0565Z"
          fill="#94CDDB"
        />
        <Path
          d="M189.373 124.069C188.862 123.952 188.329 123.971 187.827 124.124C187.326 124.277 186.873 124.559 186.515 124.942C186.477 125.961 186.785 126.962 187.388 127.784C188.664 127.668 189.947 127.916 191.088 128.499C190.224 127.153 189.64 125.646 189.373 124.069Z"
          fill="#FFCE63"
        />
        <Path
          d="M413.982 99.5166C408.135 100.484 402.503 102.467 397.34 105.376C399.143 108.542 401.765 111.164 404.93 112.966C407.725 110.457 410.568 109.79 415.061 109.203C414.171 107.771 413.613 106.158 413.426 104.482C413.239 102.806 413.429 101.11 413.982 99.5166Z"
          fill="#A0C460"
        />
        <Path
          d="M378.318 118.733C378.537 117.711 379.063 116.78 379.826 116.065C379.48 115.87 379.219 115.553 379.096 115.176C378.204 115.921 377.53 116.891 377.143 117.986C377.465 118.33 377.87 118.586 378.318 118.733Z"
          fill="#FD7064"
        />
        <Path
          d="M421.016 26.8713C421.528 26.5348 422.109 26.3177 422.715 26.2361C421.959 25.2609 421.33 24.1938 420.842 23.0603C420.242 22.9885 419.637 23.1412 419.143 23.4891C419.635 24.6847 420.264 25.8196 421.016 26.8713Z"
          fill="#FFCE63"
        />
        <Path
          d="M163.506 101.979C158.663 97.5803 156.424 95.0555 154.646 89.8154C152.439 91.181 150.866 91.705 149.231 91.3081C150.819 97.1039 153.153 100.581 157.901 105.599C160.057 104.909 161.991 103.66 163.506 101.979Z"
          fill="#FBF6F3"
        />
        <Path
          d="M195.693 14.6455C190.829 10.9724 185.358 8.18288 179.528 6.4043C178.436 10.0165 178.337 13.8561 179.242 17.5196C183.085 17.8213 185.594 19.4886 189.23 22.4103C189.659 20.7155 190.462 19.1383 191.58 17.7946C192.699 16.4509 194.104 15.3749 195.693 14.6455Z"
          fill="#94CDDB"
        />
        <Path
          d="M139.402 103.694C139.178 103.623 138.972 103.508 138.795 103.355C138.617 103.202 138.473 103.015 138.37 102.805C137.459 103.685 136.679 104.69 136.051 105.79C136.362 106.266 136.796 106.65 137.306 106.901C137.71 105.666 138.433 104.56 139.402 103.694Z"
          fill="#FBF6F3"
        />
        <Path
          d="M84.7462 5.45093C84.0797 5.22064 83.3639 5.17132 82.6721 5.30801C81.9803 5.44471 81.3371 5.76251 80.8082 6.229C80.6183 7.57268 80.8809 8.94135 81.5545 10.1194C83.2483 10.1625 84.8971 10.6736 86.3182 11.5961C85.38 9.67659 84.845 7.58519 84.7462 5.45093Z"
          fill="#94CDDB"
        />
        <Path
          d="M417.11 84.1791C416.729 78.542 415.824 74.0483 413.188 70.142C410.16 70.0027 407.175 70.8988 404.724 72.6827C407.303 76.8314 408.606 81.6462 408.472 86.5292C411.616 84.2267 413.807 83.3534 417.11 84.1791Z"
          fill="#94CDDB"
        />
        <Path
          d="M627.57 3.53043C626.608 2.76289 625.872 1.74977 625.439 0.59818C625.006 -0.553407 624.892 -1.80066 625.109 -3.01172C621.933 -1.69376 620.075 -0.074101 616.963 3.08582C616.836 5.56295 617.55 6.78563 619.599 8.72287C622.298 5.99168 624.41 4.24499 627.57 3.53043Z"
          fill="#FD7064"
        />
        <Path
          d="M316.469 9.26218C318.494 7.18522 321.212 5.92502 324.107 5.72116C320.931 1.13213 317.326 -3.10757 315.119 -4.44141C312.838 -2.9463 310.913 -0.967583 309.482 1.35443C311.991 2.83118 313.722 5.11776 316.469 9.26218Z"
          fill="#FBF6F3"
        />
        <Path
          d="M259.209 181.058C258.536 181.977 257.67 182.738 256.671 183.287C255.673 183.835 254.566 184.159 253.429 184.233C255.833 189.88 259.042 195.148 262.957 199.874C265.639 199.32 268.12 198.046 270.134 196.19C264.481 191.522 262.147 187.504 259.209 181.058Z"
          fill="#FBF6F3"
        />
        <Path
          d="M353.943 55.1981C356.155 58.6284 359.445 61.2259 363.296 62.5818C364.362 58.4632 366.722 54.7954 370.028 52.1176C368.081 48.8084 365.476 45.9334 362.375 43.6699C360.337 48.0222 357.473 51.9373 353.943 55.1981Z"
          fill="#A0C460"
        />
        <Path
          d="M349.386 22.3775C353.546 23.1873 358.151 23.6637 362.597 21.5994C363.84 18.6452 365.526 15.8981 367.599 13.4535C364.423 13.6123 362.756 12.2626 360.231 8.54688C357.913 13.4376 354.308 17.2486 349.386 22.3775Z"
          fill="#FFCE63"
        />
        <Path
          d="M262.051 70.4912C262.033 71.0788 261.808 71.6413 261.416 72.0791C262.349 72.3152 263.316 72.3904 264.274 72.3014C264.394 71.736 264.394 71.1519 264.274 70.5865C263.536 70.7307 262.774 70.698 262.051 70.4912Z"
          fill="#FBF6F3"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_101_5838">
          <Rect
            width="1258.65"
            height="545.301"
            fill="white"
            transform="translate(0 -160.945)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export const FestivalUpgrade = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 1358 381"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G>
        <Path
          d="M121.829 170.381C122.132 171.291 122.736 172.071 123.542 172.591C124.029 171.724 124.779 171.034 125.683 170.621C125.433 169.756 125.007 168.951 124.433 168.257C123.713 169.13 122.828 169.852 121.829 170.381Z"
          fill="#A0C460"
        />
        <Path
          d="M215.868 216.279C216.164 215.759 216.279 215.157 216.194 214.565C215.57 214.708 214.918 214.654 214.326 214.411C214.021 214.901 213.823 215.45 213.744 216.022C214.462 215.968 215.184 216.055 215.868 216.279Z"
          fill="#A0C460"
        />
        <Path
          d="M329.028 20.7274C329.179 21.0025 329.388 21.2424 329.639 21.4314C329.89 21.6204 330.178 21.7541 330.484 21.8238C331.195 21.0534 331.995 20.3691 332.865 19.7851C332.578 19.5942 332.343 19.3352 332.18 19.0312C331.219 19.7488 330.156 20.3203 329.028 20.7274Z"
          fill="#A0C460"
        />
        <Path
          d="M194.436 88.6249C196.175 91.4976 198.795 93.7327 201.905 94.9982C204.088 94.0772 206.399 93.4993 208.758 93.2849C207.045 91.7601 206.771 90.1668 207.319 86.8945C203.516 88.2309 199.695 88.4193 194.436 88.6249Z"
          fill="#FD7064"
        />
        <Path
          d="M159.845 299.438C160.805 299.762 161.65 300.357 162.278 301.151C162.381 300.989 162.516 300.851 162.675 300.744C162.835 300.638 163.015 300.567 163.203 300.534C162.576 299.603 161.705 298.862 160.685 298.393C160.321 298.665 160.033 299.024 159.845 299.438Z"
          fill="#94CDDB"
        />
        <Path
          d="M172.112 128.766C171.318 129.118 170.422 129.167 169.594 128.903C169.838 130.237 170.301 131.522 170.964 132.706C171.763 132.554 172.518 132.226 173.174 131.747C172.605 130.843 172.243 129.825 172.112 128.766Z"
          fill="#FBF6F3"
        />
        <Path
          d="M430.315 16.3945C429.424 16.8213 428.457 17.0659 427.471 17.1141C427.47 17.6359 427.645 18.1427 427.967 18.5532C428.977 18.5291 429.976 18.35 430.931 18.0221C430.349 17.4225 430.143 17.0284 430.315 16.3945Z"
          fill="#FFCE63"
        />
        <Path
          d="M481.455 169.421C481.925 170.241 482.646 170.889 483.511 171.271C484.138 171.035 484.796 170.885 485.464 170.826C484.967 170.38 484.916 169.935 485.104 169.01C483.919 169.348 482.686 169.487 481.455 169.421Z"
          fill="#A0C460"
        />
        <Path
          d="M1031.58 272.816C1031.22 269.669 1030.31 266.607 1028.9 263.771C1027.16 264.642 1025.69 265.968 1024.64 267.608C1025.8 269.208 1026.4 271.147 1026.35 273.125C1027.15 272.691 1028.03 272.438 1028.93 272.385C1029.83 272.332 1030.74 272.479 1031.58 272.816Z"
          fill="#FFCE63"
        />
        <Path
          d="M141.291 131.849C141.296 132.897 141.645 133.914 142.284 134.744C143.11 133.989 144.154 133.515 145.265 133.39C145.3 132.402 145.131 131.416 144.769 130.495C143.704 131.16 142.524 131.619 141.291 131.849Z"
          fill="#FFCE63"
        />
        <Path
          d="M92.4807 153.64C92.4887 154.301 92.6702 154.948 93.007 155.516C93.3438 156.084 93.824 156.554 94.3995 156.878C95.6473 156.613 96.7732 155.945 97.6033 154.977C97.0524 153.462 96.9454 151.821 97.2949 150.248C95.9336 151.69 94.2965 152.843 92.4807 153.64Z"
          fill="#FD7064"
        />
        <Path
          d="M181.895 348.197C181.723 347.472 181.321 346.822 180.747 346.347C180.23 346.423 179.705 346.423 179.188 346.347C179.462 346.775 179.393 347.135 179.051 347.786C180.015 347.767 180.975 347.906 181.895 348.197Z"
          fill="#A0C460"
        />
        <Path
          d="M794.584 36.7129C794.724 37.3959 795.108 38.0047 795.663 38.4262C797.283 36.8825 799.169 35.6461 801.231 34.777C800.782 34.2724 800.511 33.6344 800.46 32.9609C798.255 33.7758 796.251 35.0554 794.584 36.7129Z"
          fill="#FBF6F3"
        />
        <Path
          d="M46.6687 15.9658C50.7457 16.3828 54.5266 18.2855 57.2908 21.3112C59.6379 13.8243 61.1113 6.06331 60.7173 2.4655C57.0503 1.24951 53.1627 0.846135 49.3242 1.28336C49.8725 5.36088 48.776 9.3356 46.6687 15.9658Z"
          fill="#94CDDB"
        />
        <Path
          d="M111.721 244.564C111.353 244.288 110.929 244.096 110.479 244.001C110.029 243.907 109.564 243.911 109.116 244.015C108.667 245.474 108.04 246.873 107.249 248.178C107.744 248.238 108.212 248.434 108.602 248.744C109.424 247.201 110.476 245.791 111.721 244.564Z"
          fill="#A0C460"
        />
        <Path
          d="M373.332 57.4244C372.353 56.371 371.115 55.5934 369.741 55.1694C368.367 54.7455 366.905 54.69 365.503 55.0087C363.87 57.253 363.032 59.9782 363.122 62.7525C366.308 64.4658 367.953 66.3846 370.403 70.0509C370.523 65.6882 371.519 61.3943 373.332 57.4244Z"
          fill="#FD7064"
        />
        <Path
          d="M301.324 204.166C302.124 207.493 303.505 210.654 305.402 213.503C307.142 212.332 308.538 210.717 309.445 208.826C307.991 207.259 307.083 205.264 306.858 203.138C306.07 203.71 305.165 204.099 304.208 204.277C303.25 204.455 302.265 204.417 301.324 204.166Z"
          fill="#FD7064"
        />
        <Path
          d="M547.226 117.475C550.276 115.488 551.441 112.576 552.126 107.607C545.55 106.175 539.394 103.243 534.137 99.041C533.452 102.639 531.841 104.832 527.832 108.55C533.612 112.83 540.215 115.869 547.226 117.475Z"
          fill="#FBF6F3"
        />
        <Path
          d="M615.19 38.7689C615.071 35.9935 613.717 34.2631 611.387 31.5391C605.613 36.833 597.904 40.722 588.567 44.4055C590.223 46.5159 591.116 49.1242 591.102 51.8067C599.973 49.2373 608.188 44.7909 615.19 38.7689Z"
          fill="#94CDDB"
        />
        <Path
          d="M1183.61 284.036C1181.78 280.421 1178.71 278.776 1173.33 277.423C1170.94 284.516 1166.95 290.964 1161.66 296.269C1165.55 297.468 1167.78 299.524 1171.41 304.406C1176.83 298.526 1180.98 291.592 1183.61 284.036Z"
          fill="#FBF6F3"
        />
        <Path
          d="M976.187 90.8507C976.792 91.3178 977.299 91.9 977.678 92.5639C978.041 92.3744 978.335 92.0745 978.517 91.7073C978.148 91.0117 977.668 90.3809 977.095 89.8398C976.907 90.4566 976.701 90.7479 976.187 90.8507Z"
          fill="#FFCE63"
        />
        <Path
          d="M586.75 58.8498C587.126 59.3664 587.405 59.9469 587.573 60.5631C587.919 60.5074 588.234 60.3315 588.464 60.0662C588.318 59.406 588.076 58.7709 587.744 58.1816C587.419 58.6614 587.179 58.8841 586.75 58.8498Z"
          fill="#94CDDB"
        />
        <Path
          d="M1322.26 257.548C1321.98 257.558 1321.71 257.504 1321.45 257.392C1321.2 257.279 1320.97 257.11 1320.79 256.897C1320.02 258.207 1319.44 259.621 1319.08 261.095C1319.59 261.527 1320.21 261.816 1320.87 261.934C1320.94 260.375 1321.42 258.861 1322.26 257.548Z"
          fill="#FFCE63"
        />
        <Path
          d="M604.414 24.9775C604.44 26.7115 604.001 28.4209 603.143 29.9276C602.284 31.4342 601.037 32.683 599.531 33.5437C603.866 35.8566 607.258 36.3535 613.477 36.8674C616.27 34.7601 616.904 32.8927 617.195 28.918C611.815 28.4383 608.029 27.7187 604.414 24.9775Z"
          fill="#94CDDB"
        />
        <Path
          d="M235.211 103.667C235.231 104.065 235.356 104.45 235.572 104.784C235.789 105.117 236.09 105.388 236.444 105.569C237.185 105.383 237.842 104.955 238.312 104.352C237.962 103.441 237.878 102.448 238.072 101.491C237.275 102.403 236.302 103.143 235.211 103.667Z"
          fill="#FD7064"
        />
        <Path
          d="M60.3748 111.514C64.5722 109.561 66.5596 107.077 67.7075 102.143C64.7264 98.2877 62.0366 95.9235 58.4388 94.8955C54.5669 98.322 51.0205 99.5555 44.7329 100.995C51.2604 104.096 55.1837 106.203 60.3748 111.514Z"
          fill="#FFCE63"
        />
        <Path
          d="M963.132 23.2979C962.601 23.6405 961.933 23.7604 960.408 23.4692C960.396 24.1673 960.606 24.8514 961.008 25.4223C961.988 25.5253 962.978 25.3779 963.886 24.994C963.458 24.5252 963.193 23.93 963.132 23.2979Z"
          fill="#FBF6F3"
        />
        <Path
          d="M1132.9 219.412C1133.21 218.279 1133.75 217.22 1134.47 216.294C1133.99 215.883 1133.39 215.637 1132.76 215.592C1131.99 216.524 1131.37 217.571 1130.93 218.693C1131.94 218.641 1132.45 218.778 1132.9 219.412Z"
          fill="#FD7064"
        />
        <Path
          d="M1086.02 133.407C1085.83 133.133 1085.57 132.909 1085.27 132.754C1084.98 132.599 1084.65 132.518 1084.31 132.517C1084.01 133.64 1083.47 134.682 1082.72 135.566C1083.37 135.753 1083.94 136.158 1084.33 136.714C1085.12 135.742 1085.69 134.616 1086.02 133.407Z"
          fill="#94CDDB"
        />
        <Path
          d="M279.841 78.6699C280.166 79.3381 280.68 79.6122 281.554 80.0234C282.602 77.9319 284.025 76.0504 285.751 74.4725C285.122 74.1494 284.625 73.616 284.347 72.9648C282.457 74.5249 280.92 76.4698 279.841 78.6699Z"
          fill="#FFCE63"
        />
        <Path
          d="M253.44 173.551C251.951 174.284 250.746 175.488 250.013 176.977C251.654 177.568 253.064 178.666 254.039 180.112C255.462 179.432 256.733 178.471 257.774 177.286C256.103 176.33 254.632 175.062 253.44 173.551Z"
          fill="#FD7064"
        />
        <Path
          d="M452.946 28.7479C452.715 28.4541 452.566 28.104 452.515 27.7337C452.464 27.3634 452.512 26.9861 452.655 26.6406C451.627 26.8371 450.659 27.2713 449.828 27.9084C449.724 28.2252 449.707 28.5645 449.779 28.8902C449.851 29.2159 450.01 29.516 450.239 29.7587C451.023 29.1629 451.964 28.8113 452.946 28.7479Z"
          fill="#FD7064"
        />
        <Path
          d="M671.864 56.9475C672.995 59.1918 674.76 60.0998 677.706 61.4875C680.482 54.9601 685.365 48.8781 691.686 42.3507C689.538 41.2367 687.834 39.4237 686.855 37.2109C680.511 42.6481 675.4 49.3769 671.864 56.9475Z"
          fill="#94CDDB"
        />
        <Path
          d="M180.798 13.002C181.648 12.9788 182.481 12.7577 183.231 12.3562C183.98 11.9547 184.626 11.3839 185.116 10.6891C183.124 8.48101 181.67 5.84246 180.867 2.97949C179.547 4.0994 177.869 4.70747 176.138 4.69273C177.098 7.75584 178.685 10.5856 180.798 13.002Z"
          fill="#FBF6F3"
        />
        <Path
          d="M532.629 48.501C532.342 48.8038 532.14 49.1773 532.043 49.5835C531.947 49.9898 531.96 50.4143 532.081 50.8138C532.761 51.2386 533.561 51.431 534.36 51.3621C534.79 50.4425 535.474 49.6642 536.33 49.1177C535.067 49.1685 533.807 48.9586 532.629 48.501Z"
          fill="#FBF6F3"
        />
        <Path
          d="M1058.29 136.183C1061.38 138.61 1065.18 139.947 1069.11 139.986C1068.78 135.876 1069.78 131.768 1071.96 128.268C1069.12 125.86 1065.82 124.058 1062.26 122.974C1061.8 127.591 1060.45 132.076 1058.29 136.183Z"
          fill="#FFCE63"
        />
        <Path
          d="M75.0228 218.094C75.0228 212.749 74.5431 206.941 70.9281 201.921C66.9707 201.095 63.1632 199.668 59.6379 197.689C60.5802 201.544 59.3295 203.96 55.3376 207.969C61.985 209.682 67.5702 213.229 75.0228 218.094Z"
          fill="#FD7064"
        />
        <Path
          d="M708.168 118.178C707.58 119.41 707.329 120.775 707.441 122.135C707.552 123.496 708.022 124.802 708.802 125.922C711.354 126.568 714.049 126.345 716.46 125.288C716.785 121.861 717.967 119.754 720.315 116.311C716.434 117.749 712.301 118.384 708.168 118.178Z"
          fill="#FD7064"
        />
        <Path
          d="M92.4463 87.8874C92.6005 88.6584 92.4463 89.4636 91.4697 91.0741C92.2602 91.3889 93.1306 91.4429 93.9539 91.2283C94.4955 90.1693 94.7607 88.9906 94.7249 87.8018C93.9945 88.0754 93.1952 88.1054 92.4463 87.8874Z"
          fill="#FBF6F3"
        />
        <Path
          d="M428.053 3.98927C429.596 7.73425 432.338 10.8615 435.848 12.881C437.614 9.01934 440.584 5.83362 444.312 3.80081C442.959 0.206941 440.889 -3.07459 438.23 -5.84473C435.506 -1.93865 432.05 1.40121 428.053 3.98927Z"
          fill="#FFCE63"
        />
        <Path
          d="M1219.96 114.665C1221.06 116.036 1222.52 117.074 1224.18 117.663C1225.03 117.023 1225.64 116.11 1225.89 115.076C1224.26 114.504 1222.82 113.468 1221.76 112.095C1221.7 112.64 1221.51 113.161 1221.19 113.611C1220.88 114.06 1220.46 114.422 1219.96 114.665Z"
          fill="#FD7064"
        />
        <Path
          d="M261.972 0.666992C259.246 3.45919 257.518 7.07231 257.055 10.9464C261.17 11.0338 265.147 12.4457 268.396 14.9725C271.083 12.4047 273.217 9.31472 274.667 5.89238C270.139 4.98157 265.829 3.20749 261.972 0.666992Z"
          fill="#FD7064"
        />
        <Path
          d="M1132.49 120.336C1131.07 123.477 1129 126.281 1126.42 128.559C1132.89 130.687 1139.04 133.684 1144.7 137.468C1147.76 135.977 1150.14 133.39 1151.38 130.221C1145.5 126.183 1139.16 122.864 1132.49 120.336Z"
          fill="#FD7064"
        />
        <Path
          d="M311.998 79.9551C312.413 80.9897 313.153 81.8616 314.106 82.4393C314.873 82.2534 315.664 82.1784 316.453 82.2165C315.956 81.634 315.973 81.0858 316.333 80.0407C314.893 80.2492 313.429 80.2203 311.998 79.9551Z"
          fill="#A0C460"
        />
        <Path
          d="M930.067 68.3564C930.318 67.2597 930.258 66.1148 929.896 65.0499C929.231 64.8718 928.526 64.9201 927.891 65.1869C928.261 66.2399 928.308 67.3791 928.028 68.4592C928.332 68.2723 928.678 68.1649 929.034 68.1469C929.391 68.1289 929.746 68.201 930.067 68.3564Z"
          fill="#A0C460"
        />
        <Path
          d="M958.472 43.841C959.855 44.6529 960.995 45.8196 961.775 47.2203C962.555 48.6209 962.947 50.2047 962.909 51.8076C966.833 49.4947 968.872 47.0619 972.281 42.3676C971.973 39.1296 970.808 37.6733 967.792 35.5146C964.828 39.6093 962.481 42.2477 958.472 43.841Z"
          fill="#FFCE63"
        />
        <Path
          d="M554.542 7.57208C555.196 7.61892 555.809 7.9129 556.255 8.39444C556.591 7.43673 556.759 6.42826 556.752 5.4134C556.198 5.24076 555.614 5.18819 555.038 5.25921C555.055 6.05831 554.885 6.85024 554.542 7.57208Z"
          fill="#94CDDB"
        />
        <Path
          d="M988.574 4.94963C985.168 2.3991 982.298 -0.796891 980.127 -4.45605C978.116 -3.38247 976.519 -1.67087 975.587 0.409545C977.721 4.22882 980.431 7.69607 983.623 10.689C984.753 7.12544 985.833 5.54926 988.574 4.94963Z"
          fill="#94CDDB"
        />
        <Path
          d="M1099.78 180.59C1100.19 180.546 1100.56 180.357 1100.84 180.059C1100.02 179.042 1099.4 177.879 1099.01 176.633C1098.7 176.862 1098.33 176.983 1097.95 176.975C1098.29 178.299 1098.91 179.533 1099.78 180.59Z"
          fill="#94CDDB"
        />
        <Path
          d="M176.755 176.136C178.142 173.909 179.952 171.977 182.083 170.448C181.329 169.281 180.217 168.392 178.914 167.912C176.693 169.452 174.718 171.317 173.054 173.446C175.196 173.891 176.224 174.491 176.755 176.136Z"
          fill="#FD7064"
        />
        <Path
          d="M193.237 147.748C192.358 147.109 191.618 146.299 191.061 145.366C190.554 145.642 190.151 146.075 189.913 146.6C190.467 147.563 191.166 148.436 191.986 149.187C192.243 148.227 192.517 147.833 193.237 147.748Z"
          fill="#FD7064"
        />
        <Path
          d="M322.483 137.467C318.234 135.908 316.144 134.863 313.626 131.968C313.306 132.553 312.869 133.065 312.341 133.472C311.813 133.879 311.206 134.172 310.559 134.332C312.944 137.476 316.16 139.891 319.845 141.305C321.045 140.279 321.955 138.956 322.483 137.467Z"
          fill="#94CDDB"
        />
        <Path
          d="M431.599 36.3863C431.993 33.5081 433.57 30.7669 439.12 26.3467C436.738 24.2146 433.737 22.9 430.554 22.5947C427.233 25.7045 424.767 29.6159 423.393 33.9535C426.319 33.8603 429.197 34.7135 431.599 36.3863Z"
          fill="#94CDDB"
        />
        <Path
          d="M80.5222 52.7997C81.4797 53.5839 82.2717 54.5507 82.8522 55.6437C83.4462 55.3732 83.9298 54.9077 84.2228 54.3245C83.6658 53.1927 82.9312 52.1574 82.047 51.2578C81.6701 52.2172 81.3274 52.6627 80.5222 52.7997Z"
          fill="#FFCE63"
        />
        <Path
          d="M883.878 78.499C882.865 78.9562 881.995 79.6784 881.359 80.5892C881.616 81.2213 882.073 81.7512 882.661 82.0968C883.276 81.1817 884.146 80.4669 885.163 80.0409C884.835 79.9152 884.544 79.7074 884.319 79.4374C884.094 79.1675 883.942 78.8444 883.878 78.499Z"
          fill="#94CDDB"
        />
        <Path
          d="M1120.34 128.681C1119.14 126.15 1117.28 123.989 1114.96 122.428C1113.37 123.071 1112.05 124.238 1111.22 125.734C1113.51 127.251 1115.3 129.408 1116.36 131.936C1116.7 131.101 1117.23 130.364 1117.93 129.794C1118.63 129.225 1119.45 128.842 1120.34 128.681Z"
          fill="#A0C460"
        />
        <Path
          d="M583.238 105.156C583.799 105.76 584.22 106.479 584.472 107.264C585.556 106.045 586.801 104.978 588.172 104.094C588.137 103.279 587.795 102.508 587.213 101.936C585.76 102.841 584.425 103.922 583.238 105.156Z"
          fill="#FBF6F3"
        />
        <Path
          d="M243.983 286.625C239.305 287.19 234.371 285.819 225.137 278.915C222.742 283.535 221.907 288.806 222.755 293.94C230.294 298.12 235.125 300.005 243.469 300.553C242.047 295.671 242.441 292.518 243.983 286.625Z"
          fill="#94CDDB"
        />
        <Path
          d="M14.5797 189.347C12.8827 186.752 12.2053 183.622 12.678 180.558C7.16135 182.751 1.9017 185.577 0 187.565C1.04551 190.295 2.67716 192.763 4.77994 194.795C6.83583 192.516 9.69694 191.265 14.5797 189.347Z"
          fill="#FFCE63"
        />
        <Path
          d="M279.738 139.182C279.035 139.208 278.341 139.016 277.751 138.634C277.631 138.976 277.511 139.165 277.305 139.251C277.933 139.719 278.682 139.999 279.464 140.056C279.626 139.792 279.721 139.492 279.738 139.182Z"
          fill="#FD7064"
        />
        <Path
          d="M1167.15 117.782C1165.39 117.653 1163.63 117.912 1161.99 118.54C1160.34 119.167 1158.86 120.149 1157.64 121.414C1159.19 127.047 1160.08 132.843 1160.29 138.684C1162.02 137.879 1163.93 137.531 1165.83 137.673C1165.26 131.014 1165.71 124.308 1167.15 117.782Z"
          fill="#FFCE63"
        />
        <Path
          d="M226.473 60.5597C227.146 60.3068 227.874 60.2386 228.582 60.3621C229.29 60.4856 229.952 60.7964 230.499 61.2622C230.735 59.2737 230.512 57.2577 229.848 55.3686C229.33 54.9977 228.722 54.7706 228.087 54.7105C227.452 54.6503 226.813 54.7591 226.234 55.026C226.862 56.8057 226.945 58.7323 226.473 60.5597Z"
          fill="#FD7064"
        />
        <Path
          d="M1355 208.602C1352.16 207.879 1349.15 208.089 1346.44 209.201C1345.63 211.147 1344.53 212.957 1343.16 214.564C1345.22 214.427 1346.35 215.3 1348.01 217.699C1349.84 214.311 1352.2 211.239 1355 208.602Z"
          fill="#FBF6F3"
        />
        <Path
          d="M750.04 108.344C753.059 109.312 755.835 110.919 758.177 113.056C759.452 106.923 761.555 100.992 764.431 95.4264C762.754 92.7789 760.142 90.8587 757.115 90.0469C754.032 95.8407 751.657 101.984 750.04 108.344Z"
          fill="#FD7064"
        />
        <Path
          d="M660.797 11.5791C660.566 11.8695 660.403 12.208 660.32 12.5697C660.237 12.9314 660.236 13.3072 660.317 13.6693C661.492 14.0541 662.614 14.5835 663.658 15.2454C663.723 14.8455 663.888 14.4684 664.138 14.149C662.904 13.4614 661.778 12.5954 660.797 11.5791Z"
          fill="#FD7064"
        />
        <Path
          d="M411.4 73.4617C411.864 74.244 412.534 74.8841 413.336 75.312C413.824 75.0444 414.21 74.6227 414.433 74.1127C413.642 73.7274 412.981 73.1202 412.531 72.3652C412.444 72.6251 412.296 72.8603 412.099 73.0511C411.902 73.2419 411.663 73.3827 411.4 73.4617Z"
          fill="#A0C460"
        />
        <Path
          d="M96.5925 227.464C91.7269 226.779 89.277 226.128 85.9533 223.609C85.745 224.302 85.3954 224.945 84.9266 225.496C84.4578 226.048 83.8799 226.496 83.2292 226.813C86.4689 229.617 90.4262 231.462 94.6566 232.141C95.6948 230.776 96.3618 229.164 96.5925 227.464Z"
          fill="#94CDDB"
        />
        <Path
          d="M1015.95 96.3516C1016.23 96.4661 1016.47 96.6388 1016.67 96.8577C1016.87 97.0765 1017.03 97.3364 1017.12 97.6194C1018.43 96.6572 1019.58 95.5019 1020.54 94.1929C1020.23 93.5369 1019.74 92.984 1019.12 92.5996C1018.41 94.1058 1017.32 95.3995 1015.95 96.3516Z"
          fill="#FBF6F3"
        />
        <Path
          d="M586.511 1.42139C587.882 -2.14215 590.726 -5.14032 599.12 -9.08078C596.719 -12.5254 593.279 -15.1126 589.304 -16.4648C583.461 -12.6615 580.292 -9.9374 576.745 -4.18091C580.789 -3.39282 582.896 -1.91943 586.511 1.42139Z"
          fill="#FBF6F3"
        />
        <Path
          d="M372.15 38.4788C372.15 38.0334 371.876 37.7764 371.482 37.3652C370.482 38.3145 369.322 39.0801 368.056 39.6267C368.328 39.9438 368.49 40.3405 368.518 40.7574C369.876 40.2617 371.113 39.4852 372.15 38.4788Z"
          fill="#FBF6F3"
        />
        <Path
          d="M1017.13 11.2882C1018.04 12.502 1018.47 14.0096 1018.33 15.5199C1020.52 14.5927 1022.54 13.3073 1024.31 11.7165C1023.74 10.4015 1022.88 9.23101 1021.79 8.29004C1020.48 9.62259 1018.89 10.6467 1017.13 11.2882Z"
          fill="#FD7064"
        />
        <Path
          d="M776.046 10.227C776.281 10.5013 776.583 10.7101 776.922 10.8332C777.261 10.9563 777.626 10.9895 777.982 10.9295C778.423 10.3867 778.665 9.70965 778.668 9.01063C777.929 8.54302 777.336 7.87845 776.954 7.0918C776.868 8.18765 776.559 9.25436 776.046 10.227Z"
          fill="#FD7064"
        />
        <Path
          d="M1102.54 247.115C1102.9 247.922 1103.09 248.799 1103.09 249.685C1104.6 248.797 1106.22 248.128 1107.92 247.697C1108.16 246.856 1108.07 245.955 1107.66 245.179C1105.88 245.617 1104.16 246.267 1102.54 247.115Z"
          fill="#FD7064"
        />
        <Path
          d="M1211.76 184.823C1216.71 187.856 1222.38 190.665 1229.06 190.151C1232.05 186.949 1235.52 184.227 1239.34 182.082C1235.23 180.78 1233.69 178.244 1232.23 172.282C1226.95 177.439 1220.51 180.609 1211.76 184.823Z"
          fill="#A0C460"
        />
        <Path
          d="M246.158 368.567C246.805 368.431 247.479 368.528 248.06 368.842C248.075 367.807 247.919 366.776 247.598 365.792C247.003 365.803 246.419 365.943 245.884 366.203C246.159 366.959 246.253 367.769 246.158 368.567Z"
          fill="#FBF6F3"
        />
        <Path
          d="M154.106 257.396C155.267 258.878 156.806 260.02 158.56 260.702C159.501 260.034 160.189 259.068 160.513 257.961C158.771 257.316 157.258 256.172 156.162 254.672C156.079 255.263 155.847 255.824 155.487 256.3C155.127 256.777 154.652 257.154 154.106 257.396Z"
          fill="#A0C460"
        />
        <Path
          d="M1056.86 192.482C1060.8 193.189 1064.85 192.587 1068.41 190.769C1066.17 187.192 1065.13 182.987 1065.46 178.776C1061.78 177.937 1057.96 177.861 1054.24 178.554C1056.01 182.982 1056.9 187.713 1056.86 192.482Z"
          fill="#94CDDB"
        />
        <Path
          d="M1244.22 7.12403C1242.68 7.42628 1241.07 7.14559 1239.72 6.33594C1239.59 8.80413 1239.87 11.2764 1240.56 13.6515C1242.04 13.6865 1243.51 13.4061 1244.88 12.8291C1244.23 11.0017 1244 9.05048 1244.22 7.12403Z"
          fill="#A0C460"
        />
        <Path
          d="M193.63 162.535C193.383 165.774 194.201 169.005 195.96 171.735C198.193 172.209 200.342 173.018 202.334 174.134C201.802 171.958 202.522 170.587 204.766 168.326C200.767 167.007 197.007 165.051 193.63 162.535Z"
          fill="#FFCE63"
        />
        <Path
          d="M1229.75 293.526C1230.55 293.126 1231.28 292.58 1231.89 291.916C1231.48 291.533 1230.98 291.272 1230.43 291.162C1230.13 291.636 1229.68 291.993 1229.15 292.173C1229.34 292.339 1229.5 292.547 1229.6 292.782C1229.7 293.016 1229.75 293.27 1229.75 293.526Z"
          fill="#FBF6F3"
        />
        <Path
          d="M100.019 219.704C103.171 216.38 105.947 215.026 111.412 215.558C109.202 209.938 106.427 206.769 101.013 201.321C96.7125 201.064 94.5538 202.263 91.1787 205.792C95.7873 210.572 98.7512 214.273 100.019 219.704Z"
          fill="#FD7064"
        />
        <Path
          d="M407.717 79.5601C409.012 78.8257 410.038 77.6973 410.647 76.3392C410.248 75.3616 410.011 74.3259 409.944 73.2725C409.242 74.0263 408.522 74.0948 407.083 73.8036C407.601 75.6761 407.815 77.6197 407.717 79.5601Z"
          fill="#FD7064"
        />
        <Path
          d="M1097.07 0.836029C1097.12 -1.334 1096.48 -3.46303 1095.24 -5.24598C1093.72 -5.48497 1092.24 -5.96498 1090.87 -6.66797C1091.3 -5.21171 1090.87 -4.26943 1089.42 -2.67612C1092.14 -1.92599 1094.73 -0.739955 1097.07 0.836029Z"
          fill="#FD7064"
        />
        <Path
          d="M254.33 146.188C254.644 146.332 254.912 146.557 255.108 146.84C255.304 147.124 255.42 147.455 255.444 147.798C256.17 147.203 256.755 146.454 257.157 145.605C257.114 145.304 256.991 145.02 256.801 144.782C256.611 144.544 256.362 144.361 256.078 144.252C255.697 145.054 255.09 145.727 254.33 146.188Z"
          fill="#A0C460"
        />
        <Path
          d="M291.611 154.599C291.154 153.34 290.308 152.26 289.195 151.516C288.272 151.713 287.324 151.765 286.385 151.67C286.951 152.407 286.899 153.058 286.385 154.291C288.132 154.102 289.898 154.206 291.611 154.599Z"
          fill="#A0C460"
        />
        <Path
          d="M850.984 1.88396C851.086 2.44933 850.984 3.08323 850.178 4.28249C850.774 4.53582 851.435 4.58991 852.063 4.43669C852.504 3.6345 852.729 2.73095 852.714 1.81543C852.159 2.02105 851.553 2.04505 850.984 1.88396Z"
          fill="#94CDDB"
        />
        <Path
          d="M169.457 154.38C170.265 157.403 169.929 160.617 168.515 163.409C174.494 163.049 180.507 162.004 182.889 160.702C182.763 157.762 181.997 154.885 180.644 152.272C177.817 153.797 174.751 154.089 169.457 154.38Z"
          fill="#A0C460"
        />
        <Path
          d="M113.588 278.898C108.311 283.182 104.508 287.173 102.503 292.484C104.456 295.555 107.4 297.864 110.847 299.029C113.147 293.629 116.976 289.019 121.863 285.769C117.426 284.261 115.061 282.719 113.588 278.898Z"
          fill="#A0C460"
        />
        <Path
          d="M266.22 113.209C269.407 116.036 273.073 118.811 278.042 119.274C280.646 117.341 283.536 115.826 286.608 114.785C283.815 113.312 283.027 111.273 282.736 106.784C278.144 109.834 273.09 111.29 266.22 113.209Z"
          fill="#FFCE63"
        />
        <Path
          d="M781.169 1.86421C781.946 2.13305 782.773 2.2264 783.591 2.13753C784.408 2.04866 785.196 1.77979 785.897 1.35023C785.862 -1.37531 786.15 -4.09545 786.754 -6.75339C785.877 -6.60406 784.976 -6.6747 784.133 -6.95898C783.597 -3.88491 782.598 -0.909965 781.169 1.86421Z"
          fill="#94CDDB"
        />
        <Path
          d="M1056.71 72.2119C1055.74 74.0796 1054.29 75.653 1052.51 76.7681C1050.72 77.8831 1048.67 78.4988 1046.57 78.5509C1049.86 83.5193 1053.18 86.0035 1059.52 90.1324C1063.72 89.4985 1065.55 87.9052 1068.09 83.8106C1062.6 80.2127 1058.97 77.2488 1056.71 72.2119Z"
          fill="#FFCE63"
        />
        <Path
          d="M763.745 12.4023C763.057 12.7318 762.452 13.2102 761.971 13.8028C761.491 14.3955 761.149 15.0875 760.97 15.8288C762.761 17.6023 764.336 19.5804 765.664 21.7224C766.136 21.0479 766.773 20.5053 767.514 20.1462C765.867 17.7745 764.595 15.1624 763.745 12.4023Z"
          fill="#FD7064"
        />
        <Path
          d="M498.005 75.6729C497.603 76.7326 497.603 77.9026 498.005 78.9623C501.452 78.1581 505.015 77.9839 508.524 78.4483C508.31 77.4051 508.448 76.3202 508.918 75.3645C505.299 74.6986 501.581 74.8037 498.005 75.6729Z"
          fill="#A0C460"
        />
        <Path
          d="M126.112 270.108C125.274 269.267 124.779 268.143 124.724 266.956C123.126 267.915 121.696 269.131 120.492 270.554C121.096 271.491 121.89 272.29 122.822 272.901C123.686 271.726 124.812 270.77 126.112 270.108Z"
          fill="#A0C460"
        />
        <Path
          d="M108.123 128.303C108.974 128.665 109.743 129.195 110.384 129.862C110.893 128.114 111.636 126.442 112.594 124.894C112.164 124.092 111.449 123.48 110.59 123.181C109.565 124.783 108.736 126.503 108.123 128.303Z"
          fill="#FBF6F3"
        />
        <Path
          d="M1352.28 313.589C1347.68 310.126 1343.82 305.788 1340.9 300.825C1338.2 302.249 1336.04 304.517 1334.75 307.284C1336.74 311.344 1340.29 315.73 1345.56 321.127C1347.07 316.536 1348.58 314.428 1352.28 313.589Z"
          fill="#FD7064"
        />
        <Path
          d="M1197.64 73.754C1198.3 72.8029 1199.2 72.0457 1200.25 71.5607C1201.31 71.0757 1202.47 70.8807 1203.62 70.9957C1202.1 68.1547 1199.96 65.6946 1197.35 63.8001C1196.32 63.7902 1195.3 64.0488 1194.4 64.5504C1193.5 65.052 1192.74 65.7794 1192.21 66.6612C1194.68 68.4378 1196.57 70.9056 1197.64 73.754Z"
          fill="#A0C460"
        />
        <Path
          d="M1044.37 123.131C1041.98 120.784 1039.13 120.287 1034.52 120.647C1034.53 126.84 1033.1 132.951 1030.34 138.498C1033.77 138.498 1036 139.441 1040.13 142.319C1042.84 136.281 1044.29 129.75 1044.37 123.131Z"
          fill="#FD7064"
        />
        <Path
          d="M1165.6 134.453C1165.12 133.758 1164.91 132.91 1165.02 132.071C1163.78 132.547 1162.62 133.224 1161.59 134.076C1161.89 134.813 1162.35 135.474 1162.93 136.012C1163.69 135.299 1164.61 134.767 1165.6 134.453Z"
          fill="#FBF6F3"
        />
        <Path
          d="M468.434 73.1352C469.064 73.5998 469.546 74.2364 469.822 74.9684C469.934 74.8726 470.066 74.8017 470.207 74.7604C470.349 74.719 470.498 74.7082 470.644 74.7286C470.402 73.8925 469.934 73.1396 469.291 72.5527C468.962 72.6751 468.669 72.8749 468.434 73.1352Z"
          fill="#FFCE63"
        />
        <Path
          d="M1165.33 97.8928C1164.13 97.8623 1162.95 98.1521 1161.9 98.7323C1161.85 99.4654 1162.04 100.196 1162.45 100.805C1163.49 100.201 1164.68 99.9207 1165.88 100C1165.61 99.727 1165.42 99.3889 1165.32 99.0193C1165.23 98.6497 1165.23 98.2614 1165.33 97.8928Z"
          fill="#A0C460"
        />
        <Path
          d="M114.016 63.7994C117.785 61.932 122.326 61.6236 132.074 64.6732C132.714 60.0878 131.855 55.4183 129.624 51.3613C122.051 50.0935 117.443 49.9393 110.281 51.9609C112.971 55.6615 113.571 58.4198 114.016 63.7994Z"
          fill="#FBF6F3"
        />
        <Path
          d="M303.603 145.108C303.723 145.76 303.603 146.445 302.678 147.747C303.334 148.038 304.065 148.116 304.768 147.97C305.259 147.083 305.518 146.087 305.522 145.074C304.903 145.293 304.23 145.305 303.603 145.108Z"
          fill="#94CDDB"
        />
        <Path
          d="M982.92 145.437C982.595 145.786 982.181 146.041 981.722 146.173C981.264 146.306 980.778 146.312 980.316 146.19C980.736 147.484 981.459 148.658 982.423 149.617C982.842 149.684 983.271 149.64 983.668 149.489C984.065 149.339 984.415 149.088 984.685 148.76C983.768 147.86 983.152 146.7 982.92 145.437Z"
          fill="#A0C460"
        />
        <Path
          d="M37.8457 276.841C38.275 278.131 39.0361 279.284 40.0526 280.187C41.0691 281.089 42.3051 281.708 43.6365 281.981C45.9447 280.706 47.7555 278.69 48.7762 276.259C46.686 273.586 46.0521 271.222 45.3497 267.093C43.5285 270.813 40.9764 274.129 37.8457 276.841Z"
          fill="#FBF6F3"
        />
        <Path
          d="M599.566 29.0371C600.403 24.9873 602.103 21.1656 604.551 17.8325C594.563 16.479 587.95 15.057 580.857 12.1445C577.639 14.6914 575.508 18.3657 574.895 22.424C579.966 24.7369 588.995 27.2382 599.566 29.0371Z"
          fill="#FBF6F3"
        />
        <Path
          d="M346.88 130.41C343.791 129.769 340.872 128.485 338.314 126.641C337.738 132.874 336.32 139 334.099 144.852C336.06 147.29 338.868 148.899 341.963 149.358C344.358 143.263 346.009 136.901 346.88 130.41Z"
          fill="#FD7064"
        />
        <Path
          d="M588.823 81.6681C589.283 81.0861 589.542 80.3707 589.56 79.6293C588.789 79.6869 588.02 79.4947 587.367 79.0811C586.91 79.6112 586.566 80.2292 586.356 80.8971C587.223 80.9819 588.063 81.2444 588.823 81.6681Z"
          fill="#A0C460"
        />
        <Path
          d="M438.675 148.829C444.055 147.253 446.916 146.773 451.576 147.835C451.461 147.014 451.521 146.177 451.752 145.38C451.982 144.583 452.377 143.844 452.912 143.21C447.978 141.719 444.346 141.89 438.487 143.055C438.032 144.962 438.097 146.956 438.675 148.829Z"
          fill="#FBF6F3"
        />
        <Path
          d="M1228.03 149.204C1227.52 148.184 1226.76 147.317 1225.81 146.688C1224.86 146.06 1223.76 145.692 1222.62 145.623C1220.87 146.959 1219.63 148.841 1219.07 150.968C1221.03 152.941 1222.38 155.432 1222.96 158.147C1224.03 154.855 1225.76 151.813 1228.03 149.204Z"
          fill="#FD7064"
        />
        <Path
          d="M981.224 19.4424C980.715 19.7084 980.155 19.8614 979.581 19.8909C979.007 19.9205 978.434 19.8259 977.9 19.6137C977.763 22.7033 978.074 25.7966 978.826 28.7967C980.17 29.1358 981.581 29.0943 982.903 28.6768C981.549 25.7972 980.971 22.6142 981.224 19.4424Z"
          fill="#FBF6F3"
        />
        <Path
          d="M619.696 26.7952C621.183 27.0446 622.576 27.6902 623.728 28.6639C624.879 29.6377 625.747 30.9037 626.241 32.3289C628.913 28.9881 629.873 26.1784 631.38 20.9359C630.027 18.2118 628.536 17.3209 625.178 16.4814C623.842 20.9701 622.626 24.0882 619.696 26.7952Z"
          fill="#94CDDB"
        />
        <Path
          d="M281.965 18.2781C283.745 17.799 285.427 17.0103 286.933 15.9481C286.282 15.0207 285.386 14.2915 284.346 13.8408C283.534 14.6555 282.473 15.1743 281.331 15.3142C281.65 15.7302 281.873 16.212 281.982 16.7247C282.092 17.2374 282.086 17.768 281.965 18.2781Z"
          fill="#A0C460"
        />
        <Path
          d="M1224.88 96.5909C1225.36 96.4709 1225.65 96.1454 1225.96 95.5286C1225.17 95.0502 1224.51 94.4001 1224.01 93.627C1223.73 94.0831 1223.29 94.4189 1222.77 94.5692C1223.34 95.3761 1224.05 96.0633 1224.88 96.5909Z"
          fill="#FFCE63"
        />
        <Path
          d="M370.231 23.4354C371.062 25.247 372.473 26.73 374.24 27.6499C375.041 25.7054 376.455 24.0753 378.267 23.0071C377.533 21.2719 376.455 19.7039 375.097 18.3984C373.819 20.3788 372.166 22.09 370.231 23.4354Z"
          fill="#A0C460"
        />
        <Path
          d="M1192.89 51.2764C1193.46 50.2171 1194.29 49.3277 1195.31 48.701C1196.33 48.0742 1197.5 47.7329 1198.7 47.7128C1196.8 44.9619 1194.29 42.687 1191.37 41.0654C1190.31 41.176 1189.3 41.5637 1188.44 42.1894C1187.58 42.815 1186.9 43.6565 1186.47 44.629C1189.22 46.1636 1191.45 48.4761 1192.89 51.2764Z"
          fill="#FD7064"
        />
        <Path
          d="M348.216 193.079C347.361 194.357 346.179 195.381 344.792 196.044C343.405 196.707 341.866 196.985 340.335 196.848C342.322 200.72 344.532 202.81 348.798 206.322C351.899 206.203 353.356 205.192 355.531 202.416C351.899 199.367 349.501 196.917 348.216 193.079Z"
          fill="#A0C460"
        />
        <Path
          d="M917.937 138.222C918.038 139.36 917.891 140.507 917.507 141.584C917.122 142.66 916.509 143.641 915.71 144.458C921.303 147.074 927.248 148.863 933.356 149.769C934.992 147.532 935.981 144.889 936.217 142.128C928.919 142.471 924.447 141.049 917.937 138.222Z"
          fill="#FFCE63"
        />
        <Path
          d="M224.075 4.48697C224.484 4.50878 224.891 4.42393 225.258 4.24072C225.624 4.05751 225.937 3.78225 226.165 3.44189C226.064 2.65539 225.702 1.92551 225.137 1.36887C224.165 1.61255 223.146 1.5829 222.19 1.2832C223.028 2.21292 223.669 3.30275 224.075 4.48697Z"
          fill="#94CDDB"
        />
        <Path
          d="M1161.42 186.417C1160.45 187.923 1158.95 189.02 1157.23 189.501C1159.16 191.538 1161.42 193.24 1163.91 194.538C1165.11 193.357 1166.03 191.923 1166.61 190.34C1164.61 189.437 1162.84 188.096 1161.42 186.417Z"
          fill="#FBF6F3"
        />
        <Path
          d="M996.901 72.7444C997.829 71.8216 998.945 71.1088 1000.17 70.6542C998.216 69.0714 996.487 67.2266 995.033 65.1719C993.759 65.3038 992.582 65.9164 991.744 66.8851C993.227 69.0333 994.958 70.9998 996.901 72.7444Z"
          fill="#FD7064"
        />
        <Path
          d="M518.324 26.1073C517.919 25.326 517.685 24.4675 517.638 23.5889C516.189 24.5505 514.615 25.3112 512.961 25.8503C512.773 26.6984 512.914 27.5864 513.355 28.3345C515.094 27.7921 516.762 27.0445 518.324 26.1073Z"
          fill="#A0C460"
        />
        <Path
          d="M1289.5 208.604C1290.19 208.197 1290.74 207.602 1291.1 206.891C1290.88 206.472 1290.52 206.14 1290.09 205.948C1289.73 206.626 1289.18 207.186 1288.51 207.559C1289.08 207.867 1289.37 208.09 1289.5 208.604Z"
          fill="#FBF6F3"
        />
        <Path
          d="M71.4252 263.256C71.7558 264.239 71.8704 265.282 71.761 266.314C71.6516 267.346 71.3208 268.342 70.7913 269.235C76.2881 270.329 81.9134 270.629 87.4953 270.126C88.4578 267.809 88.7659 265.273 88.3862 262.793C82.0472 264.643 77.7984 264.352 71.4252 263.256Z"
          fill="#A0C460"
        />
        <Path
          d="M624.134 117.288C623.686 118.059 623.499 118.955 623.603 119.841C624.099 120.229 624.532 120.691 624.887 121.211C625.024 120.595 625.367 120.338 626.189 120.063C625.361 119.253 624.667 118.316 624.134 117.288Z"
          fill="#FD7064"
        />
        <Path
          d="M408.351 183.11C408.086 181.735 408.086 180.322 408.351 178.947C407.636 178.749 406.876 178.797 406.192 179.084C405.865 180.486 405.749 181.93 405.85 183.367C406.929 182.784 407.546 182.647 408.351 183.11Z"
          fill="#FFCE63"
        />
        <Path
          d="M681.921 84.5625C681.275 84.9259 680.535 85.0871 679.797 85.0251C679.836 85.16 679.845 85.3018 679.825 85.4408C679.804 85.5797 679.753 85.7126 679.677 85.8303C680.489 85.9524 681.32 85.8456 682.075 85.5219C682.104 85.1943 682.051 84.8646 681.921 84.5625Z"
          fill="#FFCE63"
        />
        <Path
          d="M167.401 318.797C172.206 320.873 177.337 322.091 182.563 322.395C182.732 319.188 182.04 315.994 180.558 313.144C177.286 313.658 174.87 312.784 171.238 311.088C171.209 312.577 170.85 314.041 170.186 315.374C169.523 316.708 168.571 317.877 167.401 318.797Z"
          fill="#94CDDB"
        />
        <Path
          d="M233.515 143.433C234.097 143.728 234.767 143.801 235.399 143.638C235.186 141.605 235.342 139.55 235.862 137.573C235.257 137.617 234.655 137.461 234.149 137.128C233.49 139.16 233.274 141.31 233.515 143.433Z"
          fill="#94CDDB"
        />
        <Path
          d="M1062.65 211.139C1061.46 211.728 1060.37 212.516 1059.43 213.469C1060.03 214.038 1060.76 214.44 1061.56 214.634C1062.03 213.943 1062.72 213.425 1063.51 213.16C1063.23 212.906 1063.01 212.593 1062.86 212.244C1062.71 211.895 1062.64 211.518 1062.65 211.139Z"
          fill="#FD7064"
        />
        <Path
          d="M1299.8 6.08155C1299.47 4.83235 1299.6 3.5038 1300.18 2.34668C1298.15 2.40028 1296.14 2.7881 1294.23 3.49455C1294.3 4.69078 1294.62 5.85901 1295.18 6.92104C1296.64 6.30952 1298.22 6.02309 1299.8 6.08155Z"
          fill="#FBF6F3"
        />
        <Path
          d="M732.188 60.6651C731.588 54.8058 730.475 50.1629 727.631 46.1882C724.475 46.1261 721.395 47.1548 718.91 49.1007C721.735 53.3378 723.249 58.3137 723.262 63.4063C726.466 60.9049 728.71 59.9113 732.188 60.6651Z"
          fill="#FD7064"
        />
        <Path
          d="M1022.14 26.0069C1022.45 25.9745 1022.76 25.8714 1023.03 25.7053C1023.3 25.5392 1023.52 25.3143 1023.7 25.0474C1023.23 24.0984 1022.88 23.0978 1022.65 22.0664C1022.37 22.2722 1022.05 22.4021 1021.71 22.4433C1022.02 23.6043 1022.17 24.8046 1022.14 26.0069Z"
          fill="#FFCE63"
        />
        <Path
          d="M258.631 56.3131C259.231 56.9183 260.014 57.3096 260.858 57.4267C260.894 56.5397 261.212 55.6873 261.766 54.9939C261.237 54.3739 260.583 53.8719 259.847 53.5205C259.64 54.5258 259.226 55.4769 258.631 56.3131Z"
          fill="#A0C460"
        />
        <Path
          d="M799.724 12.1451C800.18 11.4694 800.761 10.8878 801.437 10.4318C801.218 10.0441 800.873 9.74213 800.46 9.5752C799.721 10.0375 799.062 10.616 798.507 11.2884C799.278 11.4084 799.587 11.6139 799.724 12.1451Z"
          fill="#FBF6F3"
        />
        <Path
          d="M1000 131.062C1000.54 130.151 1000.88 129.133 1000.98 128.079C1001.08 127.025 1000.95 125.961 1000.6 124.963C997.15 124.295 993.792 123.22 990.595 121.759C990.572 122.9 990.253 124.015 989.67 124.997C993.399 126.488 996.882 128.532 1000 131.062Z"
          fill="#94CDDB"
        />
        <Path
          d="M329.833 163.168C330.03 162.965 330.174 162.717 330.252 162.445C330.33 162.173 330.339 161.886 330.278 161.609C329.291 161.575 328.325 161.317 327.452 160.855C327.433 161.432 327.201 161.982 326.801 162.397C327.749 162.855 328.781 163.118 329.833 163.168Z"
          fill="#FD7064"
        />
        <Path
          d="M317.001 101.012C318.538 101.321 319.946 102.085 321.044 103.204C321.172 102.939 321.351 102.703 321.572 102.509C321.792 102.314 322.05 102.166 322.329 102.074C321.182 100.778 319.7 99.8234 318.046 99.3154C317.559 99.7829 317.2 100.367 317.001 101.012Z"
          fill="#A0C460"
        />
        <Path
          d="M1143.09 47.2824C1143.86 51.2057 1146.33 53.5871 1151.11 56.3112C1155.26 50.2206 1160.77 45.1768 1167.2 41.5773C1163.77 39.3843 1162.25 36.8487 1160.12 31.2979C1153.4 35.3918 1147.6 40.8345 1143.09 47.2824Z"
          fill="#94CDDB"
        />
        <Path
          d="M1135.04 189.345C1135.19 189.416 1135.32 189.516 1135.43 189.64C1135.54 189.764 1135.62 189.908 1135.67 190.065C1136.38 189.536 1137.01 188.907 1137.54 188.198C1137.37 187.837 1137.11 187.529 1136.79 187.307C1136.39 188.125 1135.79 188.827 1135.04 189.345Z"
          fill="#94CDDB"
        />
        <Path
          d="M621.992 60.3714C623.014 60.2832 624.042 60.4177 625.007 60.7655C624.628 58.7732 624.524 56.7382 624.699 54.7177C623.869 54.1289 622.846 53.8778 621.838 54.0153C621.633 56.1325 621.685 58.2666 621.992 60.3714Z"
          fill="#A0C460"
        />
        <Path
          d="M538.506 76.4787C538.962 75.9689 539.515 75.5554 540.133 75.2623C539.991 74.9258 539.745 74.6437 539.431 74.457C538.808 74.7566 538.232 75.1431 537.718 75.6049C538.215 75.7934 538.437 76.0332 538.506 76.4787Z"
          fill="#FD7064"
        />
        <Path
          d="M416.78 94.9651C418.429 94.8526 420.033 94.3782 421.478 93.5758C422.923 92.7733 424.173 91.6625 425.14 90.3223C422.942 85.2845 421.344 80.0057 420.378 74.5947C418.888 75.5923 417.163 76.1829 415.375 76.308C416.779 82.4209 417.253 88.7108 416.78 94.9651Z"
          fill="#A0C460"
        />
        <Path
          d="M1033.26 29.8414C1033.57 30.317 1033.79 30.8538 1033.89 31.4176C1034.76 30.6935 1035.72 30.0885 1036.75 29.6187C1036.81 29.0526 1036.66 28.4836 1036.32 28.0254C1035.23 28.5053 1034.2 29.1151 1033.26 29.8414Z"
          fill="#FFCE63"
        />
        <Path
          d="M1136.49 98.2175C1134.08 97.3632 1132.07 95.6491 1130.84 93.4033C1128.63 96.7625 1127 100.469 1126.01 104.368C1128.06 105.641 1130.35 106.454 1132.74 106.749C1133 104.18 1134.25 101.935 1136.49 98.2175Z"
          fill="#FFCE63"
        />
        <Path
          d="M1166.72 241.977C1164.75 244.06 1162.35 245.696 1159.69 246.774C1164.21 250.21 1168.25 254.244 1171.68 258.766C1174.5 258.43 1177.09 257.048 1178.93 254.894C1175.39 250.12 1171.29 245.783 1166.72 241.977Z"
          fill="#FFCE63"
        />
        <Path
          d="M243.777 241.206C248.454 237.505 253.183 233.017 255.05 226.386C253.009 222.356 251.611 218.033 250.904 213.571C248.197 217.083 245.199 217.666 238.911 216.998C242.029 223.919 242.817 231.269 243.777 241.206Z"
          fill="#FD7064"
        />
        <Path
          d="M500.66 52.8506C498.052 53.8259 495.837 55.6319 494.356 57.9903C496.988 59.2932 499.132 61.4073 500.472 64.0209C503.006 63.1825 505.339 61.8293 507.325 60.0462C504.656 58.1043 502.392 55.66 500.66 52.8506Z"
          fill="#A0C460"
        />
        <Path
          d="M364.783 156.023C364.757 157.3 364.256 158.522 363.378 159.45C365.3 159.985 367.299 160.188 369.289 160.05C369.55 158.888 369.55 157.682 369.289 156.52C367.769 156.682 366.232 156.513 364.783 156.023Z"
          fill="#FBF6F3"
        />
        <Path
          d="M313.54 44.6963C313.54 46.7179 312.632 48.7053 309.188 52.1832C310.994 53.4602 313.163 54.1211 315.373 54.0677C317.404 51.6704 318.784 48.7915 319.382 45.7071C317.377 46.0202 315.324 45.665 313.54 44.6963Z"
          fill="#FFCE63"
        />
        <Path
          d="M1247.98 307.337C1248.24 306.983 1248.4 306.566 1248.44 306.129C1248.49 305.693 1248.42 305.252 1248.23 304.852C1247.47 304.485 1246.6 304.389 1245.77 304.578C1245.45 305.596 1244.86 306.505 1244.05 307.2C1245.36 306.987 1246.69 307.033 1247.98 307.337Z"
          fill="#FD7064"
        />
        <Path
          d="M170.279 194.193C171.003 194.047 171.748 194.047 172.472 194.193C172.585 193.824 172.585 193.431 172.472 193.062C171.74 192.873 170.983 192.798 170.228 192.839C170.468 193.439 170.536 193.764 170.279 194.193Z"
          fill="#94CDDB"
        />
        <Path
          d="M1249.14 171.184C1249.85 171.084 1250.51 170.753 1251.01 170.242C1251.01 169.731 1251.08 169.223 1251.23 168.735C1250.79 168.957 1250.44 168.872 1249.84 168.478C1249.76 169.412 1249.52 170.326 1249.14 171.184Z"
          fill="#A0C460"
        />
        <Path
          d="M1189.14 165.103C1190.38 165.003 1191.57 164.58 1192.59 163.877C1193.61 163.173 1194.43 162.214 1194.97 161.094C1194.33 158.784 1192.93 156.756 1190.99 155.338C1188.21 156.503 1185.15 156.859 1182.17 156.366C1185.06 158.777 1187.43 161.749 1189.14 165.103Z"
          fill="#FD7064"
        />
        <Path
          d="M905.088 79.5609C906.27 79.2867 906.955 78.4986 907.726 77.0253C905.836 75.8499 904.241 74.2554 903.066 72.3652C902.363 73.4656 901.286 74.2749 900.033 74.6438C901.359 76.6156 903.08 78.29 905.088 79.5609Z"
          fill="#FBF6F3"
        />
        <Path
          d="M64.9487 142.214C64.8287 140.055 63.7494 138.788 61.9162 136.629C57.4961 140.792 51.5511 143.893 44.3384 146.908C45.6271 148.514 46.3444 150.503 46.3771 152.562C53.2293 150.464 59.5588 146.937 64.9487 142.214Z"
          fill="#FBF6F3"
        />
        <Path
          d="M899.177 12.9148C899.595 12.3184 899.844 11.6197 899.896 10.8932C899.546 10.6143 899.111 10.4633 898.663 10.4649C898.622 11.1913 898.365 11.8891 897.926 12.4693C898.155 12.4332 898.39 12.455 898.608 12.5328C898.827 12.6106 899.022 12.7419 899.177 12.9148Z"
          fill="#FBF6F3"
        />
        <Path
          d="M325.43 48.1392C327.914 44.0617 330.261 39.3846 329.816 33.868C327.168 31.3757 324.925 28.4856 323.168 25.3018C322.089 28.7282 319.999 29.9618 315.082 31.161C319.331 35.6155 321.952 40.9265 325.43 48.1392Z"
          fill="#FBF6F3"
        />
        <Path
          d="M184.67 63.8007C184.736 64.1399 184.874 64.4609 185.075 64.7418C185.276 65.0227 185.535 65.2569 185.835 65.4283C186.828 64.8439 187.886 64.3781 188.988 64.0406C188.742 63.7583 188.576 63.4151 188.508 63.0469C187.273 63.4848 185.98 63.7387 184.67 63.8007Z"
          fill="#94CDDB"
        />
        <Path
          d="M1015.88 49.7522C1015.08 46.5998 1012.95 44.7838 1008.93 42.7793C1005.83 47.9288 1001.59 52.2917 996.523 55.5258C999.367 57.1534 1000.77 59.1579 1002.76 63.6123C1008.04 59.948 1012.51 55.2288 1015.88 49.7522Z"
          fill="#FBF6F3"
        />
        <Path
          d="M492.06 93.2822C489.809 95.2973 487.003 96.5869 484.008 96.9829C484.272 97.4882 484.43 98.0424 484.471 98.6112C484.512 99.18 484.436 99.7512 484.247 100.289C487.607 100.037 490.829 98.8498 493.55 96.8629C493.369 95.5612 492.856 94.3281 492.06 93.2822Z"
          fill="#FBF6F3"
        />
        <Path
          d="M216.948 86.0705C215.823 85.5221 214.817 84.7597 213.984 83.8262C213.46 84.2674 213.099 84.8701 212.956 85.5394C213.776 86.5214 214.747 87.3658 215.834 88.0408C215.971 86.8415 216.194 86.3275 216.948 86.0705Z"
          fill="#FD7064"
        />
        <Path
          d="M51.0372 185.2C51.6498 184.979 52.1733 184.564 52.5277 184.018C51.9225 183.708 51.4351 183.208 51.14 182.596C50.5449 182.772 49.9955 183.076 49.5295 183.487C50.1389 183.954 50.6511 184.536 51.0372 185.2Z"
          fill="#FD7064"
        />
        <Path
          d="M1117.8 263.82C1116.64 265.547 1115.78 267.467 1115.29 269.491C1116.53 269.796 1117.84 269.761 1119.07 269.388C1119.17 268.088 1119.68 266.855 1120.54 265.876C1119.96 265.757 1119.42 265.511 1118.94 265.156C1118.47 264.8 1118.08 264.344 1117.8 263.82Z"
          fill="#FBF6F3"
        />
        <Path
          d="M1057.63 34.417C1054.85 39.2892 1051.12 43.5582 1046.67 46.975C1048.37 49.4107 1050.83 51.2173 1053.66 52.1148C1057.34 49.6991 1061.15 45.7415 1065.65 39.985C1061.11 39.1113 1058.89 37.912 1057.63 34.417Z"
          fill="#FD7064"
        />
        <Path
          d="M495.212 50.9831C494.495 50.4875 493.878 49.8595 493.396 49.1328C492.997 49.3664 492.688 49.7289 492.522 50.1608C492.984 50.9155 493.562 51.5921 494.236 52.1653C494.458 51.4628 494.664 51.1373 495.212 50.9831Z"
          fill="#FBF6F3"
        />
        <Path
          d="M858.385 18.6034C856.264 16.6517 853.652 15.3134 850.83 14.7314C849.574 15.9658 848.776 17.5914 848.568 19.3401C851.361 19.8899 853.932 21.2413 855.969 23.2291C855.953 22.3175 856.165 21.4164 856.587 20.6082C857.009 19.8 857.627 19.1107 858.385 18.6034Z"
          fill="#FBF6F3"
        />
        <Path
          d="M300.537 60.5455C302.515 58.5336 303.794 55.9389 304.186 53.1443C302.964 51.5579 301.987 49.7964 301.29 47.9189C300.417 49.6322 299.166 50.1804 296.373 50.4031C298.303 53.5353 299.709 56.961 300.537 60.5455Z"
          fill="#FBF6F3"
        />
        <Path
          d="M473.522 -2.07324C471.21 0.256767 467.92 1.62736 459.919 1.83295C460.607 5.37948 462.407 8.61438 465.059 11.0673C470.202 10.5555 475.125 8.71979 479.347 5.73914C476.366 3.70038 475.219 1.81582 473.522 -2.07324Z"
          fill="#A0C460"
        />
        <Path
          d="M1347.12 176.275C1346.13 179.22 1346.13 182.41 1347.12 185.355C1350.09 184.027 1353.42 183.691 1356.59 184.395C1357.64 181.665 1358.12 178.75 1358 175.829C1354.44 176.682 1350.74 176.833 1347.12 176.275Z"
          fill="#FFCE63"
        />
        <Path
          d="M333.396 115.078C336.926 116.688 340.249 116.106 345.098 113.896C342.67 107.136 341.832 99.9074 342.648 92.7713C338.999 94.1933 336.103 93.9705 330.467 92.4629C329.887 100.122 330.884 107.819 333.396 115.078Z"
          fill="#FFCE63"
        />
        <Path
          d="M303.209 243.862C305.822 242.775 308.09 240.999 309.771 238.722C309.178 237.084 308.041 235.699 306.55 234.799C304.93 237.112 302.666 238.9 300.04 239.939C300.849 240.282 301.562 240.82 302.114 241.504C302.667 242.189 303.043 242.998 303.209 243.862Z"
          fill="#FBF6F3"
        />
        <Path
          d="M470.267 6.9378C471.191 7.69461 472.27 8.24012 473.427 8.53607C474.584 8.83203 475.792 8.87127 476.966 8.65104C478.315 4.90612 480.103 1.33468 482.294 -1.98819C481.034 -2.22621 479.855 -2.78035 478.868 -3.59863C476.554 0.330893 473.654 3.884 470.267 6.9378Z"
          fill="#94CDDB"
        />
        <Path
          d="M934.898 5.71915C932.524 4.07914 930.531 1.94618 929.056 -0.53418C926.329 4.47059 922.934 9.08144 918.965 13.1717C919.726 15.9202 921.493 18.2813 923.916 19.7849C928.127 15.5526 931.814 10.8303 934.898 5.71915Z"
          fill="#A0C460"
        />
        <Path
          d="M1107.59 44.6978C1106.76 44.1492 1105.81 43.7899 1104.82 43.6448C1103.84 43.4998 1102.83 43.5727 1101.87 43.8583C1101.1 47.0882 1099.95 50.2162 1098.44 53.1783C1099.52 53.2482 1100.56 53.5966 1101.46 54.1891C1103.02 50.7351 1105.08 47.5354 1107.59 44.6978Z"
          fill="#94CDDB"
        />
        <Path
          d="M337.457 54.5645C337.807 58.9328 339.555 63.072 342.442 66.3687C345.538 66.545 348.588 67.192 351.488 68.2875C350.323 65.4778 351.009 63.4904 353.578 59.9954C348.37 59.4472 343.727 57.3913 337.457 54.5645Z"
          fill="#FBF6F3"
        />
        <Path
          d="M981.618 42.4691C982.019 41.6709 982.269 40.8054 982.355 39.9164C981.809 39.8619 981.258 39.9566 980.762 40.1905C980.801 40.7438 980.65 41.2939 980.333 41.7495C980.587 41.7664 980.835 41.8397 981.057 41.9642C981.279 42.0887 981.471 42.2612 981.618 42.4691Z"
          fill="#A0C460"
        />
        <Path
          d="M1045.13 188.095C1043.22 184.897 1042.56 181.109 1043.28 177.456C1036.54 179.82 1030.09 182.956 1027.7 185.234C1028.8 188.556 1030.62 191.596 1033.02 194.143C1035.67 191.522 1039.17 190.168 1045.13 188.095Z"
          fill="#94CDDB"
        />
        <Path
          d="M572.77 14.269C572.007 13.9885 571.169 13.9885 570.406 14.269C570.939 16.7649 571.009 19.3375 570.612 21.8586C571.372 21.7185 572.156 21.8392 572.839 22.2013C573.379 19.5823 573.356 16.8783 572.77 14.269Z"
          fill="#A0C460"
        />
        <Path
          d="M204.338 42.2799C203.103 41.4422 201.632 41.022 200.141 41.0806C199.438 41.8699 198.617 42.546 197.708 43.0851C198.701 43.3763 199.078 43.976 199.421 45.3979C200.878 44.0958 202.539 43.0423 204.338 42.2799Z"
          fill="#A0C460"
        />
        <Path
          d="M293.838 58.1279C293.135 58.7007 292.641 59.4897 292.433 60.3723C292.767 60.9009 293.016 61.4791 293.17 62.0855C293.512 61.5544 293.941 61.4345 294.883 61.4516C294.352 60.4095 293.999 59.2862 293.838 58.1279Z"
          fill="#FD7064"
        />
        <Path
          d="M182.957 208.398C182.083 208.387 181.221 208.187 180.432 207.811C179.642 207.435 178.943 206.894 178.383 206.223C175.968 210.287 174.15 214.678 172.986 219.26C174.564 220.671 176.494 221.63 178.571 222.036C178.827 217.187 180.338 212.488 182.957 208.398Z"
          fill="#A0C460"
        />
        <Path
          d="M1112.25 180.625C1117.5 175.714 1121.84 169.914 1125.07 163.493C1121.13 161.521 1116.73 160.645 1112.34 160.957C1111.21 165.343 1108.79 167.81 1104.68 171.545C1106.54 172.397 1108.19 173.655 1109.5 175.227C1110.81 176.798 1111.75 178.642 1112.25 180.625Z"
          fill="#FFCE63"
        />
        <Path
          d="M144.392 40.1924C144.615 45.4692 145.334 49.6667 147.716 53.3673C150.534 53.5756 153.339 52.8139 155.665 51.2086C153.346 47.2827 152.243 42.7576 152.495 38.2051C149.497 40.2781 147.441 41.0491 144.392 40.1924Z"
          fill="#94CDDB"
        />
        <Path
          d="M624.973 9.48909C625.693 9.35203 626.07 8.94085 626.686 8.23842C624.983 6.72394 623.577 4.90543 622.54 2.87598C622.088 3.36637 621.485 3.69193 620.827 3.80113C621.787 5.97166 623.201 7.91124 624.973 9.48909Z"
          fill="#FFCE63"
        />
        <Path
          d="M186.383 264.009C188.097 263.735 189.073 262.741 190.29 260.788C187.797 258.954 185.762 256.567 184.345 253.815C183.254 255.258 181.678 256.257 179.907 256.625C181.538 259.504 183.742 262.017 186.383 264.009Z"
          fill="#A0C460"
        />
        <Path
          d="M1142.77 290.7C1142.45 290.874 1142.17 291.119 1141.96 291.416C1141.76 291.713 1141.62 292.055 1141.57 292.413C1142.44 293.193 1143.22 294.066 1143.9 295.018C1144.1 294.695 1144.38 294.43 1144.72 294.247C1143.88 293.175 1143.23 291.978 1142.77 290.7Z"
          fill="#FD7064"
        />
        <Path
          d="M1069.95 189.877C1069.85 194.4 1070.16 199.334 1073.12 203.583C1076.45 204.365 1079.65 205.648 1082.6 207.386C1081.86 204.114 1082.97 202.092 1086.43 198.82C1080.88 197.244 1076.22 194.143 1069.95 189.877Z"
          fill="#FD7064"
        />
        <Path
          d="M939.85 97.7402C939.048 98.2699 938.401 99.0022 937.974 99.8627C937.546 100.723 937.354 101.681 937.417 102.64C938.712 103.96 940.414 104.805 942.248 105.039C943.696 103.204 945.632 101.815 947.833 101.03C944.976 100.487 942.26 99.3678 939.85 97.7402Z"
          fill="#FFCE63"
        />
        <Path
          d="M1124.67 85.9173C1125.75 84.8483 1126.57 83.5552 1127.09 82.1305C1127.6 80.7059 1127.8 79.185 1127.65 77.6766C1123.12 75.5246 1118.86 72.8386 1114.96 69.6758C1114.52 71.2583 1113.68 72.699 1112.51 73.8561C1117.15 77.242 1121.25 81.3081 1124.67 85.9173Z"
          fill="#A0C460"
        />
        <Path
          d="M1193.27 16.5986C1192.73 18.574 1191.8 20.4244 1190.55 22.0467C1191.38 22.7419 1192.41 23.1557 1193.49 23.2289C1194.81 21.5942 1195.88 19.7688 1196.65 17.815C1194.93 17.935 1194.03 17.7122 1193.27 16.5986Z"
          fill="#94CDDB"
        />
        <Path
          d="M868.664 147.078C868.818 146.138 868.674 145.174 868.253 144.32C867.596 144.112 866.977 143.8 866.42 143.395C866.505 144.063 866.231 144.457 865.478 145.108C866.639 145.589 867.714 146.255 868.664 147.078Z"
          fill="#94CDDB"
        />
        <Path
          d="M1092.28 156.193C1092.07 156.214 1091.87 156.19 1091.68 156.125C1091.49 156.06 1091.31 155.955 1091.16 155.816C1090.72 156.832 1090.42 157.904 1090.27 159.003C1090.68 159.286 1091.16 159.452 1091.66 159.483C1091.57 158.351 1091.78 157.216 1092.28 156.193Z"
          fill="#FFCE63"
        />
        <Path
          d="M1066.46 25.8506C1066.17 25.8535 1065.89 25.9329 1065.65 26.0805C1065.4 26.2282 1065.21 26.4387 1065.07 26.6901C1065.19 27.2241 1065.48 27.7052 1065.89 28.0607C1066.55 27.8275 1067.25 27.7859 1067.93 27.9407C1067.31 27.3483 1066.81 26.6379 1066.46 25.8506Z"
          fill="#FFCE63"
        />
        <Path
          d="M1072.13 -6.93953C1073.28 -5.74654 1074.1 -4.26523 1074.49 -2.65004C1074.88 -1.03486 1074.83 0.65503 1074.34 2.24342C1078.9 1.00989 1081.59 -0.857538 1086.33 -4.60953C1086.91 -7.91608 1086.16 -9.74924 1083.71 -12.6104C1079.65 -9.42373 1076.51 -7.45351 1072.13 -6.93953Z"
          fill="#FFCE63"
        />
        <Path
          d="M153.078 233.531C153.188 235.169 152.694 236.79 151.69 238.088C154.237 238.518 156.837 238.518 159.383 238.088C159.601 236.563 159.484 235.007 159.04 233.531C157.077 233.969 155.041 233.969 153.078 233.531Z"
          fill="#FFCE63"
        />
        <Path
          d="M80.0425 100.977C80.1883 101.228 80.386 101.445 80.6223 101.613C80.8587 101.781 81.1283 101.897 81.4131 101.953C82.0616 101.221 82.7916 100.566 83.5889 100C83.3174 99.838 83.093 99.6076 82.9379 99.332C82.0635 100.027 81.0868 100.581 80.0425 100.977Z"
          fill="#FD7064"
        />
        <Path
          d="M145.848 321.332C146.515 322.198 147.004 323.188 147.287 324.245C147.854 324.117 148.364 323.811 148.743 323.371C148.463 322.287 148.03 321.249 147.458 320.287C146.979 321.058 146.567 321.366 145.848 321.332Z"
          fill="#A0C460"
        />
        <Path
          d="M818.226 64.9307C813.84 66.8324 811.476 67.5348 807.45 67.1236C807.627 67.8088 807.66 68.5231 807.548 69.2218C807.436 69.9205 807.181 70.5885 806.799 71.184C810.91 71.8546 815.126 71.3743 818.98 69.7963C819.169 68.1362 818.908 66.4559 818.226 64.9307Z"
          fill="#94CDDB"
        />
        <Path
          d="M1164.85 17.6624C1164.89 16.8904 1164.73 16.1212 1164.37 15.4352C1163.9 15.3794 1163.42 15.4883 1163.02 15.7436C1163.38 16.4207 1163.54 17.1878 1163.48 17.9536C1163.66 17.7951 1163.89 17.6855 1164.13 17.6346C1164.37 17.5838 1164.61 17.5933 1164.85 17.6624Z"
          fill="#A0C460"
        />
        <Path
          d="M208.656 266.614C209.757 268.847 210.174 271.356 209.855 273.826C210.313 273.727 210.787 273.723 211.246 273.815C211.706 273.906 212.142 274.091 212.528 274.357C213.083 271.645 212.863 268.83 211.894 266.237C210.8 266.075 209.683 266.205 208.656 266.614Z"
          fill="#FBF6F3"
        />
        <Path
          d="M260.053 69.5381C260.033 70.2973 259.782 71.0325 259.333 71.6454C259.693 71.7996 259.899 71.9538 259.984 72.1765C260.527 71.5276 260.872 70.7368 260.978 69.8979C260.712 69.6893 260.39 69.5641 260.053 69.5381Z"
          fill="#FFCE63"
        />
        <Path
          d="M1179.29 92.5149C1181 95.3931 1183.73 96.541 1188.34 97.2777C1189.81 91.2121 1192.68 85.571 1196.7 80.7963C1193.37 80.0767 1191.37 78.5177 1188.01 74.7314C1183.91 79.9939 1180.94 86.0488 1179.29 92.5149Z"
          fill="#94CDDB"
        />
        <Path
          d="M1153.16 143.19C1151.54 143.521 1150.09 144.427 1149.09 145.743C1152.7 149.472 1155.6 153.826 1157.65 158.592C1158.81 157.544 1160.28 156.905 1161.83 156.776C1159.95 151.68 1156.99 147.047 1153.16 143.19Z"
          fill="#FBF6F3"
        />
        <Path
          d="M709.761 9.61059C711.298 11.2768 712.301 13.3654 712.639 15.6069C713.013 15.4003 713.425 15.2737 713.849 15.2354C714.274 15.197 714.702 15.2477 715.106 15.3842C714.877 12.9058 713.977 10.5367 712.502 8.53125C711.509 8.64085 710.563 9.01344 709.761 9.61059Z"
          fill="#94CDDB"
        />
        <Path
          d="M1106.94 203.807C1106.76 203.91 1106.56 203.973 1106.35 203.991C1106.15 204.009 1105.94 203.981 1105.74 203.909C1105.73 205.07 1105.9 206.225 1106.24 207.336C1106.74 207.423 1107.25 207.382 1107.73 207.216C1107.18 206.167 1106.9 204.992 1106.94 203.807Z"
          fill="#FD7064"
        />
        <Path
          d="M127.156 3.50869C126.725 3.31329 126.253 3.22232 125.78 3.24315C125.307 3.26399 124.845 3.39604 124.432 3.62862C124.897 5.22533 124.991 6.90714 124.706 8.54562C125.645 8.27928 126.648 8.3583 127.533 8.76834C127.766 7.00771 127.638 5.21818 127.156 3.50869Z"
          fill="#FBF6F3"
        />
        <Path
          d="M1228.87 23.5224C1224.34 24.1722 1219.72 23.916 1215.29 22.7686C1214.57 25.09 1214.64 27.5811 1215.48 29.8614C1219.98 31.1275 1224.66 31.7051 1229.34 31.5746C1227.61 28.1139 1227.26 26.1094 1228.87 23.5224Z"
          fill="#FFCE63"
        />
        <Path
          d="M392.572 118.127C393.612 118.359 394.528 118.97 395.142 119.841C395.875 118.343 396.35 116.733 396.546 115.078C395.636 114.67 394.649 114.46 393.651 114.461C393.566 115.748 393.197 117 392.572 118.127Z"
          fill="#FFCE63"
        />
        <Path
          d="M934.316 250.235C935.474 250.287 936.633 250.142 937.742 249.807C937.524 249.141 937.127 248.549 936.594 248.094C935.941 248.412 935.203 248.514 934.487 248.385C934.591 248.688 934.63 249.01 934.6 249.329C934.571 249.648 934.474 249.957 934.316 250.235Z"
          fill="#FBF6F3"
        />
        <Path
          d="M156.059 155.2C155.249 155.818 154.322 156.267 153.335 156.519C153.453 157.049 153.735 157.529 154.14 157.89C155.153 157.643 156.124 157.244 157.018 156.708C156.316 156.314 156.025 155.868 156.059 155.2Z"
          fill="#94CDDB"
        />
        <Path
          d="M414.244 16.4443C412.556 17.5687 410.598 18.2191 408.572 18.3275C406.547 18.436 404.53 17.9987 402.731 17.0611C403.194 22.7833 404.839 26.4325 408.248 32.8914C412.103 34.3134 414.382 33.8166 418.425 31.538C415.478 25.9871 413.799 21.7896 414.244 16.4443Z"
          fill="#94CDDB"
        />
        <Path
          d="M859.327 70.3447C858.932 70.7899 858.448 71.1461 857.905 71.3898C858.859 72.0591 859.713 72.861 860.441 73.7712C861.019 73.6845 861.54 73.3775 861.897 72.9146C861.145 71.9597 860.282 71.097 859.327 70.3447Z"
          fill="#FD7064"
        />
        <Path
          d="M151.056 50.3516C151.105 51.4703 150.91 52.5862 150.484 53.6217C150.058 54.6572 149.411 55.5875 148.589 56.3479C153.944 59.1614 159.681 61.1758 165.619 62.3271C167.322 60.2248 168.413 57.6935 168.771 55.0116C161.644 55.0116 157.258 53.4183 151.056 50.3516Z"
          fill="#94CDDB"
        />
        <Path
          d="M1246.19 210.776C1245.61 211.063 1244.98 211.227 1244.33 211.256C1244.32 211.603 1244.44 211.941 1244.65 212.215C1245.32 212.187 1245.98 212.06 1246.6 211.839C1246.23 211.445 1246.09 211.136 1246.19 210.776Z"
          fill="#FFCE63"
        />
        <Path
          d="M29.6392 84.8208C29.7591 85.232 30.0161 85.4204 30.4615 85.7288C31.2301 84.661 32.1883 83.7435 33.2884 83.0219C32.9728 82.7847 32.7489 82.4458 32.6545 82.0625C31.4639 82.756 30.4357 83.6966 29.6392 84.8208Z"
          fill="#94CDDB"
        />
        <Path
          d="M1119.16 28.9877C1120.49 29.1453 1121.84 28.8102 1122.94 28.0454C1121.09 24.2866 1119.93 20.2239 1119.52 16.0527C1118.36 16.5742 1117.07 16.6948 1115.83 16.3954C1116.04 20.7805 1117.17 25.0723 1119.16 28.9877Z"
          fill="#FBF6F3"
        />
        <Path
          d="M1160.74 59.3441C1161.55 60.8103 1162.74 62.0352 1164.18 62.8955C1165.62 63.7558 1167.27 64.2209 1168.94 64.244C1171.72 61.4685 1173.35 59.1042 1173.79 56.1232C1170.64 53.3649 1169.32 50.658 1167.54 45.8438C1166.21 50.757 1163.89 55.3495 1160.74 59.3441Z"
          fill="#94CDDB"
        />
        <Path
          d="M1137.9 113.961C1138.56 114.31 1139.13 114.797 1139.58 115.389C1140.03 115.98 1140.34 116.662 1140.5 117.388C1143.87 115.246 1146.92 112.633 1149.55 109.627C1148.9 107.96 1147.81 106.502 1146.4 105.412C1144.36 108.953 1141.43 111.9 1137.9 113.961Z"
          fill="#94CDDB"
        />
        <Path
          d="M1209.19 198.941C1209.01 198.466 1208.67 198.07 1208.23 197.827C1207.29 199.085 1206.13 200.159 1204.8 200.997C1205.17 201.298 1205.43 201.714 1205.54 202.179C1206.97 201.364 1208.21 200.261 1209.19 198.941Z"
          fill="#FD7064"
        />
        <Path
          d="M890.354 50.488C889.619 50.5137 888.9 50.27 888.332 49.8027C888.093 50.9289 888.047 52.0875 888.195 53.2292C888.879 53.3439 889.579 53.3148 890.251 53.1436C890.087 52.2617 890.122 51.3545 890.354 50.488Z"
          fill="#A0C460"
        />
        <Path
          d="M1121.45 34.8984C1118.76 36.3409 1115.78 37.1881 1112.73 37.3826C1116.13 42.3726 1118.83 47.802 1120.77 53.5213C1123.71 54.1187 1126.76 53.593 1129.33 52.048C1127.4 46.0368 1124.76 40.2792 1121.45 34.8984Z"
          fill="#FD7064"
        />
        <Path
          d="M1090.58 312.408C1088.27 310.076 1085.26 308.556 1082.01 308.073C1080.17 309.481 1078.11 310.591 1075.92 311.363C1077.94 312.408 1078.52 313.881 1078.74 317.119C1081.98 314.909 1085.63 313.83 1090.58 312.408Z"
          fill="#94CDDB"
        />
        <Path
          d="M1196.37 243.689C1198.27 243.209 1199.25 241.975 1200.81 240.056C1195.98 236.204 1191.88 231.508 1188.71 226.196C1187.51 227.613 1185.87 228.589 1184.05 228.972C1187.06 234.702 1191.26 239.721 1196.37 243.689Z"
          fill="#FBF6F3"
        />
        <Path
          d="M204.321 115.044C203.769 114.918 203.194 114.939 202.653 115.104C202.112 115.27 201.624 115.574 201.237 115.987C201.197 117.086 201.529 118.166 202.179 119.053C203.556 118.928 204.94 119.195 206.171 119.824C205.239 118.372 204.609 116.746 204.321 115.044Z"
          fill="#FFCE63"
        />
        <Path
          d="M735.957 73.9424C736.442 74.341 737.015 74.6201 737.628 74.757C738.241 74.8939 738.877 74.8848 739.486 74.7305C739.435 72.526 739.892 70.3393 740.822 68.3401C739.531 68.3623 738.275 67.9113 737.293 67.0723C736.388 69.2483 735.933 71.5855 735.957 73.9424Z"
          fill="#FFCE63"
        />
        <Path
          d="M1104.47 130.222C1101.8 124.923 1098.22 120.133 1093.89 116.07C1091.39 118.734 1089.67 122.027 1088.9 125.596C1092.12 127.515 1093.6 130.033 1095.53 134.162C1096.64 132.884 1098.01 131.867 1099.56 131.186C1101.11 130.505 1102.79 130.175 1104.47 130.222Z"
          fill="#94CDDB"
        />
        <Path
          d="M1093.7 96.4536C1094.14 97.2662 1094.4 98.1645 1094.46 99.087C1094.52 100.01 1094.39 100.935 1094.06 101.799C1099.04 101.939 1104.01 101.362 1108.83 100.086C1109.33 97.906 1109.22 95.63 1108.52 93.5068C1103.92 95.768 1098.81 96.784 1093.7 96.4536Z"
          fill="#FFCE63"
        />
        <Path
          d="M446.659 88.5547C440.351 89.5989 434.275 91.7384 428.704 94.8766C430.649 98.2924 433.478 101.121 436.893 103.066C439.909 100.359 442.975 99.6394 447.824 99.0055C446.864 97.4602 446.261 95.72 446.059 93.9119C445.858 92.1038 446.063 90.2735 446.659 88.5547Z"
          fill="#A0C460"
        />
        <Path
          d="M1189.18 100.326C1187.27 100.207 1185.43 99.5765 1183.85 98.5002C1182.27 97.4239 1181.01 95.9419 1180.2 94.21C1177.27 98.7672 1176.41 102.434 1175.3 109.218C1177.36 112.49 1179.36 113.415 1183.69 114.032C1184.71 108.207 1185.84 104.112 1189.18 100.326Z"
          fill="#FD7064"
        />
        <Path
          d="M1284.57 166.098C1285.24 165.078 1285.62 163.892 1285.67 162.671C1285.06 162.241 1284.33 162.019 1283.59 162.037C1283.57 163.265 1283.18 164.457 1282.48 165.464C1282.85 165.384 1283.24 165.401 1283.61 165.512C1283.97 165.622 1284.3 165.824 1284.57 166.098Z"
          fill="#94CDDB"
        />
        <Path
          d="M1224.5 68.7347C1223.39 67.8503 1222.47 66.7412 1221.81 65.4795C1220.33 67.857 1218.53 70.0189 1216.45 71.9041C1216.74 73.2841 1217.54 74.5061 1218.68 75.3306C1220.88 73.373 1222.83 71.1585 1224.5 68.7347Z"
          fill="#FD7064"
        />
        <Path
          d="M408.18 109.287C408.416 108.184 408.984 107.18 409.807 106.409C409.434 106.199 409.153 105.856 409.019 105.449C408.057 106.253 407.33 107.3 406.912 108.482C407.26 108.852 407.696 109.129 408.18 109.287Z"
          fill="#FD7064"
        />
        <Path
          d="M210.454 182.013C209.863 184.835 208.245 187.338 205.914 189.037C211.054 191.23 216.279 192.858 218.849 192.806C219.983 190.346 220.568 187.668 220.563 184.959C217.616 185.097 214.926 184.017 210.454 182.013Z"
          fill="#FFCE63"
        />
        <Path
          d="M454.248 10.1754C454.8 9.81238 455.427 9.57817 456.082 9.49015C455.266 8.43796 454.586 7.28663 454.06 6.06367C453.413 5.98611 452.76 6.15089 452.227 6.52624C452.758 7.81626 453.437 9.04074 454.248 10.1754Z"
          fill="#FFCE63"
        />
        <Path
          d="M176.412 91.2113C171.187 86.4656 168.771 83.7416 166.852 78.0879C164.471 79.5613 162.775 80.1266 161.01 79.6983C162.723 85.9517 165.242 89.7037 170.365 95.1175C172.69 94.3731 174.777 93.0252 176.412 91.2113Z"
          fill="#FBF6F3"
        />
        <Path
          d="M211.14 -3.01551C205.892 -6.97855 199.989 -9.98826 193.699 -11.9072C192.521 -8.00992 192.414 -3.86725 193.391 0.0854511C197.537 0.410967 200.244 2.20987 204.167 5.36223C204.63 3.53364 205.496 1.83196 206.703 0.382194C207.909 -1.06757 209.426 -2.22857 211.14 -3.01551Z"
          fill="#94CDDB"
        />
        <Path
          d="M150.405 93.061C150.164 92.9847 149.941 92.8604 149.75 92.6955C149.559 92.5305 149.403 92.3285 149.292 92.1016C148.31 93.0513 147.467 94.1358 146.79 95.3225C147.126 95.8362 147.593 96.2504 148.144 96.5218C148.58 95.1893 149.36 93.9955 150.405 93.061Z"
          fill="#FBF6F3"
        />
        <Path
          d="M450.034 72.006C449.623 65.924 448.646 61.0755 445.802 56.8609C442.535 56.7106 439.314 57.6774 436.67 59.6021C439.453 64.0783 440.859 69.2732 440.714 74.5416C444.106 72.0574 446.47 71.1151 450.034 72.006Z"
          fill="#94CDDB"
        />
        <Path
          d="M849.956 57.0657C853.04 60.4921 855.969 61.5029 860.938 61.0918C863.645 57.1342 865.049 53.9304 864.912 50.247C860.509 47.66 858.334 44.6961 855.113 39.2822C854.153 46.2894 853.365 50.6067 849.956 57.0657Z"
          fill="#FFCE63"
        />
        <Path
          d="M279.67 176.532C278.944 177.524 278.009 178.345 276.932 178.937C275.854 179.529 274.66 179.878 273.433 179.959C276.027 186.051 279.489 191.735 283.713 196.834C286.607 196.236 289.284 194.862 291.457 192.859C285.358 187.822 282.839 183.488 279.67 176.532Z"
          fill="#FBF6F3"
        />
        <Path
          d="M381.881 40.7379C384.268 44.439 387.818 47.2415 391.972 48.7045C393.123 44.2607 395.669 40.3034 399.236 37.4142C397.135 33.8439 394.325 30.742 390.978 28.2998C388.78 32.9956 385.69 37.2198 381.881 40.7379Z"
          fill="#A0C460"
        />
        <Path
          d="M376.964 5.32662C381.453 6.20037 386.421 6.71434 391.219 4.48713C392.559 1.29967 394.379 -1.66418 396.615 -4.30179C393.189 -4.13047 391.39 -5.58672 388.666 -9.5957C386.164 -4.31892 382.275 -0.207149 376.964 5.32662Z"
          fill="#FFCE63"
        />
        <Path
          d="M738.921 5.20801C738.725 5.92598 738.761 6.68753 739.023 7.38382C739.507 7.59138 739.957 7.86842 740.36 8.20618C740.36 7.6922 740.565 7.41809 741.165 7.00691C740.323 6.53537 739.564 5.92751 738.921 5.20801Z"
          fill="#FD7064"
        />
        <Path
          d="M1288.72 50.0931C1288.57 51.0292 1288.74 51.9884 1289.2 52.8171C1290.01 52.2619 1290.99 51.9854 1291.97 52.029C1292.15 51.1587 1292.15 50.2609 1291.97 49.3906C1290.94 49.8297 1289.84 50.0681 1288.72 50.0931Z"
          fill="#94CDDB"
        />
        <Path
          d="M282.736 57.2373C282.717 57.8713 282.474 58.4781 282.051 58.9505C283.057 59.2053 284.1 59.2864 285.134 59.1904C285.263 58.5804 285.263 57.9501 285.134 57.3401C284.338 57.4957 283.516 57.4604 282.736 57.2373Z"
          fill="#FBF6F3"
        />
      </G>
      <Defs>
        <ClipPath id="Clip0_101_7927">
          <Rect
            width="1358"
            height="588.344"
            fill="white"
            transform="translate(0 -192.467)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export const FestivalUpgradeSmall = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 343 471"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#clip0_101_16710)">
        <Path
          d="M238.58 376.575C238.304 376.545 238.025 376.575 237.763 376.665C237.5 376.754 237.261 376.9 237.06 377.091C237.602 377.934 237.94 378.892 238.048 379.888C238.542 379.581 239.13 379.462 239.705 379.553C239.537 378.494 239.155 377.48 238.58 376.575Z"
          fill="#94CDDB"
        />
        <Path
          d="M257.5 332.442C257.402 331.418 257.51 330.385 257.819 329.403C257.302 329.228 256.741 329.228 256.223 329.403C255.889 330.382 255.71 331.408 255.692 332.442C256.482 332.108 256.953 332.047 257.5 332.442Z"
          fill="#FFCE63"
        />
        <Path
          d="M146.608 428.7C147.748 429.193 149.029 429.252 150.21 428.867C149.576 425.027 149.638 421.105 150.392 417.287C149.235 417.436 148.06 417.201 147.049 416.618C146.042 420.568 145.892 424.687 146.608 428.7Z"
          fill="#94CDDB"
        />
        <Path
          d="M210.602 350.313C207.137 352.866 204.356 353.657 199.402 352.274C200.512 357.821 202.563 361.209 206.666 367.121C210.602 368.078 212.745 367.319 216.484 364.614C213.003 359.538 210.861 355.602 210.602 350.313Z"
          fill="#FBF6F3"
        />
        <Path
          d="M86.474 269.588C86.3494 268.982 86.0092 268.442 85.5166 268.068C84.0799 269.437 82.4064 270.534 80.5776 271.305C80.9758 271.753 81.2161 272.319 81.2615 272.916C83.2175 272.193 84.9952 271.058 86.474 269.588Z"
          fill="#FBF6F3"
        />
        <Path
          d="M73.5872 453.533C73.738 453.891 73.8158 454.276 73.8158 454.665C73.8158 455.054 73.738 455.439 73.5872 455.797C74.1611 455.872 74.7437 455.755 75.2436 455.463C75.4099 454.655 75.3681 453.819 75.122 453.031C74.6831 453.37 74.1412 453.547 73.5872 453.533Z"
          fill="#FBF6F3"
        />
        <Path
          d="M210.633 396.011C210.951 395.94 211.281 395.938 211.6 396.003C211.919 396.069 212.222 396.201 212.487 396.391C212.994 394.714 213.26 392.975 213.277 391.224C212.584 390.846 211.801 390.667 211.013 390.707C211.353 392.478 211.222 394.307 210.633 396.011Z"
          fill="#94CDDB"
        />
        <Path
          d="M184.874 389.309C185.995 386.625 186.224 383.652 185.528 380.829C183.724 379.791 182.094 378.479 180.695 376.938C180.513 378.944 179.51 379.978 176.926 381.193C179.92 383.108 182.032 385.737 184.874 389.309Z"
          fill="#FFCE63"
        />
        <Path
          d="M97.2944 363.945C94.619 363.475 92.0749 362.439 89.8327 360.906C89.4243 366.251 88.2945 371.516 86.4742 376.558C88.2071 378.62 90.6446 379.963 93.3128 380.327C95.285 375.044 96.6215 369.544 97.2944 363.945Z"
          fill="#A0C460"
        />
        <Path
          d="M42.8895 411.877C43.9118 411.665 44.9677 411.677 45.9852 411.91C47.0027 412.144 47.958 412.594 48.7859 413.229C50.5583 407.863 51.5411 402.268 51.7037 396.619C49.501 395.375 46.9986 394.76 44.47 394.841C45.5641 401.421 44.7435 405.631 42.8895 411.877Z"
          fill="#FD7064"
        />
        <Path
          d="M146.836 382.212C142.718 386.452 140.332 388.397 135.53 389.81C136.059 390.509 136.437 391.311 136.638 392.164C136.84 393.017 136.861 393.903 136.7 394.765C142.004 393.564 145.241 391.528 150.012 387.409C149.431 385.427 148.335 383.634 146.836 382.212Z"
          fill="#A0C460"
        />
        <Path
          d="M305.887 197.95C303.182 199.713 302.148 202.296 301.541 206.703C307.374 207.974 312.834 210.574 317.497 214.302C318.105 211.11 319.534 209.165 323.09 205.867C317.963 202.07 312.106 199.375 305.887 197.95Z"
          fill="#FBF6F3"
        />
        <Path
          d="M245.601 267.765C245.707 270.227 246.908 271.761 248.975 274.178C254.096 269.482 260.935 266.032 269.217 262.765C267.748 260.893 266.955 258.579 266.968 256.2C259.099 258.479 251.812 262.423 245.601 267.765Z"
          fill="#94CDDB"
        />
        <Path
          d="M222.927 362.578C222.707 362.665 222.467 362.693 222.232 362.658C221.997 362.623 221.776 362.528 221.59 362.38C221.527 363.04 221.615 363.705 221.848 364.325C222.025 364.44 222.228 364.507 222.439 364.52C222.649 364.533 222.859 364.492 223.049 364.401C222.831 363.819 222.788 363.184 222.927 362.578Z"
          fill="#A0C460"
        />
        <Path
          d="M270.828 249.952C270.495 249.494 270.248 248.979 270.098 248.433C269.791 248.482 269.512 248.638 269.308 248.873C269.437 249.459 269.652 250.022 269.946 250.545C270.235 250.119 270.448 249.922 270.828 249.952Z"
          fill="#94CDDB"
        />
        <Path
          d="M255.16 279.998C255.136 278.46 255.526 276.944 256.288 275.607C257.049 274.271 258.156 273.163 259.491 272.4C255.646 270.348 252.637 269.907 247.121 269.451C244.644 271.321 244.081 272.977 243.823 276.503C248.595 276.928 251.953 277.567 255.16 279.998Z"
          fill="#94CDDB"
        />
        <Path
          d="M175.589 368.869C174.552 367.628 173.786 366.184 173.34 364.629C171.131 366.937 168.621 368.936 165.878 370.571C165.888 372.167 166.495 373.702 167.58 374.872C170.481 373.199 173.17 371.184 175.589 368.869Z"
          fill="#A0C460"
        />
        <Path
          d="M4.289 306.135C3.50433 305.877 2.65734 305.877 1.87267 306.135C1.60144 306.656 1.25305 307.132 0.839295 307.549C1.41677 307.549 1.70551 307.837 2.11582 308.552C2.70338 307.633 3.43752 306.817 4.289 306.135Z"
          fill="#A0C460"
        />
        <Path
          d="M15.3831 422.226C16.1521 421.284 16.7488 420.214 17.1459 419.065C16.4419 418.824 15.6861 418.776 14.9575 418.928C14.8318 419.678 14.4634 420.367 13.9089 420.888C14.2388 420.987 14.5424 421.159 14.7974 421.39C15.0525 421.621 15.2526 421.907 15.3831 422.226Z"
          fill="#FD7064"
        />
        <Path
          d="M195.33 251.64C194.327 249.649 192.761 248.843 190.148 247.612C187.686 253.402 183.355 258.797 177.747 264.587C179.652 265.576 181.164 267.184 182.032 269.146C187.66 264.324 192.193 258.355 195.33 251.64Z"
          fill="#94CDDB"
        />
        <Path
          d="M18.6351 453.289C18.3656 456.078 17.2704 458.724 15.4894 460.887C15.9771 461.05 16.4266 461.311 16.8106 461.653C17.1946 461.996 17.5051 462.412 17.7233 462.878C19.8493 460.624 21.3113 457.826 21.9481 454.793C20.9975 454.006 19.8537 453.486 18.6351 453.289Z"
          fill="#FFCE63"
        />
        <Path
          d="M278.973 344.052C281.222 345.45 283.304 345.298 286.708 344.949C285.645 337.563 286.708 329.418 288.851 320.087C286.331 320.256 283.828 319.576 281.739 318.157C278.978 326.492 278.035 335.322 278.973 344.052Z"
          fill="#A0C460"
        />
        <Path
          d="M318.835 259.132C319.09 258.863 319.269 258.532 319.355 258.172C319.44 257.811 319.428 257.435 319.321 257.08C318.718 256.703 318.009 256.533 317.3 256.594C316.918 257.41 316.312 258.1 315.552 258.585C316.673 258.54 317.79 258.726 318.835 259.132Z"
          fill="#FBF6F3"
        />
        <Path
          d="M18.2094 361.544C18.362 361.815 18.5823 362.041 18.8487 362.201C19.1151 362.361 19.4185 362.449 19.7291 362.456C20.1885 362.063 20.504 361.528 20.6257 360.936C20.0608 360.423 19.6547 359.758 19.4555 359.022C19.2123 359.937 18.7886 360.795 18.2094 361.544Z"
          fill="#A0C460"
        />
        <Path
          d="M163.127 197.326C163.649 196.233 163.871 195.022 163.773 193.816C163.674 192.609 163.257 191.45 162.565 190.457C160.301 189.884 157.911 190.082 155.772 191.019C155.483 194.059 154.435 195.928 152.353 198.982C155.795 197.707 159.461 197.143 163.127 197.326Z"
          fill="#FD7064"
        />
        <Path
          d="M153.341 312.719C153.214 313.273 152.965 313.793 152.611 314.239C153.696 314.399 154.754 314.706 155.757 315.15C156.207 314.833 156.517 314.354 156.623 313.813C155.577 313.318 154.475 312.95 153.341 312.719Z"
          fill="#FD7064"
        />
        <Path
          d="M299.398 295.438C298.817 295.396 298.274 295.135 297.878 294.708C297.58 295.558 297.431 296.452 297.438 297.353C297.929 297.506 298.447 297.552 298.957 297.489C298.943 296.781 299.094 296.078 299.398 295.438Z"
          fill="#94CDDB"
        />
        <Path
          d="M120.348 310.164C120.884 310.575 121.329 311.092 121.655 311.684C122.331 310.566 123.154 309.543 124.102 308.644C123.932 308.018 123.537 307.477 122.992 307.125C121.991 308.027 121.104 309.048 120.348 310.164Z"
          fill="#FD7064"
        />
        <Path
          d="M7.26788 232.522C8.16591 232.117 8.93773 231.476 9.50183 230.668C9.2744 230.108 8.86844 229.638 8.34685 229.331C7.80153 230.143 7.03013 230.777 6.12811 231.155C6.41914 231.266 6.67669 231.451 6.87623 231.69C7.07576 231.93 7.21062 232.216 7.26788 232.522Z"
          fill="#94CDDB"
        />
        <Path
          d="M12.4501 381.042C10.2973 383.294 8.55847 385.907 7.31354 388.762C9.06925 389.517 10.9945 389.79 12.8907 389.553C13.3694 387.674 14.434 385.998 15.9301 384.766C15.1102 384.442 14.3726 383.94 13.7707 383.296C13.1687 382.652 12.7177 381.882 12.4501 381.042Z"
          fill="#94CDDB"
        />
        <Path
          d="M273.943 208.876C273.446 208.341 273.072 207.703 272.849 207.007C271.887 208.089 270.783 209.034 269.567 209.819C269.597 210.542 269.902 211.226 270.418 211.733C271.707 210.931 272.891 209.971 273.943 208.876Z"
          fill="#FBF6F3"
        />
        <Path
          d="M247.865 428.744C246.648 427.541 245.775 426.034 245.337 424.38C244.899 422.726 244.911 420.985 245.373 419.337C240.723 420.705 238.002 422.696 233.215 426.632C232.699 430.051 233.504 431.859 236.088 434.808C240.221 431.464 243.397 429.352 247.865 428.744Z"
          fill="#94CDDB"
        />
        <Path
          d="M357.328 388.686C357.192 384.294 356.629 379.567 353.529 375.495C350.255 374.922 347.087 373.851 344.138 372.318C345.019 375.449 344.031 377.485 340.87 380.874C346.341 382.12 351.022 384.886 357.328 388.686Z"
          fill="#FD7064"
        />
        <Path
          d="M125.986 206.049C123.308 205.191 120.845 203.765 118.767 201.87C117.637 207.31 115.771 212.571 113.221 217.507C114.708 219.856 117.025 221.559 119.71 222.279C122.444 217.14 124.551 211.691 125.986 206.049Z"
          fill="#FD7064"
        />
        <Path
          d="M205.147 291.883C205.352 291.625 205.496 291.325 205.57 291.004C205.644 290.683 205.644 290.35 205.572 290.029C204.53 289.687 203.535 289.218 202.609 288.631C202.551 288.985 202.405 289.32 202.183 289.603C203.278 290.213 204.277 290.981 205.147 291.883Z"
          fill="#FD7064"
        />
        <Path
          d="M271.04 300.893C269.825 304.054 267.302 306.714 259.855 310.209C261.986 313.264 265.037 315.559 268.563 316.759C273.745 313.385 276.557 310.969 279.703 305.863C276.116 305.164 274.247 303.857 271.04 300.893Z"
          fill="#FBF6F3"
        />
        <Path
          d="M102.917 293.082C102.709 292.839 102.442 292.654 102.141 292.545C101.84 292.435 101.516 292.406 101.2 292.459C100.809 292.941 100.595 293.541 100.592 294.161C101.247 294.576 101.774 295.165 102.112 295.863C102.189 294.891 102.463 293.945 102.917 293.082Z"
          fill="#FD7064"
        />
        <Path
          d="M156.638 328.37C158.553 327.322 160.787 327.013 162.914 327.504C162.024 324.196 160.591 321.058 158.675 318.219C156.705 318.798 154.885 319.798 153.341 321.152C154.86 322.762 155.559 324.844 156.638 328.37Z"
          fill="#FD7064"
        />
        <Path
          d="M194.995 360.328C197.298 358.13 198.828 355.246 199.357 352.107C198.045 350.277 197.02 348.258 196.317 346.119C195.269 348.079 193.825 348.611 190.694 348.763C192.731 351.939 193.719 355.511 194.995 360.328Z"
          fill="#94CDDB"
        />
        <Path
          d="M36.4458 300.483C36.3547 299.982 36.4459 299.419 37.1601 298.356C36.6322 298.131 36.0459 298.083 35.4885 298.219C35.0969 298.93 34.8978 299.732 34.911 300.544C35.4033 300.362 35.9407 300.34 36.4458 300.483Z"
          fill="#94CDDB"
        />
        <Path
          d="M273.031 364.386C274.103 363.342 274.802 361.975 275.022 360.495C273.458 360.404 271.962 359.819 270.752 358.824C269.693 359.761 268.844 360.91 268.26 362.197C269.975 362.616 271.595 363.359 273.031 364.386Z"
          fill="#FFCE63"
        />
        <Path
          d="M98.3734 300.5C97.6839 300.261 96.9503 300.178 96.2251 300.257C95.4998 300.336 94.8011 300.575 94.179 300.956C94.2103 303.373 93.9552 305.786 93.4192 308.144C94.1974 308.011 94.9963 308.074 95.7443 308.326C96.2197 305.599 97.1061 302.961 98.3734 300.5Z"
          fill="#94CDDB"
        />
        <Path
          d="M10.9608 364.949C10.9288 365.279 10.9739 365.611 11.0926 365.919C11.2113 366.228 11.4004 366.505 11.6447 366.728C12.5986 366.059 13.6976 365.627 14.8512 365.466C14.4671 364.9 14.2998 364.215 14.3801 363.536C13.1557 363.769 11.992 364.25 10.9608 364.949Z"
          fill="#94CDDB"
        />
        <Path
          d="M7.69354 338.263C7.08331 335.449 7.08331 332.536 7.69354 329.722C2.2899 331.522 -3.3343 332.575 -9.02306 332.853C-10.3336 335.376 -10.6483 338.3 -9.90451 341.044C-3.94763 340.832 1.96157 339.898 7.69354 338.263Z"
          fill="#A0C460"
        />
        <Path
          d="M113.829 291.152C114.439 290.86 114.976 290.436 115.402 289.91C115.828 289.384 116.131 288.771 116.291 288.113C114.702 286.54 113.305 284.785 112.127 282.885C111.708 283.484 111.143 283.965 110.485 284.283C111.947 286.387 113.075 288.704 113.829 291.152Z"
          fill="#FD7064"
        />
        <Path
          d="M349.548 235.03C349.904 234.09 349.904 233.052 349.548 232.112C346.49 232.825 343.329 232.98 340.217 232.568C340.407 233.493 340.284 234.456 339.867 235.303C343.077 235.894 346.376 235.801 349.548 235.03Z"
          fill="#A0C460"
        />
        <Path
          d="M259.46 276.397C258.718 279.989 257.21 283.379 255.038 286.335C263.898 287.536 269.764 288.797 276.055 291.381C278.91 289.122 280.801 285.863 281.344 282.263C276.846 280.211 268.837 277.992 259.46 276.397Z"
          fill="#FBF6F3"
        />
        <Path
          d="M268.989 229.711C268.581 230.227 268.352 230.862 268.335 231.52C269.019 231.468 269.701 231.639 270.281 232.006C270.686 231.536 270.991 230.987 271.177 230.395C270.409 230.32 269.664 230.087 268.989 229.711Z"
          fill="#A0C460"
        />
        <Path
          d="M241.604 278.386C240.285 278.164 239.05 277.592 238.028 276.728C237.006 275.864 236.237 274.741 235.799 273.477C233.428 276.44 232.577 278.933 231.24 283.583C232.441 285.999 233.763 286.79 236.741 287.534C237.927 283.553 239.006 280.787 241.604 278.386Z"
          fill="#94CDDB"
        />
        <Path
          d="M101.793 418.808C101.428 417.789 100.729 417.288 99.5435 416.558C97.6869 419.455 95.318 421.988 92.5529 424.035C93.3973 424.628 94.0224 425.483 94.331 426.467C97.3354 424.474 99.8794 421.863 101.793 418.808Z"
          fill="#FFCE63"
        />
        <Path
          d="M337.8 430.54C338.812 429.362 339.353 427.852 339.32 426.3C334.522 425.624 329.887 424.079 325.643 421.741C325.388 423.185 324.648 424.498 323.546 425.464C327.878 428.159 332.74 429.89 337.8 430.54Z"
          fill="#FBF6F3"
        />
        <Path
          d="M331.524 278.996C331.883 279.689 332.09 280.45 332.132 281.229C333.418 280.377 334.814 279.702 336.281 279.224C336.448 278.471 336.323 277.684 335.931 277.02C334.389 277.501 332.91 278.164 331.524 278.996Z"
          fill="#A0C460"
        />
        <Path
          d="M237.668 198.116C238.066 197.432 238.231 196.638 238.139 195.852C237.699 195.508 237.315 195.098 236.999 194.636C236.878 195.183 236.574 195.411 235.844 195.654C236.579 196.373 237.195 197.204 237.668 198.116Z"
          fill="#FD7064"
        />
        <Path
          d="M186.409 227.145C186.982 226.822 187.638 226.679 188.293 226.734C188.259 226.615 188.25 226.489 188.269 226.365C188.287 226.242 188.332 226.124 188.4 226.02C187.679 225.912 186.942 226.006 186.272 226.294C186.247 226.584 186.294 226.877 186.409 227.145Z"
          fill="#FFCE63"
        />
        <Path
          d="M134.983 398.578C134.77 402.879 134.983 406.359 136.67 409.535C138.944 409.924 141.282 409.522 143.295 408.396C141.732 405.023 141.203 401.263 141.776 397.591C139.132 399.05 137.399 399.505 134.983 398.578Z"
          fill="#FBF6F3"
        />
        <Path
          d="M52.342 332.548C51.1813 333.09 49.8617 333.187 48.634 332.821C49.0383 334.797 49.7675 336.692 50.7919 338.429C51.964 338.164 53.0637 337.645 54.0137 336.909C53.1402 335.597 52.5692 334.107 52.342 332.548Z"
          fill="#FD7064"
        />
        <Path
          d="M141.821 248.343C142.353 253.54 143.341 257.658 145.863 261.184C148.662 261.239 151.395 260.327 153.599 258.601C151.093 254.842 149.75 250.429 149.739 245.911C146.897 248.13 144.906 249.011 141.821 248.343Z"
          fill="#FD7064"
        />
        <Path
          d="M122.096 440.492C122.532 441.038 122.813 441.692 122.91 442.385C123.006 443.077 122.914 443.783 122.643 444.428C124.561 444.058 126.366 443.246 127.916 442.057C128.104 441.467 128.135 440.838 128.004 440.233C127.873 439.627 127.586 439.067 127.171 438.607C125.701 439.72 123.936 440.375 122.096 440.492Z"
          fill="#A0C460"
        />
        <Path
          d="M81.915 291.381C81.5105 291.98 80.9946 292.496 80.3953 292.9C80.5898 293.244 80.8952 293.512 81.2615 293.66C81.917 293.25 82.5019 292.737 82.9939 292.14C82.3101 292.034 82.0365 291.852 81.915 291.381Z"
          fill="#FBF6F3"
        />
        <Path
          d="M176.364 332.049C175.854 329.021 175.947 325.923 176.637 322.931C175.067 322.5 173.399 322.585 171.881 323.174C171.116 326.222 170.819 329.368 170.999 332.505C173.264 331.274 174.616 331.016 176.364 332.049Z"
          fill="#FFCE63"
        />
        <Path
          d="M319.655 356.195C319.138 355.643 318.845 354.916 318.835 354.159C317.795 354.739 316.86 355.489 316.069 356.378C316.435 356.983 316.927 357.501 317.513 357.897C318.094 357.181 318.826 356.6 319.655 356.195Z"
          fill="#FBF6F3"
        />
        <Path
          d="M24.1666 390.919C23.0086 392.764 22.4757 394.933 22.6469 397.104C23.8372 398.103 24.8629 399.282 25.6863 400.6C26.0814 399.08 26.9477 398.548 29.0297 397.94C27.0349 395.882 25.392 393.51 24.1666 390.919Z"
          fill="#FFCE63"
        />
        <Path
          d="M79.4378 416.482C80.5016 416.194 81.0336 415.51 81.8846 414.355C79.0841 412.276 76.6888 409.7 74.818 406.756C74.1717 407.585 73.2591 408.165 72.2345 408.398C74.0319 411.575 76.4879 414.332 79.4378 416.482Z"
          fill="#A0C460"
        />
        <Path
          d="M239.568 248.603C238.661 248.681 237.749 248.562 236.893 248.253C237.23 250.02 237.322 251.825 237.167 253.618C237.903 254.14 238.81 254.363 239.705 254.241C239.886 252.363 239.84 250.47 239.568 248.603Z"
          fill="#A0C460"
        />
        <Path
          d="M313.622 234.315C313.217 234.767 312.727 235.134 312.178 235.394C312.305 235.693 312.523 235.943 312.801 236.108C313.354 235.843 313.865 235.5 314.321 235.09C313.88 234.923 313.683 234.71 313.622 234.315Z"
          fill="#FD7064"
        />
        <Path
          d="M326.783 382.333C325.975 381.876 325.097 381.558 324.184 381.391C324.086 381.953 324.144 382.531 324.351 383.063C324.93 383.071 325.491 383.269 325.947 383.625C325.985 383.362 326.079 383.111 326.223 382.888C326.368 382.665 326.559 382.475 326.783 382.333Z"
          fill="#94CDDB"
        />
        <Path
          d="M33.6041 349.357C37.4337 349.357 39.5157 348.841 42.5551 346.06C41.1612 340.753 40.3961 335.3 40.2755 329.814C38.6407 330.543 36.8449 330.836 35.0631 330.665C35.5249 336.934 35.033 343.236 33.6041 349.357Z"
          fill="#A0C460"
        />
        <Path
          d="M347.192 255.273C349.506 254.408 351.471 252.806 352.785 250.714C350.45 249.559 348.548 247.683 347.359 245.365C345.112 246.109 343.042 247.309 341.281 248.891C343.648 250.613 345.656 252.781 347.192 255.273Z"
          fill="#A0C460"
        />
        <Path
          d="M53.7094 391.983C53.6334 388.291 53.2231 384.294 50.67 380.874C47.929 380.363 45.2837 379.43 42.8284 378.109C43.5275 380.753 42.6917 382.44 39.9866 385.251C44.5609 386.345 48.4817 388.716 53.7094 391.983Z"
          fill="#94CDDB"
        />
        <Path
          d="M53.1778 316.637C53.4871 315.64 53.5753 314.588 53.4362 313.554C53.2971 312.52 52.934 311.529 52.3724 310.649C48.903 310.788 45.4293 310.517 42.0232 309.844C42.2602 310.949 42.2026 312.096 41.856 313.172C45.7845 313.743 49.6025 314.912 53.1778 316.637Z"
          fill="#FFCE63"
        />
        <Path
          d="M197.67 334.176C197.989 335.695 197.67 337.322 195.725 340.513C197.294 341.146 199.024 341.263 200.664 340.847C201.759 338.707 202.283 336.32 202.184 333.917C200.748 334.497 199.162 334.587 197.67 334.176Z"
          fill="#FFCE63"
        />
        <Path
          d="M248.975 315.164C247.311 314.881 245.602 315.041 244.02 315.628C242.438 316.215 241.039 317.208 239.963 318.508C240.358 322.429 241.178 325.194 243.2 327.444C247.348 326.729 250.297 327.444 255.19 329.115C252.195 324.934 250.081 320.188 248.975 315.164Z"
          fill="#FD7064"
        />
        <Path
          d="M239.279 394.492C240.191 395.237 240.799 396.331 241.148 399.143C242.362 398.759 243.425 398.004 244.188 396.985C243.813 395.212 242.992 393.564 241.802 392.198C241.228 393.213 240.344 394.018 239.279 394.492Z"
          fill="#94CDDB"
        />
        <Path
          d="M29.8808 285.652C31.7621 287.384 34.0787 288.571 36.5826 289.087C37.6966 287.992 38.4042 286.55 38.5886 284.999C36.1116 284.511 33.8303 283.313 32.0236 281.549C32.0383 282.358 31.8497 283.157 31.4754 283.874C31.101 284.591 30.5528 285.202 29.8808 285.652Z"
          fill="#FBF6F3"
        />
        <Path
          d="M172.565 458.469C173.251 458.398 173.945 458.476 174.599 458.699C175.252 458.922 175.849 459.285 176.349 459.761C177.884 456.348 178.908 452.728 179.388 449.017C178.022 448.053 176.42 447.475 174.753 447.345C174.996 451.18 174.243 455.012 172.565 458.469Z"
          fill="#FFCE63"
        />
        <Path
          d="M155.924 335.345C157.444 333.4 157.58 331.424 157.626 328.202C150.59 328.385 143.067 326.455 134.557 323.43C134.44 325.814 133.525 328.089 131.958 329.889C139.467 333.395 147.638 335.255 155.924 335.345Z"
          fill="#94CDDB"
        />
        <Path
          d="M154.647 372.501C154.967 373.033 155.058 373.687 154.723 375.161C155.407 375.211 156.087 375.029 156.653 374.644C156.799 373.686 156.695 372.707 156.35 371.802C155.868 372.206 155.273 372.45 154.647 372.501Z"
          fill="#FFCE63"
        />
        <Path
          d="M295.872 305.574C294.353 309.768 294.657 312.823 297.225 316.987C301.89 317.595 305.34 317.397 308.501 315.65C308.805 310.619 310.431 307.398 313.729 302.155C307.164 304.449 303.045 305.665 295.872 305.574Z"
          fill="#FBF6F3"
        />
        <Path
          d="M113.737 340.27C114.944 340.042 116.065 339.484 116.974 338.659C116.86 337.924 116.502 337.249 115.956 336.744C115.062 337.558 113.946 338.087 112.75 338.264C113.072 338.486 113.331 338.787 113.504 339.138C113.677 339.489 113.757 339.879 113.737 340.27Z"
          fill="#A0C460"
        />
        <Path
          d="M283.229 289.497C283.905 289.746 284.649 289.746 285.326 289.497C284.853 287.283 284.791 285.001 285.143 282.765C284.469 282.889 283.773 282.782 283.168 282.461C282.689 284.784 282.709 287.182 283.229 289.497Z"
          fill="#A0C460"
        />
        <Path
          d="M300.933 449.46C299.64 446.541 297.582 444.026 294.976 442.181C293.149 442.882 291.616 444.184 290.629 445.874C293.232 447.651 295.251 450.157 296.435 453.077C297.711 450.904 298.76 449.825 300.933 449.46Z"
          fill="#FBF6F3"
        />
        <Path
          d="M301.374 394.657C301.254 394.865 301.19 395.101 301.19 395.341C301.19 395.581 301.254 395.817 301.374 396.025C301.812 396.177 302.288 396.177 302.726 396.025C302.856 395.45 303.146 394.923 303.562 394.505C302.849 394.697 302.106 394.749 301.374 394.657Z"
          fill="#FFCE63"
        />
        <Path
          d="M196.53 417.287C195.876 417.636 195.633 418.168 195.253 419.065C197.411 420.006 199.379 421.335 201.059 422.985C201.371 422.316 201.909 421.778 202.578 421.466C200.888 419.652 198.824 418.226 196.53 417.287Z"
          fill="#A0C460"
        />
        <Path
          d="M236.923 293.737C236.285 293.858 235.951 294.223 235.404 294.846C236.914 296.189 238.161 297.802 239.081 299.603C239.482 299.168 240.017 298.879 240.601 298.782C239.75 296.857 238.496 295.136 236.923 293.737Z"
          fill="#FFCE63"
        />
        <Path
          d="M227.805 340.83C227.658 341.487 227.274 342.065 226.726 342.456C227.682 342.926 228.709 343.235 229.766 343.368C230.031 342.792 230.166 342.164 230.161 341.529C229.334 341.471 228.53 341.233 227.805 340.83Z"
          fill="#FD7064"
        />
        <Path
          d="M106.367 335.042C106.436 334.918 106.529 334.81 106.641 334.723C106.754 334.637 106.883 334.575 107.02 334.54C106.598 333.894 106.087 333.311 105.501 332.808C105.181 332.933 104.903 333.143 104.695 333.416C105.389 333.797 105.966 334.359 106.367 335.042Z"
          fill="#FBF6F3"
        />
        <Path
          d="M20.7628 171.691C20.6268 172.524 20.7543 173.38 21.1275 174.137C21.7104 174.321 22.2595 174.598 22.7536 174.958C22.6776 174.365 22.9208 174.016 23.5894 173.438C22.5596 173.011 21.6052 172.421 20.7628 171.691Z"
          fill="#94CDDB"
        />
        <Path
          d="M14.0761 396.147C15.4022 396.684 16.4842 397.69 17.1155 398.974C18.4583 397.18 19.4861 395.17 20.1549 393.032C19.0623 392.259 17.8111 391.74 16.4925 391.512C16.0488 393.22 15.2225 394.805 14.0761 396.147Z"
          fill="#94CDDB"
        />
        <Path
          d="M65.5026 244.559C69.393 242.872 71.4901 242.249 75.0614 242.613C74.9045 242.006 74.8749 241.372 74.9743 240.752C75.0736 240.133 75.2999 239.54 75.6389 239.012C71.9927 238.417 68.253 238.843 64.834 240.243C64.6667 241.715 64.8976 243.206 65.5026 244.559Z"
          fill="#94CDDB"
        />
        <Path
          d="M345.961 315.574C347.84 313.642 349.158 311.237 349.776 308.614C348.655 307.391 347.147 306.591 345.505 306.35C344.93 308.949 343.603 311.321 341.691 313.173C342.547 313.182 343.387 313.407 344.134 313.826C344.88 314.246 345.509 314.847 345.961 315.574Z"
          fill="#94CDDB"
        />
        <Path
          d="M222.836 324.236C218.535 328.203 216.073 329.981 211.241 331.136C211.724 331.855 212.053 332.666 212.208 333.519C212.362 334.372 212.338 335.247 212.138 336.09C217.441 335.193 220.754 333.37 225.693 329.555C225.229 327.56 224.243 325.725 222.836 324.236Z"
          fill="#FD7064"
        />
        <Path
          d="M161.714 293.63C160.351 292.152 159.461 290.299 159.161 288.311C158.83 288.494 158.464 288.606 158.088 288.64C157.711 288.674 157.331 288.629 156.973 288.508C157.176 290.707 157.975 292.808 159.282 294.587C160.164 294.49 161.003 294.159 161.714 293.63Z"
          fill="#94CDDB"
        />
        <Path
          d="M274.414 372.258C273.975 371.935 273.439 371.769 272.894 371.787C272.939 372.316 272.822 372.846 272.56 373.307C272.952 373.616 273.401 373.843 273.882 373.976C273.956 373.376 274.136 372.795 274.414 372.258Z"
          fill="#94CDDB"
        />
        <Path
          d="M66.0951 356.501C65.5725 356.728 65.1066 357.068 64.7309 357.496C64.3552 357.924 64.0789 358.43 63.9219 358.978C65.2227 360.359 66.3551 361.889 67.2956 363.537C67.6696 363.038 68.1671 362.645 68.7393 362.397C67.5691 360.575 66.6779 358.587 66.0951 356.501Z"
          fill="#A0C460"
        />
        <Path
          d="M29.0449 239.756C29.395 239.361 29.8249 239.045 30.3063 238.829C29.4601 238.235 28.7027 237.524 28.0571 236.716C27.5446 236.793 27.0816 237.066 26.7654 237.476C27.4327 238.323 28.1979 239.089 29.0449 239.756Z"
          fill="#FD7064"
        />
        <Path
          d="M47.1442 385.57C45.412 386.243 43.5307 386.439 41.6969 386.137C39.8631 385.835 38.144 385.046 36.7192 383.852C36.005 389.065 36.7192 392.651 38.5884 399.049C41.7342 401.07 43.8921 401.07 47.9496 399.809C46.4452 394.353 45.7613 390.281 47.1442 385.57Z"
          fill="#FBF6F3"
        />
        <Path
          d="M198.126 441.252C198.926 440.294 199.462 439.143 199.678 437.914C199.894 436.684 199.783 435.419 199.357 434.246C197.249 433.073 194.81 432.639 192.427 433.015C191.348 435.948 189.798 437.574 186.91 440.082C190.69 439.713 194.504 440.111 198.126 441.252Z"
          fill="#A0C460"
        />
        <Path
          d="M96.8536 367.001C97.6217 368.089 98.6728 368.946 99.893 369.479C100.601 369.05 101.138 368.39 101.413 367.609C100.183 367.1 99.1271 366.245 98.3733 365.147C98.2963 365.559 98.1167 365.945 97.8511 366.269C97.5855 366.593 97.2424 366.845 96.8536 367.001Z"
          fill="#94CDDB"
        />
        <Path
          d="M1.5235 257.37C2.17537 257.347 2.81311 257.563 3.31674 257.978C3.5289 256.979 3.56999 255.951 3.4383 254.938C2.83174 254.836 2.21066 254.862 1.61468 255.014C1.75982 255.796 1.72867 256.601 1.5235 257.37Z"
          fill="#A0C460"
        />
        <Path
          d="M138.478 236.565C138.047 236.212 137.54 235.964 136.996 235.843C136.452 235.721 135.887 235.729 135.347 235.866C135.393 237.822 134.987 239.761 134.162 241.535C135.308 241.515 136.421 241.915 137.292 242.659C138.096 240.729 138.499 238.656 138.478 236.565Z"
          fill="#FFCE63"
        />
        <Path
          d="M44.6217 425.342C44.4896 425.185 44.3906 425.003 44.3305 424.807C44.2704 424.612 44.2506 424.406 44.2722 424.202C43.1748 424.423 42.1151 424.801 41.1264 425.326C41.1233 425.83 41.2601 426.324 41.5215 426.755C42.4181 426.028 43.485 425.542 44.6217 425.342Z"
          fill="#FD7064"
        />
        <Path
          d="M260.418 403.61C261.938 405.129 263.624 405.403 266.39 405.737C266.907 399.659 269.262 393.397 272.667 386.392C270.61 386.066 268.724 385.054 267.317 383.519C263.609 389.647 261.257 396.497 260.418 403.61Z"
          fill="#FBF6F3"
        />
        <Path
          d="M263.579 422.682C262.775 422.791 262.005 423.076 261.324 423.517C260.643 423.958 260.069 424.545 259.643 425.236C260.892 427.645 261.847 430.196 262.484 432.834C263.185 432.3 264.013 431.96 264.886 431.846C263.981 428.877 263.54 425.786 263.579 422.682Z"
          fill="#A0C460"
        />
        <Path
          d="M146.183 362.578C146.183 364.417 147.156 365.618 148.69 367.365C152.52 363.87 157.626 361.286 163.811 358.885C162.723 357.504 162.134 355.796 162.14 354.038C156.273 355.716 150.833 358.628 146.183 362.578Z"
          fill="#FBF6F3"
        />
        <Path
          d="M302.179 336.743C302.369 333.761 303.652 330.953 305.781 328.856C300.249 327.336 294.535 326.516 291.921 326.956C291.153 329.658 290.977 332.493 291.404 335.269C294.368 334.707 297.301 335.391 302.179 336.743Z"
          fill="#FFCE63"
        />
        <Path
          d="M337.8 333.203C337.636 332.661 337.674 332.078 337.907 331.562C337.017 331.614 336.143 331.82 335.323 332.17C335.365 332.705 335.526 333.225 335.794 333.689C336.421 333.387 337.105 333.221 337.8 333.203Z"
          fill="#A0C460"
        />
        <Path
          d="M341.129 360.512C345.338 363.84 349.062 366.089 353.499 366.728C355.546 364.686 356.828 362.004 357.131 359.129C352.558 358.291 348.331 356.13 344.974 352.914C344.594 356.622 343.819 358.719 341.129 360.512Z"
          fill="#A0C460"
        />
        <Path
          d="M287.94 389.811C288.804 389.56 289.587 389.088 290.211 388.439C290.835 387.791 291.278 386.991 291.496 386.118C290.708 384.568 289.424 383.327 287.848 382.592C286.054 383.825 283.945 384.52 281.77 384.598C284.156 385.903 286.254 387.676 287.94 389.811Z"
          fill="#A0C460"
        />
        <Path
          d="M37.3575 251.535C34.622 248.496 32.0234 247.599 27.6162 247.964C25.2151 251.474 23.969 254.316 24.0906 257.584C27.9962 259.878 29.9262 262.507 32.7832 267.31C33.6343 261.094 34.3333 257.264 37.3575 251.535Z"
          fill="#FFCE63"
        />
        <Path
          d="M226.727 327.824C227.701 327.537 228.551 326.933 229.143 326.107C228.25 325.559 227.557 324.739 227.167 323.767C226.242 323.977 225.372 324.381 224.614 324.952C225.496 325.765 226.213 326.74 226.727 327.824Z"
          fill="#FD7064"
        />
        <Path
          d="M190.679 315.466C191.6 316.201 192.304 317.171 192.719 318.273C193.134 319.375 193.243 320.569 193.035 321.728C196.074 320.466 197.852 318.916 200.831 315.892C200.952 313.521 200.269 312.351 198.308 310.497C195.725 313.111 193.704 314.783 190.679 315.466Z"
          fill="#FD7064"
        />
        <Path
          d="M179.525 413.443C179.735 413.323 179.969 413.25 180.21 413.229C180.452 413.208 180.695 413.239 180.923 413.322C180.95 412.012 180.781 410.706 180.421 409.447C179.846 409.313 179.244 409.35 178.689 409.553C179.303 410.754 179.592 412.096 179.525 413.443Z"
          fill="#A0C460"
        />
        <Path
          d="M135.849 297.534C136.023 296.897 135.991 296.222 135.758 295.604C135.329 295.42 134.93 295.174 134.572 294.875C134.572 295.331 134.39 295.574 133.858 295.939C134.605 296.357 135.278 296.896 135.849 297.534Z"
          fill="#FD7064"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_101_16710">
          <Rect
            width="1204.58"
            height="521.877"
            fill="white"
            transform="translate(791.291 472.877) rotate(-180)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
